import { jsx as o, jsxs as u, Fragment as $ } from "react/jsx-runtime";
import he, { forwardRef as Ot, createElement as St, useState as O, useRef as le, useEffect as Q, useMemo as de, useCallback as ge, useLayoutEffect as lr, createContext as sr, useContext as cr } from "react";
import Re from "react-dom";
import { useQueryClient as jt, useQuery as dr } from "@tanstack/react-query";
function us(e) {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}
function hs(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function ys(e) {
  const t = new Date(e), r = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), i = Math.floor(r / (1e3 * 60 * 60 * 24));
  return i === 0 ? "Today" : i === 1 ? "Yesterday" : i < 7 ? `${i} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function bs(e, t) {
  return t > 0 ? Math.round(e * 100 / t) : 0;
}
function fs(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function xs(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function Cs(e, t) {
  return e.length <= t ? e : e.slice(0, t - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pr = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), gr = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), Kt = (e) => {
  const t = gr(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Cn = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), mr = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var ur = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hr = Ot(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: l,
    iconNode: c,
    ...p
  }, d) => St(
    "svg",
    {
      ref: d,
      ...ur,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Cn("lucide", i),
      ...!l && !mr(p) && { "aria-hidden": "true" },
      ...p
    },
    [
      ...c.map(([h, m]) => St(h, m)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const se = (e, t) => {
  const n = Ot(
    ({ className: r, ...i }, l) => St(hr, {
      ref: l,
      iconNode: t,
      className: Cn(
        `lucide-${pr(Kt(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = Kt(e), n;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yr = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ke = se("check", yr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], fr = se("chevron-down", br);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xr = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], dt = se("chevron-right", xr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], kr = se("circle-check-big", Cr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], wr = se("circle-x", vr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Br = se("ellipsis-vertical", Sr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Pr = se("eye", Ir);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], Gt = se("info", zr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fr = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Tr = se("loader", Fr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], bt = se("log-out", Mr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Ar = se("maximize-2", Er);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hr = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], Nr = se("message-circle-plus", Hr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lr = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], Rr = se("minimize-2", Lr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wr = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], kn = se("monitor", Wr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dr = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], eo = se("palette", Dr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], vn = se("pencil", Or);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], $t = se("plus", jr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gr = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], wn = se("rotate-ccw", Gr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $r = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], pt = se("search", $r);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Bt = se("settings", Yr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qr = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Sn = se("smartphone", Qr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xr = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], Bn = se("upload", Xr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jr = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], We = se("x", Jr), s = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, In = () => typeof window > "u" ? !1 : window.self !== window.top, gt = () => {
  var e, t;
  return typeof window > "u" ? document.body : window.self !== window.top && ((t = (e = window.parent) == null ? void 0 : e.document) != null && t.body) ? window.parent.document.body : document.body;
}, It = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, Zr = async () => {
  if (typeof window > "u") return !0;
  try {
    const t = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(t != null && t.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, Ur = () => {
  const [e, t] = O({ x: 0, y: 0 }), [n, r] = O(!1), i = le({ x: 0, y: 0 }), l = (c) => {
    r(!0), i.current = {
      x: c.clientX - e.x,
      y: c.clientY - e.y
    };
  };
  return Q(() => {
    const c = (d) => {
      n && t({
        x: d.clientX - i.current.x,
        y: d.clientY - i.current.y
      });
    }, p = () => {
      r(!1);
    };
    if (n) {
      const d = It();
      return d.addEventListener("mousemove", c), d.addEventListener("mouseup", p), () => {
        d.removeEventListener("mousemove", c), d.removeEventListener("mouseup", p);
      };
    }
  }, [n]), { dragOffset: e, isDragging: n, handleMouseDown: l };
};
function to(e, t) {
  if (!e) return !0;
  if (typeof e == "string")
    return !!t[e];
  const { field: n, value: r, operator: i } = e, l = t[n];
  return i === "includes" && r !== void 0 ? typeof l == "string" && l.includes(r) : i === "not_equals" && r !== void 0 ? l !== r : i === "equals" || r !== void 0 ? l === r : !!l;
}
const _r = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  h6: "H6",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell",
  carousel: "Carousel",
  "Card Container": "Card Container",
  title: "Title",
  price: "Price",
  "Retailer Icons": "Retailer Icons",
  image: "Image"
};
function Pn(e) {
  return _r[e] || e;
}
function Vr(e, t) {
  const [n, r] = O("desktop"), [i, l] = O(""), [c, p] = O(null), [d, h] = O(
    /* @__PURE__ */ new Set()
  ), m = de(
    () => e.some((I) => I.responsive),
    [e]
  ), b = de(() => n === "mobile" && m ? e.filter((I) => I.responsive).map(
    (I) => ({
      ...I,
      key: `mobile_${I.key}`,
      label: I.label
    })
  ).filter((I) => to(I.condition, t)) : e.filter((I) => !I.key.startsWith("mobile_")).filter((I) => to(I.condition, t)), [e, n, m, t]), B = de(() => {
    const I = [], v = {};
    return b.forEach((k) => {
      if (k.group)
        v[k.group] || (v[k.group] = []), v[k.group].push(k);
      else {
        const M = k.key.match(/^elementStyles\.([^.]+)\./);
        if (M) {
          const H = M[1];
          v[H] || (v[H] = []), v[H].push(k);
        } else
          I.push(k);
      }
    }), { baseFields: I, groups: v };
  }, [b]), z = de(() => {
    const I = [];
    return I.push({
      name: "All",
      key: "__all__",
      count: b.length
    }), B.baseFields.length > 0 && I.push({
      name: "General",
      key: "__general__",
      count: B.baseFields.length
    }), Object.entries(B.groups).forEach(([v, k]) => {
      I.push({
        name: Pn(v),
        key: v,
        count: k.length
      });
    }), I;
  }, [b, B]), C = z.length > 3, x = C || b.length >= 8, f = ge(
    (I, v) => v ? I.label.toLowerCase().includes(v) || (I.group ? I.group.toLowerCase().includes(v) : !1) || I.key.toLowerCase().includes(v) : !0,
    []
  ), S = de(() => {
    const I = i.toLowerCase().trim();
    let v = B.baseFields, k = { ...B.groups };
    if (I) {
      v = v.filter((H) => f(H, I));
      const M = {};
      Object.entries(k).forEach(([H, P]) => {
        const W = P.filter((w) => f(w, I));
        W.length > 0 && (M[H] = W);
      }), k = M;
    }
    return c && c !== "__all__" && (c === "__general__" ? k = {} : (v = [], k = k[c] ? { [c]: k[c] } : {})), { baseFields: v, groups: k };
  }, [B, i, c, f]), F = de(() => {
    const I = i.toLowerCase().trim();
    if (!I) return null;
    const v = {};
    return v.__general__ = B.baseFields.filter(
      (k) => f(k, I)
    ).length, Object.entries(B.groups).forEach(([k, M]) => {
      v[k] = M.filter((H) => f(H, I)).length;
    }), v.__all__ = Object.values(v).reduce((k, M) => k + M, 0), v;
  }, [i, B, f]), g = S.baseFields.length + Object.values(S.groups).reduce(
    (I, v) => I + v.length,
    0
  ), N = !c || c === "__all__", y = ge((I) => {
    h((v) => {
      const k = new Set(v);
      return k.has(I) ? k.delete(I) : k.add(I), k;
    });
  }, []);
  return {
    activeTab: n,
    setActiveTab: r,
    hasResponsiveFields: m,
    searchQuery: i,
    setSearchQuery: l,
    activeCategory: c,
    setActiveCategory: p,
    categoryList: z,
    hasSidebar: C,
    hasSearchBar: x,
    displayedGroupedFields: S,
    totalDisplayedFields: g,
    isShowingAllCategories: N,
    searchMatchCounts: F,
    collapsedGroups: d,
    toggleGroupCollapse: y
  };
}
function qr(e) {
  return `
    @keyframes edit-panel-slideIn {
      from {
        opacity: 0;
        transform: translateY(-8px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    .edit-panel-close {
      transition: all 0.15s ease;
    }

    .edit-panel-close:hover {
      background-color: ${s.overlay_light};
      color: ${s.primary};
      transform: scale(1.1);
    }

    .edit-panel-input:focus,
    .edit-panel-select:focus {
      border-color: ${s.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
    }

    .edit-panel-input:hover:not(:focus),
    .edit-panel-select:hover:not(:focus) {
      border-color: ${s.gray_border};
    }

    .edit-panel-color-text:focus {
      border-color: ${s.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
      background: ${s.white};
    }

    .edit-panel-color-swatch:hover {
      border-color: ${s.gray_border};
      transform: scale(1.05);
    }

    .edit-panel-reset-field:hover {
      opacity: 1 !important;
      color: ${s.blue} !important;
    }

    .drag-handle {
      cursor: ${e ? "grabbing" : "grab"};
      transition: background-color 0.15s ease;
    }

    .drag-handle:hover {
      background-color: ${s.overlay_light};
    }

    .edit-panel-save-button {
      background: linear-gradient(135deg, ${s.blue} 0%, ${s.blue_dark} 100%);
      color: ${s.white};
      border: none;
      padding: 10px 18px;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.15s ease;
      box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
      letter-spacing: 0.3px;
    }

    .edit-panel-save-button:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
    }

    .edit-panel-save-button:active:not(:disabled) {
      transform: translateY(0);
    }

    .edit-panel-save-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    /* Custom scrollbar for fields area */
    .edit-panel-content::-webkit-scrollbar {
      width: 6px;
    }

    .edit-panel-content::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-content::-webkit-scrollbar-thumb {
      background: ${s.gray_border};
      border-radius: 3px;
    }

    .edit-panel-content::-webkit-scrollbar-thumb:hover {
      background: ${s.gray_medium};
    }

    /* Custom scrollbar for sidebar */
    .edit-panel-sidebar::-webkit-scrollbar {
      width: 4px;
    }

    .edit-panel-sidebar::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-sidebar::-webkit-scrollbar-thumb {
      background: ${s.gray_border};
      border-radius: 2px;
    }

    .edit-panel-sidebar-item {
      transition: all 0.12s ease;
    }

    .edit-panel-sidebar-item:hover {
      background-color: rgba(85, 114, 183, 0.08) !important;
    }

    .edit-panel-search:focus {
      border-color: ${s.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.08);
    }

    .edit-panel-group-header {
      cursor: pointer;
      transition: color 0.12s ease;
      user-select: none;
    }

    .edit-panel-group-header:hover {
      color: ${s.blue} !important;
    }

    /* Reset client-site global CSS that applies min-width to buttons */
    .edit-panel-root button {
      min-width: 0;
    }
  `;
}
const Kr = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, ei = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, ti = (e, t, n) => {
  switch (e) {
    case "primary":
      return {
        background: n ? s.blue_dark : t ? `linear-gradient(135deg, ${s.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${s.blue_dark} 0%, #1f2463 100%)`,
        color: s.white,
        border: "none",
        boxShadow: t ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: n ? s.gray_border : s.gray_light,
        color: s.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: n ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : t ? `linear-gradient(135deg, ${s.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${s.red} 0%, #e63e37 100%)`,
        color: s.white,
        border: "none",
        boxShadow: t ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: n ? "rgba(0, 0, 0, 0.08)" : t ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: s.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: n ? s.blue_light : t ? "rgba(24, 29, 86, 0.04)" : s.white,
        color: s.blue_dark,
        border: `2px solid ${s.blue_dark}`,
        boxShadow: "none",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: n ? "rgba(0, 0, 0, 0.1)" : t ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: s.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, oe = Ot(
  ({
    variant: e = "primary",
    size: t = "md",
    leftIcon: n,
    rightIcon: r,
    isLoading: i = !1,
    pill: l = !1,
    disabled: c,
    children: p,
    style: d,
    ...h
  }, m) => {
    const [b, B] = O(!1), [z, C] = O(!1), x = c || i, f = e === "icon" ? ei[t] : Kr[t], S = l ? "200px" : f.borderRadius, F = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: x ? "not-allowed" : "pointer",
      opacity: x ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...f,
      borderRadius: S,
      ...ti(
        e,
        !x && b,
        !x && z
      ),
      ...d
    };
    return /* @__PURE__ */ o(
      "button",
      {
        ref: m,
        disabled: x,
        style: F,
        onMouseEnter: () => B(!0),
        onMouseLeave: () => {
          B(!1), C(!1);
        },
        onMouseDown: () => C(!0),
        onMouseUp: () => C(!1),
        ...h,
        children: i ? /* @__PURE__ */ o(oi, { size: t }) : /* @__PURE__ */ u($, { children: [
          n && /* @__PURE__ */ o(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          ),
          p,
          r && /* @__PURE__ */ o(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: r
            }
          )
        ] })
      }
    );
  }
);
oe.displayName = "Button";
const oi = ({ size: e }) => {
  const t = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ u(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ o("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ o(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, et = ({
  title: e,
  message: t,
  confirmLabel: n = "Save",
  cancelLabel: r = "Discard",
  dismissLabel: i = "Cancel",
  onConfirm: l,
  onCancel: c,
  onDismiss: p,
  isLoading: d = !1
}) => {
  const h = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${s.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${s.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${s.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .confirm-dialog-actions-right {
          display: flex;
          gap: 12px;
        }

        /* Reset client-site global CSS that applies min-width to buttons */
        .confirm-dialog-container button {
          min-width: 0;
        }
      ` }),
    /* @__PURE__ */ o("div", { className: "confirm-dialog-overlay", onClick: c, children: /* @__PURE__ */ u(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (m) => m.stopPropagation(),
        children: [
          /* @__PURE__ */ o("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ o("p", { className: "confirm-dialog-message", children: t }),
          /* @__PURE__ */ u("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ o("div", { children: p && /* @__PURE__ */ o(
              oe,
              {
                variant: "ghost",
                size: "sm",
                onClick: p,
                disabled: d,
                children: i
              }
            ) }),
            /* @__PURE__ */ u("div", { className: "confirm-dialog-actions-right", children: [
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: c,
                  disabled: d,
                  children: r
                }
              ),
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "primary",
                  size: "sm",
                  onClick: l,
                  isLoading: d,
                  disabled: d,
                  children: n
                }
              )
            ] })
          ] })
        ]
      }
    ) })
  ] });
  return Re.createPortal(h, gt());
}, ni = ({
  displayName: e,
  isDirty: t,
  isSaving: n,
  onReset: r,
  onSave: i,
  onClose: l,
  handleMouseDown: c
}) => /* @__PURE__ */ u(
  "div",
  {
    className: "drag-handle",
    onMouseDown: c,
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${s.border_glass}`,
      borderRadius: "20px 20px 0 0",
      userSelect: "none"
    },
    children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flex: 1
          },
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "3px",
                  opacity: 0.3
                },
                children: [...Array(6)].map((p, d) => /* @__PURE__ */ o(
                  "div",
                  {
                    style: {
                      width: "4px",
                      height: "4px",
                      background: s.gray_medium,
                      borderRadius: "1px"
                    }
                  },
                  d
                ))
              }
            ),
            /* @__PURE__ */ o(
              "h3",
              {
                style: {
                  fontSize: "13px",
                  fontWeight: 600,
                  color: s.primary,
                  margin: 0,
                  letterSpacing: "0.2px"
                },
                children: e || "Edit Properties"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ u("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
        t && r && /* @__PURE__ */ o(
          oe,
          {
            variant: "ghost",
            size: "sm",
            onClick: r,
            disabled: n,
            "aria-label": "Reset changes",
            leftIcon: /* @__PURE__ */ o(wn, { size: 14 }),
            children: "Reset"
          }
        ),
        t && i && /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            size: "sm",
            onClick: i,
            disabled: n,
            isLoading: n,
            "aria-label": "Save changes",
            type: "submit",
            children: "Save"
          }
        ),
        /* @__PURE__ */ o(oe, { variant: "icon", size: "md", onClick: l, "aria-label": "Close", children: /* @__PURE__ */ o(We, { size: 18 }) })
      ] })
    ]
  }
), ri = ({
  searchQuery: e,
  setSearchQuery: t,
  searchInputRef: n
}) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      padding: "12px 20px",
      borderBottom: `1px solid ${s.border_glass}`
    },
    children: /* @__PURE__ */ u("div", { style: { position: "relative" }, children: [
      /* @__PURE__ */ o(
        pt,
        {
          size: 14,
          style: {
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: s.gray_medium,
            pointerEvents: "none"
          }
        }
      ),
      /* @__PURE__ */ o(
        "input",
        {
          ref: n,
          type: "text",
          value: e,
          onChange: (r) => t(r.target.value),
          onKeyDown: (r) => {
            var i;
            r.key === "Escape" && (t(""), (i = n.current) == null || i.blur());
          },
          placeholder: "Search properties...",
          className: "edit-panel-search",
          style: {
            width: "100%",
            padding: "8px 30px 8px 32px",
            fontSize: "12px",
            border: `1px solid ${s.border_glass}`,
            borderRadius: "10px",
            background: s.bg_light,
            color: s.primary,
            outline: "none",
            transition: "border-color 0.15s, box-shadow 0.15s",
            fontFamily: "inherit",
            boxSizing: "border-box"
          }
        }
      ),
      e && /* @__PURE__ */ o(
        "button",
        {
          onClick: () => {
            var r;
            t(""), (r = n.current) == null || r.focus();
          },
          style: {
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "inline-flex",
            alignItems: "center",
            color: s.gray_medium
          },
          children: /* @__PURE__ */ o(We, { size: 12 })
        }
      )
    ] })
  }
), ii = ({
  activeTab: e,
  setActiveTab: t
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      gap: "0",
      padding: "0 20px",
      borderBottom: `1px solid ${s.border_glass}`
    },
    children: [
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => t("desktop"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "desktop" ? `2px solid ${s.blue}` : "2px solid transparent",
            color: e === "desktop" ? s.blue : s.gray_medium,
            fontSize: "12px",
            fontWeight: e === "desktop" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ o(kn, { size: 14 }),
            "Desktop"
          ]
        }
      ),
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => t("mobile"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "mobile" ? `2px solid ${s.blue}` : "2px solid transparent",
            color: e === "mobile" ? s.blue : s.gray_medium,
            fontSize: "12px",
            fontWeight: e === "mobile" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ o(Sn, { size: 14 }),
            "Mobile"
          ]
        }
      )
    ]
  }
), ai = ({
  categoryList: e,
  activeCategory: t,
  setActiveCategory: n,
  searchMatchCounts: r
}) => /* @__PURE__ */ o(
  "div",
  {
    className: "edit-panel-sidebar",
    style: {
      width: "160px",
      minWidth: "160px",
      borderRight: `1px solid ${s.border_glass}`,
      overflowY: "auto",
      padding: "8px 0"
    },
    children: e.map((i) => {
      const l = t === i.key || !t && i.key === "__all__", c = r ? r[i.key] ?? 0 : i.count, p = r !== null && c === 0;
      return /* @__PURE__ */ u(
        "button",
        {
          className: "edit-panel-sidebar-item",
          onClick: () => n(
            l && i.key !== "__all__" ? null : i.key
          ),
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "7px 16px 7px 20px",
            background: l ? "rgba(85, 114, 183, 0.1)" : "none",
            border: "none",
            borderLeft: l ? `3px solid ${s.blue}` : "3px solid transparent",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: l ? 600 : 500,
            color: l ? s.blue : s.gray_medium,
            textAlign: "left",
            opacity: p ? 0.35 : 1,
            fontFamily: "inherit"
          },
          children: [
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                children: i.name
              }
            ),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: "10px",
                  fontWeight: 500,
                  color: l ? s.blue : s.gray_border,
                  marginLeft: "6px",
                  flexShrink: 0
                },
                children: r ? c : i.count
              }
            )
          ]
        },
        i.key
      );
    })
  }
), li = ({ value: e, onChange: t }) => {
  const [n, r] = O(e || "");
  return Q(() => {
    r(e || "");
  }, [e]), /* @__PURE__ */ o(
    "input",
    {
      type: "text",
      value: n,
      onChange: (l) => {
        const c = l.target.value;
        r(c), t(c);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${s.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: s.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: s.white,
        outline: "none"
      }
    }
  );
}, si = ({
  value: e,
  onChange: t,
  field: n
}) => {
  var r, i;
  return /* @__PURE__ */ o(
    "select",
    {
      value: e ?? ((i = (r = n.options) == null ? void 0 : r[0]) == null ? void 0 : i.value) ?? "",
      onChange: (l) => t(l.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${s.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: s.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: s.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (n.options ?? []).map((l) => /* @__PURE__ */ o("option", { value: l.value, children: l.label }, l.value))
    }
  );
};
function mt() {
  return (mt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function zn(e, t) {
  if (e == null) return {};
  var n, r, i = {}, l = Object.keys(e);
  for (r = 0; r < l.length; r++) t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
  return i;
}
function Pt(e) {
  var t = le(e), n = le(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var tt = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, qe = function(e) {
  return "touches" in e;
}, zt = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, oo = function(e, t, n) {
  var r = e.getBoundingClientRect(), i = qe(t) ? function(l, c) {
    for (var p = 0; p < l.length; p++) if (l[p].identifier === c) return l[p];
    return l[0];
  }(t.touches, n) : t;
  return { left: tt((i.pageX - (r.left + zt(e).pageXOffset)) / r.width), top: tt((i.pageY - (r.top + zt(e).pageYOffset)) / r.height) };
}, no = function(e) {
  !qe(e) && e.preventDefault();
}, Fn = he.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = zn(e, ["onMove", "onKey"]), i = le(null), l = Pt(t), c = Pt(n), p = le(null), d = le(!1), h = de(function() {
    var z = function(f) {
      no(f), (qe(f) ? f.touches.length > 0 : f.buttons > 0) && i.current ? l(oo(i.current, f, p.current)) : x(!1);
    }, C = function() {
      return x(!1);
    };
    function x(f) {
      var S = d.current, F = zt(i.current), g = f ? F.addEventListener : F.removeEventListener;
      g(S ? "touchmove" : "mousemove", z), g(S ? "touchend" : "mouseup", C);
    }
    return [function(f) {
      var S = f.nativeEvent, F = i.current;
      if (F && (no(S), !function(N, y) {
        return y && !qe(N);
      }(S, d.current) && F)) {
        if (qe(S)) {
          d.current = !0;
          var g = S.changedTouches || [];
          g.length && (p.current = g[0].identifier);
        }
        F.focus(), l(oo(F, S, p.current)), x(!0);
      }
    }, function(f) {
      var S = f.which || f.keyCode;
      S < 37 || S > 40 || (f.preventDefault(), c({ left: S === 39 ? 0.05 : S === 37 ? -0.05 : 0, top: S === 40 ? 0.05 : S === 38 ? -0.05 : 0 }));
    }, x];
  }, [c, l]), m = h[0], b = h[1], B = h[2];
  return Q(function() {
    return B;
  }, [B]), he.createElement("div", mt({}, r, { onTouchStart: m, onMouseDown: m, className: "react-colorful__interactive", ref: i, onKeyDown: b, tabIndex: 0, role: "slider" }));
}), Yt = function(e) {
  return e.filter(Boolean).join(" ");
}, Tn = function(e) {
  var t = e.color, n = e.left, r = e.top, i = r === void 0 ? 0.5 : r, l = Yt(["react-colorful__pointer", e.className]);
  return he.createElement("div", { className: l, style: { top: 100 * i + "%", left: 100 * n + "%" } }, he.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, ye = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, ci = function(e) {
  return ui(Ft(e));
}, Ft = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? ye(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? ye(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, di = function(e) {
  return mi(gi(e));
}, pi = function(e) {
  var t = e.s, n = e.v, r = e.a, i = (200 - t) * n / 100;
  return { h: ye(e.h), s: ye(i > 0 && i < 200 ? t * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: ye(i / 2), a: ye(r, 2) };
}, Tt = function(e) {
  var t = pi(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, gi = function(e) {
  var t = e.h, n = e.s, r = e.v, i = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var l = Math.floor(t), c = r * (1 - n), p = r * (1 - (t - l) * n), d = r * (1 - (1 - t + l) * n), h = l % 6;
  return { r: ye(255 * [r, p, c, c, d, r][h]), g: ye(255 * [d, r, r, p, c, c][h]), b: ye(255 * [c, c, d, r, r, p][h]), a: ye(i, 2) };
}, nt = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, mi = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, l = i < 1 ? nt(ye(255 * i)) : "";
  return "#" + nt(t) + nt(n) + nt(r) + l;
}, ui = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, l = Math.max(t, n, r), c = l - Math.min(t, n, r), p = c ? l === t ? (n - r) / c : l === n ? 2 + (r - t) / c : 4 + (t - n) / c : 0;
  return { h: ye(60 * (p < 0 ? p + 6 : p)), s: ye(l ? c / l * 100 : 0), v: ye(l / 255 * 100), a: i };
}, hi = he.memo(function(e) {
  var t = e.hue, n = e.onChange, r = Yt(["react-colorful__hue", e.className]);
  return he.createElement("div", { className: r }, he.createElement(Fn, { onMove: function(i) {
    n({ h: 360 * i.left });
  }, onKey: function(i) {
    n({ h: tt(t + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": ye(t), "aria-valuemax": "360", "aria-valuemin": "0" }, he.createElement(Tn, { className: "react-colorful__hue-pointer", left: t / 360, color: Tt({ h: t, s: 100, v: 100, a: 1 }) })));
}), yi = he.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: Tt({ h: t.h, s: 100, v: 100, a: 1 }) };
  return he.createElement("div", { className: "react-colorful__saturation", style: r }, he.createElement(Fn, { onMove: function(i) {
    n({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    n({ s: tt(t.s + 100 * i.left, 0, 100), v: tt(t.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + ye(t.s) + "%, Brightness " + ye(t.v) + "%" }, he.createElement(Tn, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Tt(t) })));
}), Mn = function(e, t) {
  if (e === t) return !0;
  for (var n in e) if (e[n] !== t[n]) return !1;
  return !0;
}, bi = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || Mn(Ft(e), Ft(t));
};
function fi(e, t, n) {
  var r = Pt(n), i = O(function() {
    return e.toHsva(t);
  }), l = i[0], c = i[1], p = le({ color: t, hsva: l });
  Q(function() {
    if (!e.equal(t, p.current.color)) {
      var h = e.toHsva(t);
      p.current = { hsva: h, color: t }, c(h);
    }
  }, [t, e]), Q(function() {
    var h;
    Mn(l, p.current.hsva) || e.equal(h = e.fromHsva(l), p.current.color) || (p.current = { hsva: l, color: h }, r(h));
  }, [l, e, r]);
  var d = ge(function(h) {
    c(function(m) {
      return Object.assign({}, m, h);
    });
  }, []);
  return [l, d];
}
var xi = typeof window < "u" ? lr : Q, Ci = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, ro = /* @__PURE__ */ new Map(), ki = function(e) {
  xi(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !ro.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, ro.set(t, n);
      var r = Ci();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, vi = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, i = r === void 0 ? n.defaultColor : r, l = e.onChange, c = zn(e, ["className", "colorModel", "color", "onChange"]), p = le(null);
  ki(p);
  var d = fi(n, i, l), h = d[0], m = d[1], b = Yt(["react-colorful", t]);
  return he.createElement("div", mt({}, c, { ref: p, className: b }), he.createElement(yi, { hsva: h, onChange: m }), he.createElement(hi, { hue: h.h, onChange: m, className: "react-colorful__last-control" }));
}, wi = { defaultColor: "000", toHsva: ci, fromHsva: function(e) {
  return di({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: bi }, Si = function(e) {
  return he.createElement(vi, mt({}, e, { colorModel: wi }));
};
const io = (e) => {
  const t = e.startsWith("#") ? e : `#${e}`, n = t.slice(0, 7).padEnd(7, "0"), r = t.slice(7, 9) || "ff", i = parseInt(r, 16), l = Math.round(i / 255 * 100);
  return { hex: n, opacity: l };
}, Oe = (e, t) => {
  const n = Math.round(t / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${n}`;
}, ao = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, En = ({
  value: e,
  onChange: t,
  className: n
}) => {
  const { hex: r, opacity: i } = io(
    e || "#000000ff"
  ), [l, c] = O(r), [p, d] = O(i), [h, m] = O(
    i < 100 ? e || "#000000ff" : r
  );
  Q(() => {
    const { hex: x, opacity: f } = io(
      e || "#000000ff"
    );
    c(x), d(f), m(f < 100 ? e || "#000000ff" : x);
  }, [e]);
  const b = (x) => {
    c(x), m(p < 100 ? Oe(x, p) : x), t(Oe(x, p));
  }, B = (x) => {
    const f = x.target.value;
    m(f);
    const S = ao(f);
    if (S)
      if (S.length === 9) {
        const F = S.slice(0, 7), g = S.slice(7, 9), N = parseInt(g, 16), y = Math.round(N / 255 * 100);
        c(F), d(y), t(S);
      } else
        c(S), t(Oe(S, p));
  }, z = () => {
    const x = ao(h);
    if (x)
      if (x.length === 9)
        m(x);
      else {
        const f = Oe(x, p);
        m(p < 100 ? f : x);
      }
    else {
      const f = Oe(l, p);
      m(p < 100 ? f : l);
    }
  }, C = (x) => {
    const f = parseInt(x.target.value, 10);
    d(f);
    const S = Oe(l, f);
    t(S), m(f < 100 ? S : l);
  };
  return /* @__PURE__ */ u("div", { className: `bc-color-picker ${n || ""}`, children: [
    /* @__PURE__ */ o("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${s.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${s.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${s.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${s.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${s.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${l} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${s.white};
          border: 2px solid ${s.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${s.white};
          border: 2px solid ${s.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${s.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ o(Si, { color: l, onChange: b }),
    /* @__PURE__ */ o(
      "input",
      {
        type: "text",
        value: h,
        onChange: B,
        onBlur: z,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ u("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ o(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: p,
          onChange: C,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${l} 100%)`
          }
        }
      ),
      /* @__PURE__ */ o("span", { className: "bc-color-picker-opacity-value", children: p })
    ] })
  ] });
}, Bi = "data:image/png;base64,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", Mt = ({
  color: e,
  size: t = 32,
  borderRadius: n = 4,
  className: r,
  style: i
}) => /* @__PURE__ */ u(
  "div",
  {
    className: r,
    style: {
      position: "relative",
      width: t,
      height: t,
      borderRadius: n,
      overflow: "hidden",
      ...i
    },
    children: [
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Bi})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), Ii = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), a = (e) => ({
  type: "theme",
  value: e
}), K = (e) => ({
  type: "custom",
  value: e
}), je = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, lo = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, Pi = ({
  value: e,
  onChange: t,
  field: n,
  themeColors: r,
  openColorPicker: i,
  setOpenColorPicker: l
}) => {
  const p = Ii(e) && e.type === "theme" ? e.value : "", d = de(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return je(e);
    if (e.type === "custom")
      return je(e.value);
    if (e.type === "theme") {
      const k = r[e.value];
      return k ? je(k) : "#000000ff";
    }
    return "#000000ff";
  }, [e, r]), h = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), m = (k) => {
    if (k === "") {
      const M = h();
      t({ type: "custom", value: M });
    } else
      t({ type: "theme", value: k });
  }, b = (k) => {
    t({ type: "custom", value: k });
  }, B = i === n.key, z = d, C = le(null), x = le(null), [f, S] = he.useState(!1), F = (k) => {
    const M = je(k);
    return M.length === 9 && M.slice(7, 9).toLowerCase() === "ff" ? M.slice(0, 7) : M;
  }, [g, N] = O(() => F(z));
  Q(() => {
    N(F(d));
  }, [d]);
  const y = (k) => {
    const M = k.target.value;
    N(M);
    const H = lo(M);
    if (H) {
      const P = je(H);
      b(P);
    }
  }, I = () => {
    const k = lo(g);
    if (!k)
      N(F(z));
    else {
      const M = je(k);
      N(F(M));
    }
  }, v = 300;
  return Q(() => {
    if (B && x.current) {
      const k = x.current.getBoundingClientRect(), H = window.innerHeight - k.bottom, P = k.top;
      S(H < v && P > H);
    }
  }, [B]), Q(() => {
    if (!B) return;
    const k = (M) => {
      C.current && !C.current.contains(M.target) && l(null);
    };
    return document.addEventListener("mousedown", k, !0), () => {
      document.removeEventListener("mousedown", k, !0);
    };
  }, [B, l]), /* @__PURE__ */ u(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ u(
          "select",
          {
            value: p,
            onChange: (k) => m(k.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${s.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: s.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: s.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ o("option", { value: "", children: "Custom" }),
              Object.keys(r).map((k) => /* @__PURE__ */ o("option", { value: k, children: k }, k))
            ]
          }
        ),
        /* @__PURE__ */ u("div", { ref: C, style: { position: "relative" }, children: [
          /* @__PURE__ */ o(
            "button",
            {
              ref: x,
              type: "button",
              onClick: () => l(B ? null : n.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${s.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: s.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ o(
                Mt,
                {
                  color: z,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          B && /* @__PURE__ */ o(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...f ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: s.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${s.shadow_medium}, 0 0 0 1px ${s.border_glass}`
              },
              onClick: (k) => k.stopPropagation(),
              children: /* @__PURE__ */ o(
                En,
                {
                  value: z,
                  onChange: b
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            value: g,
            onChange: y,
            onBlur: I,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${s.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: s.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: s.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (k) => k.target.select()
          }
        )
      ]
    }
  );
}, zi = ({
  value: e,
  onChange: t,
  field: n
}) => /* @__PURE__ */ o(
  "input",
  {
    type: "number",
    value: e || 0,
    min: n.min,
    max: n.max,
    step: n.step || 1,
    onChange: (r) => t(parseFloat(r.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${s.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: s.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: s.white,
      outline: "none"
    }
  }
), Fi = ({ value: e, onChange: t }) => {
  const n = !!e;
  return /* @__PURE__ */ o(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": n,
      onClick: () => t(!n),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: n ? s.blue : s.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: n ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ o(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: s.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, Ti = ({
  value: e,
  onChange: t,
  themeFonts: n
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "inherit",
    onChange: (r) => t(r.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${s.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: s.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: s.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ o("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(n).map(([r, i]) => /* @__PURE__ */ o("option", { value: r, children: i.name }, r))
    ]
  }
), Et = "bc-widget-panel-opened", At = "bc-widget-upload-icon-request", An = (e) => {
  const t = new CustomEvent(Et, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(t);
}, Hn = (e) => {
  const t = (n) => {
    e(n.detail.widgetId);
  };
  return document.addEventListener(Et, t), () => {
    document.removeEventListener(Et, t);
  };
}, Mi = () => {
  const e = new CustomEvent(At, { bubbles: !0 });
  document.dispatchEvent(e);
}, Ei = (e) => {
  const t = () => {
    e();
  };
  return document.addEventListener(At, t), () => {
    document.removeEventListener(At, t);
  };
}, so = "__upload_new__", Ai = ({
  value: e,
  onChange: t,
  themeIcons: n
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "default",
    onChange: (i) => {
      const l = i.target.value;
      if (l === so) {
        Mi();
        return;
      }
      t(l);
    },
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${s.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: s.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: s.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ o("option", { value: "default", children: "Default" }),
      Object.entries(n).map(([i, l]) => /* @__PURE__ */ o("option", { value: i, children: l.name }, i)),
      /* @__PURE__ */ o("option", { value: so, children: "Upload new..." })
    ]
  }
);
function Hi(e, t) {
  const n = t.values[e.key];
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ o(
        li,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "options":
      return /* @__PURE__ */ o(
        si,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "color":
      return /* @__PURE__ */ o(
        Pi,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeColors: t.themeColors,
          openColorPicker: t.openColorPicker,
          setOpenColorPicker: t.setOpenColorPicker
        }
      );
    case "number":
      return /* @__PURE__ */ o(
        zi,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "toggle":
      return /* @__PURE__ */ o(
        Fi,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "font":
      return /* @__PURE__ */ o(
        Ti,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeFonts: t.themeFonts
        }
      );
    case "icon":
      return /* @__PURE__ */ o(
        Ai,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeIcons: t.themeIcons
        }
      );
    default:
      return null;
  }
}
const Ni = (e) => {
  const { field: t, savedKeys: n, studioLockedKeys: r, onResetField: i } = e, l = n == null ? void 0 : n.has(t.key), c = r == null ? void 0 : r.has(t.key);
  return /* @__PURE__ */ u(
    "div",
    {
      style: {
        minWidth: 0,
        opacity: c ? 0.5 : 1,
        pointerEvents: c ? "none" : void 0
      },
      children: [
        /* @__PURE__ */ u(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: 600,
              color: s.gray_medium,
              marginBottom: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            },
            children: [
              t.label,
              c && /* @__PURE__ */ o(
                "span",
                {
                  title: "Edit this property from Concierge Studio",
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    color: s.blue,
                    marginLeft: "2px",
                    flexShrink: 0,
                    cursor: "help",
                    pointerEvents: "auto"
                  },
                  children: /* @__PURE__ */ o(Gt, { size: 10 })
                }
              ),
              !c && l && i && /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => i(t.key),
                  title: "Reset to default",
                  className: "edit-panel-reset-field",
                  style: {
                    background: "none",
                    border: "none",
                    padding: "1px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    color: s.gray_medium,
                    opacity: 0.5,
                    transition: "opacity 0.15s, color 0.15s",
                    marginLeft: "2px",
                    flexShrink: 0
                  },
                  children: /* @__PURE__ */ o(wn, { size: 10 })
                }
              )
            ]
          }
        ),
        Hi(t, e)
      ]
    }
  );
}, co = ({ label: e, count: t, isCollapsed: n, onClick: r, marginBottom: i }) => /* @__PURE__ */ u(
  "button",
  {
    className: "edit-panel-group-header",
    onClick: r,
    style: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "12px",
      fontWeight: 700,
      color: s.primary,
      margin: 0,
      padding: 0,
      paddingBottom: "8px",
      marginBottom: i ?? 0,
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
      borderBottom: `2px solid ${s.border_glass}`,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      background: "none",
      width: "100%",
      textAlign: "left",
      fontFamily: "inherit"
    },
    children: [
      n ? /* @__PURE__ */ o(dt, { size: 14 }) : /* @__PURE__ */ o(fr, { size: 14 }),
      e,
      /* @__PURE__ */ o(
        "span",
        {
          style: {
            fontSize: "10px",
            fontWeight: 500,
            color: s.gray_medium,
            marginLeft: "auto"
          },
          children: t
        }
      )
    ]
  }
), po = ({
  fields: e,
  itemProps: t
}) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px"
    },
    children: e.map((n) => /* @__PURE__ */ o(Ni, { field: n, ...t }, n.key))
  }
), Li = ({
  displayedGroupedFields: e,
  totalDisplayedFields: t,
  isShowingAllCategories: n,
  collapsedGroups: r,
  toggleGroupCollapse: i,
  searchQuery: l,
  setSearchQuery: c,
  fieldItemProps: p
}) => {
  if (t === 0)
    return /* @__PURE__ */ o(
      "div",
      {
        className: "edit-panel-content",
        style: {
          padding: "16px 20px 20px",
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 20px",
              color: s.gray_medium,
              gap: "8px"
            },
            children: [
              /* @__PURE__ */ o(pt, { size: 24, style: { opacity: 0.3 } }),
              /* @__PURE__ */ o("span", { style: { fontSize: "12px", fontWeight: 500 }, children: "No matching properties" }),
              l && /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => c(""),
                  style: {
                    background: "none",
                    border: `1px solid ${s.border_glass}`,
                    borderRadius: "8px",
                    padding: "6px 12px",
                    fontSize: "11px",
                    color: s.blue,
                    cursor: "pointer",
                    fontFamily: "inherit",
                    marginTop: "4px"
                  },
                  children: "Clear search"
                }
              )
            ]
          }
        )
      }
    );
  const d = Object.keys(e.groups).length > 0;
  return /* @__PURE__ */ o(
    "div",
    {
      className: "edit-panel-content",
      style: {
        padding: "16px 20px 20px",
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1
      },
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          },
          children: [
            e.baseFields.length > 0 && /* @__PURE__ */ u($, { children: [
              n && d && /* @__PURE__ */ o(
                co,
                {
                  label: "General",
                  count: e.baseFields.length,
                  isCollapsed: r.has("__general__"),
                  onClick: () => i("__general__")
                }
              ),
              (!n || !r.has("__general__") || !d) && /* @__PURE__ */ o(
                po,
                {
                  fields: e.baseFields,
                  itemProps: p
                }
              )
            ] }),
            Object.entries(e.groups).map(
              ([h, m]) => {
                const b = n && r.has(h);
                return /* @__PURE__ */ u("div", { children: [
                  n && /* @__PURE__ */ o(
                    co,
                    {
                      label: Pn(h),
                      count: m.length,
                      isCollapsed: b,
                      onClick: () => i(h),
                      marginBottom: b ? 0 : "16px"
                    }
                  ),
                  !b && /* @__PURE__ */ o(po, { fields: m, itemProps: p })
                ] }, h);
              }
            )
          ]
        }
      )
    }
  );
}, Nn = ({
  displayName: e,
  fields: t,
  values: n,
  initialValues: r,
  onChange: i,
  onClose: l,
  onReset: c,
  screenPosition: p,
  onSave: d,
  isSaving: h = !1,
  savedKeys: m,
  studioLockedKeys: b,
  onResetField: B,
  themeColors: z = {},
  themeFonts: C = {},
  themeIcons: x = {}
}) => {
  const { dragOffset: f, isDragging: S, handleMouseDown: F } = Ur(), g = le(null), N = le(null), [y, I] = O(null), [v, k] = O(!1), {
    activeTab: M,
    setActiveTab: H,
    hasResponsiveFields: P,
    searchQuery: W,
    setSearchQuery: w,
    activeCategory: E,
    setActiveCategory: D,
    categoryList: X,
    hasSidebar: T,
    hasSearchBar: R,
    displayedGroupedFields: j,
    totalDisplayedFields: L,
    isShowingAllCategories: G,
    searchMatchCounts: Y,
    collapsedGroups: _,
    toggleGroupCollapse: J
  } = Vr(t, n), U = de(() => r ? JSON.stringify(n) !== JSON.stringify(r) : !1, [n, r]), re = () => {
    U ? k(!0) : l();
  }, q = () => {
    k(!1), c && c(), l();
  }, ne = () => {
    k(!1), l();
  }, ee = async () => {
    d && d(), k(!1);
  };
  Q(() => {
    if (!y) return;
    const fe = It(), Pe = (ve) => {
      const Te = ve.target;
      !Te.closest(".edit-panel-color-popover") && !Te.closest(".edit-panel-color-swatch") && I(null);
    };
    return fe.addEventListener("mousedown", Pe, !0), () => {
      fe.removeEventListener("mousedown", Pe, !0);
    };
  }, [y]), Q(() => {
    if (!In()) return;
    const fe = It(), Pe = "edit-panel-styles";
    if (!fe.getElementById(Pe)) {
      const ve = fe.createElement("style");
      ve.id = Pe, ve.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, fe.head.appendChild(ve);
    }
    return () => {
      const ve = fe.getElementById(Pe);
      ve && ve.remove();
    };
  }, []);
  const be = {
    values: n,
    onChange: i,
    savedKeys: m,
    studioLockedKeys: b,
    onResetField: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    openColorPicker: y,
    setOpenColorPicker: I
  }, Ne = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: qr(S) }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: g,
        className: "edit-panel-root",
        style: {
          position: "fixed",
          top: p.y + f.y,
          left: p.x + f.x,
          background: s.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${s.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${s.shadow_medium},
            0 20px 60px ${s.shadow_soft},
            0 0 0 1px ${s.border_glass}
          `,
          zIndex: 999999,
          width: T ? "800px" : "620px",
          maxWidth: T ? "800px" : "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (fe) => fe.stopPropagation(),
        onMouseDown: (fe) => fe.stopPropagation(),
        children: [
          /* @__PURE__ */ o(
            ni,
            {
              displayName: e,
              isDirty: U,
              isSaving: h,
              onReset: c,
              onSave: d,
              onClose: re,
              handleMouseDown: F
            }
          ),
          R && /* @__PURE__ */ o(
            ri,
            {
              searchQuery: W,
              setSearchQuery: w,
              searchInputRef: N
            }
          ),
          P && /* @__PURE__ */ o(ii, { activeTab: M, setActiveTab: H }),
          /* @__PURE__ */ u("div", { style: { display: "flex", flex: 1, overflow: "hidden" }, children: [
            T && /* @__PURE__ */ o(
              ai,
              {
                categoryList: X,
                activeCategory: E,
                setActiveCategory: D,
                searchMatchCounts: Y
              }
            ),
            /* @__PURE__ */ o(
              Li,
              {
                displayedGroupedFields: j,
                totalDisplayedFields: L,
                isShowingAllCategories: G,
                collapsedGroups: _,
                toggleGroupCollapse: J,
                searchQuery: W,
                setSearchQuery: w,
                fieldItemProps: be
              }
            )
          ] })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ u($, { children: [
    Re.createPortal(Ne, gt()),
    v && /* @__PURE__ */ o(
      et,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: ee,
        onCancel: q,
        onDismiss: ne,
        isLoading: h
      }
    )
  ] });
}, Ce = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken",
  PREVIEW_MODE: "bc_previewMode"
}, Ri = (e, t, n, r) => {
  try {
    e ? localStorage.setItem(Ce.THEME_ID, e) : localStorage.removeItem(Ce.THEME_ID), localStorage.setItem(Ce.EDIT_MODE, String(t)), n ? localStorage.setItem(Ce.EDIT_THEME_TOKEN, n) : localStorage.removeItem(Ce.EDIT_THEME_TOKEN), localStorage.setItem(Ce.PREVIEW_MODE, String(!!r));
  } catch (i) {
    console.error("Failed to save theme params to localStorage:", i);
  }
}, Wi = () => {
  try {
    return {
      themeId: localStorage.getItem(Ce.THEME_ID),
      editMode: localStorage.getItem(Ce.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(Ce.EDIT_THEME_TOKEN),
      previewMode: localStorage.getItem(Ce.PREVIEW_MODE) === "true"
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null,
      previewMode: !1
    };
  }
}, ft = () => {
  try {
    localStorage.removeItem(Ce.THEME_ID), localStorage.removeItem(Ce.EDIT_MODE), localStorage.removeItem(Ce.EDIT_THEME_TOKEN), localStorage.removeItem(Ce.PREVIEW_MODE);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Di = () => {
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("themeId"), n = e.get("editMode") === "true", r = e.get("editThemeToken"), i = e.get("previewMode") === "true";
    t && Ri(t, n, r, i);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, xt = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), e.searchParams.delete("previewMode"), e.searchParams.delete("origin"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, ks = (e, t, n) => {
  try {
    const r = new URL(window.location.href);
    e ? (r.searchParams.set("themeId", e), r.searchParams.set("editMode", String(t)), n ? r.searchParams.set("editThemeToken", n) : r.searchParams.delete("editThemeToken")) : (r.searchParams.delete("themeId"), r.searchParams.delete("editMode"), r.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", r.toString());
  } catch (r) {
    console.error("Failed to update URL params:", r);
  }
}, go = () => {
  const e = new URLSearchParams(window.location.search), t = e.get("themeId"), n = e.get("editMode"), r = e.get("editThemeToken"), i = e.get("origin"), l = e.get("previewMode"), c = Wi(), p = l === "true" || l === null && c.previewMode;
  return {
    themeId: t || c.themeId,
    editMode: !p && (n === "true" || n === null && c.editMode),
    editThemeToken: r || c.editThemeToken,
    origin: i,
    previewMode: p
  };
}, $e = () => {
  const [e, t] = O(go);
  return Q(() => {
    const n = setTimeout(() => {
      const r = go();
      t((i) => i.themeId !== r.themeId || i.editMode !== r.editMode || i.editThemeToken !== r.editThemeToken || i.origin !== r.origin || i.previewMode !== r.previewMode ? r : i);
    }, 0);
    return () => clearTimeout(n);
  }, []), e;
}, Qt = () => $e().editMode, Xt = sr(!1), Oi = ({ children: e }) => /* @__PURE__ */ o(Xt.Provider, { value: !0, children: e }), vs = ({ children: e }) => /* @__PURE__ */ o(Xt.Provider, { value: !1, children: e }), ji = () => cr(Xt), Gi = "/bc-checkout-shop-app/bc-checkout-shop-app.js";
function $i(e) {
  return typeof e == "string" && e.toLowerCase().endsWith(".myshopify.com");
}
function Yi(e) {
  return typeof e == "string" && e.toLowerCase().endsWith(".shopifypreview.com");
}
function Qi(e) {
  if (!e)
    return !1;
  try {
    const t = new URL(e);
    return t.pathname.endsWith(Gi) && t.searchParams.has("id");
  } catch {
    return !1;
  }
}
const Xi = () => {
  const t = Array.from(document.getElementsByTagName("script")).find((r) => Qi(r.src));
  if (t != null && t.src)
    return new URL(t.src).origin;
  const n = window.location.hostname;
  if ($i(n) || Yi(n))
    throw new Error(
      "[brandclub] Could not resolve host domain for an embedded Shopify storefront. Ensure the checkout bundle is loaded from /bc-checkout-shop-app/bc-checkout-shop-app.js?id=<slug>."
    );
  return window.location.origin;
}, Ln = Xi(), we = `${Ln}/api-rewards`;
Ln.replace(/^https?:\/\//, "");
const Rn = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // UI colors
  borderColor: "#DCDCDC",
  buttonText: "#ffffff",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, Ji = Object.keys(Rn), lt = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, mo = (e) => {
  const t = lt(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, uo = (e) => {
  const t = lt(e || "#000000");
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, ho = ({
  themeColors: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  isAddingColor: i,
  setIsAddingColor: l,
  newColorKey: c,
  setNewColorKey: p,
  newColorValue: d,
  setNewColorValue: h,
  onAddColor: m,
  onUpdateColor: b,
  onRenameColor: B,
  onDeleteColor: z,
  studioLockedColorKeys: C
}) => {
  const [x, f] = O(null), S = le({}), [F, g] = O({
    top: 0,
    left: 0,
    openAbove: !1
  }), [N, y] = O(null), [I, v] = O(null), [k, M] = O(null), H = le({}), [P, W] = O({
    top: 0,
    left: 0
  }), w = 300;
  Q(() => {
    if (x && S.current[x]) {
      const L = S.current[x].getBoundingClientRect(), Y = window.innerHeight - L.bottom, _ = L.top, J = Y < w && _ > Y;
      g({
        top: J ? L.top - 8 : L.bottom + 8,
        left: L.left + L.width / 2,
        openAbove: J
      });
    }
  }, [x]), Q(() => {
    if (!x) return;
    const L = (G) => {
      const Y = G.target;
      !Y.closest(".bc-theme-color-popover") && !Y.closest(".bc-theme-color-swatch") && f(null);
    };
    return document.addEventListener("mousedown", L), () => {
      document.removeEventListener("mousedown", L);
    };
  }, [x]), Q(() => {
    if (k && H.current[k]) {
      const L = H.current[k].getBoundingClientRect();
      W({
        top: L.bottom + 4,
        left: L.right
      });
    }
  }, [k]), Q(() => {
    if (!k) return;
    const L = (G) => {
      const Y = G.target;
      !Y.closest(".bc-theme-color-dropdown") && !Y.closest(".bc-theme-color-menu-btn") && M(null);
    };
    return document.addEventListener("mousedown", L), () => {
      document.removeEventListener("mousedown", L);
    };
  }, [k]);
  const E = (L, G) => {
    y(L), v({ name: L, value: lt(G) }), M(null), f(null);
  }, D = () => {
    y(null), v(null), f(null);
  }, X = async (L) => {
    if (!I) return;
    const { name: G, value: Y } = I, _ = mo(Y);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(_))
      return;
    G.trim() && G.trim() !== L && B && await B(L, G.trim());
    const U = mo(e[L]);
    if (_ !== U) {
      const re = G.trim() || L;
      await b(re, _);
    }
    y(null), v(null), f(null);
  }, T = (L) => {
    I && v({ ...I, value: L });
  }, R = (L) => {
    I && v({ ...I, name: L });
  }, j = (L, G, Y, _) => {
    const J = x === L, U = lt(G), re = _ && !r;
    return /* @__PURE__ */ u($, { children: [
      re ? /* @__PURE__ */ o(
        "button",
        {
          ref: (q) => {
            S.current[L] = q;
          },
          type: "button",
          onClick: () => f(J ? null : L),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${s.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: s.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ o(
            Mt,
            {
              color: U,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${s.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: s.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ o(
            Mt,
            {
              color: U,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      J && re && Re.createPortal(
        /* @__PURE__ */ o(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: F.top,
              left: F.left,
              transform: F.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: s.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${s.shadow_medium}, 0 0 0 1px ${s.border_glass}`
            },
            onClick: (q) => q.stopPropagation(),
            children: /* @__PURE__ */ o(En, { value: U, onChange: Y })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ o("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${s.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${s.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ o(
        dt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: r && Object.keys(e).length === 0 ? /* @__PURE__ */ o("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([L, G]) => {
        const Y = N === L, _ = Ji.includes(L), J = (C == null ? void 0 : C.has(L)) ?? !1, U = k === L, re = Y && I ? I.name : L, q = uo(Y && I ? I.value : G), ne = Y && I ? I.value : G;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ o(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: re,
                onChange: (ee) => Y && R(ee.target.value),
                readOnly: !Y,
                disabled: r,
                style: { cursor: Y ? "text" : "default" }
              }
            ),
            j(
              L,
              ne,
              T,
              Y
              // only editable when in edit mode
            ),
            Y ? /* @__PURE__ */ o(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: q,
                onChange: (ee) => {
                  const be = ee.target.value;
                  I && v({ ...I, value: be });
                },
                disabled: r,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ o(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: q
              }
            ),
            J && !Y && /* @__PURE__ */ o(
              "span",
              {
                title: "Edit this color from Concierge Studio",
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  color: s.blue,
                  padding: "4px",
                  cursor: "help"
                },
                children: /* @__PURE__ */ o(Gt, { size: 14 })
              }
            ),
            !Y && !J && /* @__PURE__ */ o(
              "button",
              {
                ref: (ee) => {
                  H.current[L] = ee;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => M(U ? null : L),
                disabled: r,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: s.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ o(Br, { size: 16 })
              }
            ),
            U && Re.createPortal(
              /* @__PURE__ */ u(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: P.top,
                    left: P.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: s.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${s.shadow_medium}, 0 0 0 1px ${s.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (ee) => ee.stopPropagation(),
                  children: [
                    /* @__PURE__ */ o(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => E(L, G),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: s.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => ee.currentTarget.style.background = s.gray_light,
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ o(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          M(null), z(L);
                        },
                        disabled: _,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: _ ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: _ ? s.gray_medium : s.red,
                          opacity: _ ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => {
                          _ || (ee.currentTarget.style.background = s.gray_light);
                        },
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          Y && /* @__PURE__ */ u(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ o(Ke, { size: 12 }),
                    onClick: () => X(L),
                    disabled: r,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: D,
                    disabled: r,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, L);
      }),
      i ? /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: c,
            onChange: (L) => p(L.target.value),
            disabled: r,
            autoFocus: !0
          }
        ),
        j(
          "__new_color__",
          d,
          h,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ o(Ke, { size: 12 }),
            onClick: m,
            disabled: r || !c.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              l(!1), p(""), h("#000000ff");
            },
            disabled: r,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ o(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ o($t, { size: 12 }),
          onClick: () => l(!0),
          disabled: r,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, Zi = (e) => {
  const t = {};
  let n = !1;
  for (const [r, i] of Object.entries(e))
    typeof i == "string" && i.startsWith("#") ? (t[r] = { type: "custom", value: i }, n = !0) : t[r] = i;
  return { migrated: t, needsMigration: n };
}, Ui = (e) => {
  const t = {};
  for (const [n, r] of Object.entries(Rn))
    n in e || (t[n] = r);
  return t;
}, Xe = {
  shadow: /* @__PURE__ */ new Set(["8px 8px 14px 0px rgba(0, 0, 0, 0.03)", "8px 8px 14px 0 rgba(0, 0, 0, 0.03)", "8px 8px 6px 0px rgba(0, 0, 0, 0.02)"]),
  borderColor: /* @__PURE__ */ new Set(["*"])
}, Wn = {
  "concierge-sidebar": {
    logoIconSize: /* @__PURE__ */ new Set([20, 22, 32]),
    avatarSize: /* @__PURE__ */ new Set([20, 22]),
    composeIconSize: /* @__PURE__ */ new Set([18]),
    sidebarIconSize: /* @__PURE__ */ new Set([20, 28]),
    avatarFontSize: /* @__PURE__ */ new Set([8]),
    chatHistoryTitleFontSize: /* @__PURE__ */ new Set([14, 16]),
    labelFontSize: /* @__PURE__ */ new Set([14, 16]),
    collapsedWidth: /* @__PURE__ */ new Set([40])
  },
  "concierge-home-greeting": {
    greetingFontSize: /* @__PURE__ */ new Set([28]),
    greetingFontFamily: /* @__PURE__ */ new Set(["*"]),
    greetingMarginBottom: /* @__PURE__ */ new Set([8, 24])
  },
  "concierge-home-subtitle": {
    fontSize: /* @__PURE__ */ new Set([32]),
    fontFamily: /* @__PURE__ */ new Set(["*"])
  },
  "product-card-carousel": {
    titleLineClamp: /* @__PURE__ */ new Set([2]),
    titleFontSize: /* @__PURE__ */ new Set([18]),
    titleLineHeight: /* @__PURE__ */ new Set([1.333]),
    showRetailers: /* @__PURE__ */ new Set([!1])
  },
  "concierge-chat-input": Xe,
  "concierge-panel-chat-input": Xe,
  "concierge-conversation-chat-input": Xe,
  "concierge-panel-conversation-chat-input": Xe,
  "chat-input": Xe
}, _i = (e, t) => {
  const n = Wn[e];
  if (!n) return { migrated: t, needsMigration: !1 };
  const r = { ...t };
  let i = !1;
  for (const [l, c] of Object.entries(n))
    l in r && (c.has("*") || c.has(r[l])) && (delete r[l], i = !0);
  return { migrated: r, needsMigration: i };
}, Dn = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let t = !1;
  const n = { ...e };
  n.config || (n.config = {});
  const r = n.config.colors || {}, i = Ui(r);
  if (Object.keys(i).length > 0 && (n.config.colors = { ...r, ...i }, t = !0), n.config.widgetConfig) {
    const l = {};
    for (const [c, p] of Object.entries(
      n.config.widgetConfig
    )) {
      let d = p;
      const { migrated: h, needsMigration: m } = Zi(d);
      if (d = h, m && (t = !0), c in Wn) {
        const { migrated: b, needsMigration: B } = _i(c, d);
        d = b, B && (t = !0);
      }
      l[c] = d;
    }
    n.config.widgetConfig = l;
  }
  return { processedTheme: n, needsUpdate: t };
}, On = async (e, t) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (n) {
    console.error(`Failed to migrate theme ${e}:`, n);
  }
}, Vi = async (e) => {
  const t = await fetch(
    `${we}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch widget theme");
  const n = await t.json(), { processedTheme: r, needsUpdate: i } = Dn(n);
  return i && On(e, r.config), r;
}, qi = async (e) => {
  const t = await fetch(
    `${we}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch published widget theme");
  const n = await t.json(), { processedTheme: r, needsUpdate: i } = Dn(n);
  return i && (r != null && r.appThemeId) && On(
    r.appThemeId,
    r.config
  ), r;
}, Ki = async ({
  themeId: e,
  editThemeToken: t
}) => {
  try {
    const n = await fetch(
      `${we}/brand-app-widget-theme/validate-edit-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          appThemeId: e,
          editThemeToken: t
        })
      }
    );
    return n.ok ? (await n.json()).valid === !0 : !1;
  } catch {
    return !1;
  }
}, jn = async ({
  themeId: e,
  widgetId: t,
  widgetState: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${we}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: t,
        widgetState: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, yo = async ({
  themeId: e,
  colorKey: t,
  colorValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${we}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        colorValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, ea = async ({
  themeId: e,
  colorKey: t,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${we}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme color";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, ta = async ({
  themeId: e,
  oldColorKey: t,
  newColorKey: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${we}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: t,
        newColorKey: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to rename theme color";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, bo = async ({
  themeId: e,
  fileName: t,
  contentType: n,
  assetType: r,
  editThemeToken: i
}) => {
  const l = await fetch(
    `${we}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: t,
        contentType: n,
        assetType: r,
        editThemeToken: i
      })
    }
  );
  if (!l.ok) {
    let p = "Failed to generate upload URL";
    try {
      const d = await l.json();
      p = d.errorMessage || d.message || p;
    } catch {
    }
    throw new Error(p);
  }
  const c = await l.json();
  if (c.status === "failed")
    throw new Error(c.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: c.signedUploadUrl,
    objectPublicUrl: c.objectPublicUrl
  };
}, fo = async ({
  file: e,
  signedUploadUrl: t
}) => {
  if (!(await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, oa = async ({
  themeId: e,
  fontKey: t,
  fontValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${we}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        fontValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, na = async ({
  themeId: e,
  fontKey: t,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${we}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme font";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, ra = async ({
  themeId: e,
  iconKey: t,
  iconValue: n,
  editThemeToken: r
}) => {
  const i = await fetch(
    `${we}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        iconValue: n,
        editThemeToken: r
      })
    }
  );
  if (!i.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await i.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return i.json();
}, ia = async ({
  themeId: e,
  iconKey: t,
  editThemeToken: n
}) => {
  const r = await fetch(
    `${we}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        editThemeToken: n
      })
    }
  );
  if (!r.ok) {
    let i = "Failed to delete theme icon";
    try {
      i = (await r.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return r.json();
}, Le = ["bc-widget-theme"], Gn = "bc-theme-updated";
let Ct = null, xo = !1;
const aa = (e) => {
  Ct = e, Q(() => {
    if (xo) return;
    xo = !0;
    const t = (n) => {
      var i;
      if (n.origin !== window.location.origin || ((i = n.data) == null ? void 0 : i.type) !== Gn || !Ct) return;
      const { themeId: r } = n.data.payload;
      Ct.refetchQueries({
        queryKey: [...Le, r]
      });
    };
    window.addEventListener("message", t);
  }, []);
}, ze = () => {
  const e = $e(), t = jt();
  return aa(t), dr({
    queryKey: [...Le, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return Vi(e.themeId);
      const n = window.location.hostname;
      return qi(n);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, Jt = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = ze();
  return {
    themeColors: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.colors) || {},
    isLoading: t,
    refreshThemeColors: async () => {
      await n();
    }
  };
}, $n = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = ze();
  return {
    themeFonts: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.fonts) || {},
    isLoading: t,
    refreshThemeFonts: async () => {
      await n();
    }
  };
}, Yn = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = ze();
  return {
    themeIcons: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.icons) || {},
    isLoading: t,
    refreshThemeIcons: async () => {
      await n();
    }
  };
}, la = (e, t) => {
  var l, c;
  const { data: n, isLoading: r } = ze(), i = e ? (c = (l = n == null ? void 0 : n.config) == null ? void 0 : l.widgetConfig) == null ? void 0 : c[e] : void 0;
  return {
    ...t,
    ...i,
    isLoading: r,
    savedKeys: new Set(i ? Object.keys(i) : [])
  };
}, Ht = (e) => {
  const t = jt(), n = $e();
  return { updateWidgetConfig: (c, p) => {
    e && t.setQueryData(
      [...Le, n.themeId],
      (d) => {
        var h, m, b;
        return d ? {
          ...d,
          config: {
            ...d == null ? void 0 : d.config,
            widgetConfig: {
              ...(h = d == null ? void 0 : d.config) == null ? void 0 : h.widgetConfig,
              [e]: {
                ...(b = (m = d == null ? void 0 : d.config) == null ? void 0 : m.widgetConfig) == null ? void 0 : b[e],
                [c]: p
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [c]: p
              }
            }
          }
        };
      }
    );
  }, removeWidgetConfigKey: (c) => {
    e && t.setQueryData(
      [...Le, n.themeId],
      (p) => {
        var m, b;
        if (!((b = (m = p == null ? void 0 : p.config) == null ? void 0 : m.widgetConfig) != null && b[e])) return p;
        const { [c]: d, ...h } = p.config.widgetConfig[e];
        return {
          ...p,
          config: {
            ...p.config,
            widgetConfig: {
              ...p.config.widgetConfig,
              [e]: h
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var p, d;
    if (!e) return;
    const c = t.getQueryData([
      ...Le,
      n.themeId
    ]);
    return (d = (p = c == null ? void 0 : c.config) == null ? void 0 : p.widgetConfig) == null ? void 0 : d[e];
  } };
}, ws = () => {
  const { data: e } = ze();
  return e == null ? void 0 : e.studioAvailability;
}, Ss = () => {
  const { data: e } = ze();
  return e == null ? void 0 : e.studioAgentName;
}, sa = (e, t = 32, n = 4) => {
  const r = window.innerWidth, i = window.innerHeight, l = r < 768, c = e.left, p = r - e.right, d = e.top, h = i - e.bottom, m = t + n, b = c >= m, B = p >= m, z = d >= m, C = h >= m;
  let x = "top-left", f = {};
  return l ? B && z ? (x = "top-right", f = {
    top: e.top - n,
    left: e.right - t + n
  }) : B && C ? (x = "bottom-right", f = {
    top: e.bottom - t + n,
    left: e.right - t + n
  }) : b && z ? (x = "top-left", f = {
    top: e.top - n,
    left: e.left - n
  }) : b && C ? (x = "bottom-left", f = {
    top: e.bottom - t + n,
    left: e.left - n
  }) : (x = "top-right", f = {
    top: e.top + n,
    left: e.right - t - n
  }) : b && z ? (x = "top-left", f = {
    top: e.top - n,
    left: e.left - n
  }) : B && z ? (x = "top-right", f = {
    top: e.top - n,
    left: e.right - t + n
  }) : b && C ? (x = "bottom-left", f = {
    top: e.bottom - t + n,
    left: e.left - n
  }) : B && C ? (x = "bottom-right", f = {
    top: e.bottom - t + n,
    left: e.right - t + n
  }) : (x = "top-left", f = {
    top: e.top + n,
    left: e.left + n
  }), { position: x, style: f };
}, Z = ({
  children: e,
  widgetId: t,
  displayName: n,
  editFields: r,
  editValues: i,
  onEditChange: l,
  onSave: c,
  isSaving: p = !1,
  savedKeys: d,
  studioLockedKeys: h,
  onResetField: m,
  themeColors: b = {},
  themeFonts: B = {},
  themeIcons: z = {},
  triggerMode: C = "hover",
  triggerIcon: x = "pencil",
  triggerPosition: f = "bottom-right",
  triggerLabel: S,
  wrapperStyle: F,
  containerClassName: g,
  iconOffset: N
}) => {
  const { data: y } = ze(), I = /* @__PURE__ */ new Set(), [v, k] = O(!1), [M, H] = O({ x: 0, y: 0 }), [P, W] = O(null), [w, E] = O(!1), [D, X] = O(null), [T, R] = O(!1), [j, L] = O(!1), G = le(null), Y = le(null), _ = le(null), J = Qt(), U = ji(), re = (C === "persistent" || T || j) && !v, q = ge(() => {
    if (_.current) {
      const V = _.current.getBoundingClientRect();
      if (C === "persistent") {
        const xe = S ? 160 : 28, ae = {};
        f.includes("top") ? ae.top = V.top + 12 : ae.top = V.bottom - 32 - 12, f.includes("right") ? ae.left = V.right - xe - 12 : ae.left = V.left + 12, X(ae);
      } else {
        const { style: me } = sa(V);
        N && (N.top && (me.top = (me.top ?? 0) + N.top), N.left && (me.left = (me.left ?? 0) + N.left)), X(me);
      }
    }
  }, [C, f, N]);
  Q(() => {
    if (!J || !re) {
      X(null);
      return;
    }
    q();
    const V = () => q();
    return window.addEventListener("scroll", V, !0), window.addEventListener("resize", V), () => {
      window.removeEventListener("scroll", V, !0), window.removeEventListener("resize", V);
    };
  }, [J, re, q]);
  const ne = ge(() => P ? JSON.stringify(i) !== JSON.stringify(P) : !1, [i, P]);
  if (Q(() => t ? Hn((me) => {
    me !== t && v && (ne() ? E(!0) : k(!1));
  }) : void 0, [t, v, ne]), Q(() => () => {
    G.current && clearTimeout(G.current);
  }, []), !J || U)
    return /* @__PURE__ */ o($, { children: e });
  const ee = () => {
    if (Y.current) {
      const V = Y.current.getBoundingClientRect(), me = window.innerWidth, Se = window.innerHeight, xe = 620, ae = 450, ue = 10, De = Se - V.bottom, Ye = V.top, Qe = me - V.left, ut = V.right;
      let Fe;
      De >= ae + ue ? Fe = V.bottom + ue : Ye >= ae + ue ? Fe = V.top - ae - ue : De >= Ye ? Fe = Math.max(ue, Se - ae - ue) : Fe = Math.max(ue, V.top - ae - ue);
      let ke;
      Qe >= xe ? ke = V.left : ut >= xe ? ke = V.right - xe : ke = Math.max(ue, Math.min(me - xe - ue, V.left)), ke = Math.max(ue, Math.min(ke, me - xe - ue)), Fe = Math.max(ue, Math.min(Fe, Se - ae - ue)), H({ x: ke, y: Fe });
    }
    (!P || JSON.stringify(i) === JSON.stringify(P)) && W({ ...i }), k(!0), t && An(t);
  }, be = () => {
    P && Object.keys(P).forEach((V) => {
      l(V, P[V]);
    });
  }, Ne = () => {
    c && c(), W({ ...i });
  }, fe = () => {
    be(), E(!1), k(!1);
  }, Pe = () => {
    Ne(), E(!1), k(!1);
  }, ve = () => {
    E(!1), k(!1);
  }, Te = () => {
    if (!D) return null;
    const V = C === "persistent", me = x === "gear" ? Bt : vn, xe = V && S ? (
      // Labeled button for persistent mode (more discoverable)
      /* @__PURE__ */ u(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: D.top,
            left: D.left,
            height: 32,
            background: j ? s.blue_light : "rgba(255, 255, 255, 0.92)",
            border: `1px solid ${j ? s.blue : "rgba(0,0,0,0.12)"}`,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 12px 0 8px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            transition: "all 0.2s ease",
            transform: j ? "scale(1.03)" : "scale(1)",
            opacity: j ? 1 : 0.85,
            zIndex: 999998,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap"
          },
          onMouseDown: (ae) => ae.stopPropagation(),
          onClick: (ae) => {
            ae.stopPropagation(), ae.preventDefault(), ee();
          },
          onMouseEnter: () => {
            G.current && (clearTimeout(G.current), G.current = null), L(!0);
          },
          onMouseLeave: () => L(!1),
          "aria-label": S,
          children: [
            /* @__PURE__ */ o(me, { size: 14, color: j ? s.blue : s.gray_dark }),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: "11px",
                  fontWeight: 600,
                  color: j ? s.blue : s.gray_dark,
                  letterSpacing: "0.2px"
                },
                children: S
              }
            )
          ]
        }
      )
    ) : (
      // Icon-only button (standard for hover mode, compact for persistent without label)
      /* @__PURE__ */ o(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: D.top,
            left: D.left,
            width: V ? 28 : 32,
            height: V ? 28 : 32,
            background: j ? s.blue_light : V ? "rgba(255, 255, 255, 0.85)" : s.white,
            border: `1px solid ${j ? s.blue : V ? "rgba(0,0,0,0.1)" : s.gray_border}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: V ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "background 0.2s, border-color 0.2s, transform 0.2s, opacity 0.2s",
            transform: j ? "scale(1.05)" : "scale(1)",
            opacity: V && !j ? 0.7 : 1,
            zIndex: 999998,
            padding: 0,
            minWidth: 0
          },
          onMouseDown: (ae) => ae.stopPropagation(),
          onClick: (ae) => {
            ae.stopPropagation(), ae.preventDefault(), ee();
          },
          onMouseEnter: () => {
            G.current && (clearTimeout(G.current), G.current = null), L(!0);
          },
          onMouseLeave: () => L(!1),
          "aria-label": x === "gear" ? "Edit layout" : "Edit widget",
          children: /* @__PURE__ */ o(me, { size: V ? 14 : 16, color: s.gray_dark })
        }
      )
    );
    return Re.createPortal(xe, document.body);
  };
  return /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        
        }

        .widget-wrapper.widget-fill-container,
        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${s.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${s.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: _,
        className: `widget-wrapper${C === "persistent" ? " widget-fill-container" : ""}${g ? ` ${g}` : ""}${v ? " widget-editing" : re ? " widget-hovered" : ""}`,
        style: F,
        onMouseEnter: () => {
          G.current && (clearTimeout(G.current), G.current = null), R(!0);
        },
        onMouseLeave: () => {
          G.current = setTimeout(() => {
            R(!1);
          }, 200);
        },
        children: [
          e,
          v && /* @__PURE__ */ o(
            Nn,
            {
              widgetId: t,
              displayName: n,
              fields: r,
              values: i,
              initialValues: P || void 0,
              onChange: l,
              onClose: () => k(!1),
              onReset: be,
              screenPosition: M,
              onSave: Ne,
              isSaving: p,
              savedKeys: d,
              studioLockedKeys: I,
              onResetField: m,
              themeColors: b,
              themeFonts: B,
              themeIcons: z
            }
          ),
          w && /* @__PURE__ */ o(
            et,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: Pe,
              onCancel: fe,
              onDismiss: ve,
              isLoading: p
            }
          )
        ]
      }
    ),
    re && Te()
  ] });
}, Qn = (e, t, n = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : t[e.value] ?? n : n, ca = (e) => (t, n = "#000000") => Qn(t, e, n), Bs = () => {
  const { themeColors: e } = Jt();
  return ge(
    (n, r = "#000000") => Qn(n, e, r),
    [e]
  );
};
function te(e, t, n) {
  const { isLoading: r, savedKeys: i, ...l } = la(e, t), c = l, [p, d] = O(!1), { themeColors: h } = Jt(), { themeFonts: m } = $n(), { themeIcons: b } = Yn(), B = de(() => ca(h), [h]), { data: z } = ze(), C = /* @__PURE__ */ new Set(), x = $e(), { updateWidgetConfig: f, removeWidgetConfigKey: S, getWidgetState: F } = Ht(e), g = ge(
    (M) => {
      S(M);
    },
    [S]
  ), N = de(() => {
    const M = {};
    return n.forEach((H) => {
      M[H.key] = H.type, H.responsive && (M[`mobile_${H.key}`] = H.type);
    }), M;
  }, [n]), y = ge(
    (M, H) => {
      if (C.has(M)) return;
      const P = N[M];
      let W = H;
      switch (P) {
        case "toggle":
          typeof H == "string" && (W = H === "true");
          break;
        case "number":
          if (typeof H == "string" && H !== "") {
            const w = parseFloat(H);
            isNaN(w) || (W = w);
          }
          break;
        case "options":
          typeof H == "string" && (H === "true" ? W = !0 : H === "false" ? W = !1 : /^\d+$/.test(H) && (W = parseInt(H, 10)));
          break;
      }
      f(M, W);
    },
    [N, f]
  ), I = !!(x.themeId && x.editThemeToken && e), v = ge(async () => {
    if (!x.themeId || !x.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    d(!0);
    try {
      const M = F() || c;
      await jn({
        themeId: x.themeId,
        widgetId: e,
        widgetState: M,
        editThemeToken: x.editThemeToken
      });
    } catch (M) {
      console.error("Failed to save widget config:", M), alert(`Failed to save: ${M.message}`);
    } finally {
      d(!1);
    }
  }, [x, e, F, c]), k = ge(() => {
    const M = { ...c };
    return n.forEach((H) => {
      const P = M[H.key];
      H.type === "options" && (typeof P == "boolean" ? M[H.key] = P ? "true" : "false" : typeof P == "number" && (M[H.key] = String(P)));
    }), M;
  }, [c, n]);
  return {
    state: c,
    isLoading: r,
    isSaving: p,
    handleEditChange: y,
    handleSave: v,
    resetField: g,
    savedKeys: i,
    studioLockedKeys: C,
    themeColors: h,
    themeFonts: m,
    themeIcons: b,
    resolveColor: B,
    canSave: I,
    getEditValues: k
  };
}
const ot = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], pe = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
ot.slice(
  0,
  4
);
ot.slice(1, 4);
const da = ot.slice(0, 3), pa = {
  expanded: {
    fontSize: 16,
    iconSize: 24,
    iconGap: 12,
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: K("#DCDDDC"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 24,
    paddingY: 24,
    minHeight: 138,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 16,
    mobile_paddingY: 12,
    mobile_minHeight: 46,
    mobile_iconGap: 4,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20
  },
  compact: {
    fontSize: 16,
    iconSize: 24,
    iconGap: 12,
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: K("#DCDDDC"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 24,
    paddingY: 12,
    minHeight: 56,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 16,
    mobile_paddingY: 12,
    mobile_minHeight: 46,
    mobile_iconGap: 4,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20
  }
}, Is = {
  expanded: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 6,
    backgroundColor: a("background"),
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: K("#DCDDDC"),
    borderColorFocus: K("#DCDDDC"),
    borderRadiusSingleLine: 20,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 12,
    paddingY: 12,
    minHeight: 116,
    mobile_paddingX: 12,
    mobile_paddingY: 12,
    mobile_minHeight: 116
  },
  compact: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 6,
    backgroundColor: a("background"),
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: K("#DCDDDC"),
    borderColorFocus: K("#DCDDDC"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 12,
    paddingY: 10,
    minHeight: 42,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 12,
    mobile_paddingY: 12,
    mobile_minHeight: 42,
    mobile_iconGap: 6,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20
  }
}, ga = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Je = {
  preset: "expanded",
  // Background
  backgroundColor: a("background"),
  shadowEnabled: !0,
  shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
  // Border styling
  borderColor: K("#DCDDDC"),
  borderColorFocus: a("borderColor"),
  borderRadiusSingleLine: 28,
  borderRadiusMultiLine: 15,
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: a("textPrimary"),
  submitButtonBgColorHover: a("textPrimary"),
  submitButtonIconColor: a("background"),
  submitButtonSize: 24,
  submitButtonBorderRadius: 12,
  // Action icons (attachment, mic)
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 24,
  iconGap: 12,
  micActiveColor: a("error"),
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: a("textPrimary"),
  placeholderColor: a("textTertiary"),
  // Layout — 24px horizontal padding, 56px min-height per design spec
  paddingX: 24,
  paddingY: 12,
  maxWidth: 768,
  minHeight: 56,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0,
  // Mobile overrides
  mobile_fontSize: 14,
  mobile_paddingX: 12,
  mobile_paddingY: 12,
  mobile_minHeight: 46,
  mobile_iconGap: 4,
  mobile_iconSize: 20,
  mobile_submitButtonSize: 20
}, Co = [
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: [
      { label: "Expanded", value: "expanded" },
      { label: "Compact", value: "compact" },
      { label: "Custom", value: "custom" }
    ]
  },
  // Background
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "shadowEnabled", label: "Shadow", type: "toggle" },
  { key: "shadow", label: "Shadow Value (CSS)", type: "text" },
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "iconGap",
    label: "Icon Gap",
    type: "number",
    min: 4,
    max: 32,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: pe
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 300,
    step: 10,
    responsive: !0
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], Ps = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  presets: r,
  children: i
}) => {
  const l = r ?? pa, {
    state: c,
    isLoading: p,
    isSaving: d,
    handleEditChange: h,
    handleSave: m,
    resetField: b,
    savedKeys: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    resolveColor: f,
    canSave: S,
    getEditValues: F
  } = te(t, { ...Je, ...e }, Co), g = ge(
    (w, E) => {
      if (w === "preset" && E !== "custom") {
        const X = l[E];
        if (X) {
          h("preset", E), Object.entries(X).forEach(([T, R]) => {
            h(T, R);
          });
          return;
        }
      }
      w !== "preset" && h("preset", "custom"), h(w, E);
    },
    [h]
  ), N = c.fontFamily, y = N && N !== "inherit" ? C[N] : null, I = y && y.format === "google" ? y.url : null;
  if (Q(() => {
    I && ga(I);
  }, [I]), Q(() => {
    !p && !B.has("iconGap") && (B.has("iconSize") && c.iconSize !== Je.iconSize && g("iconSize", Je.iconSize), B.has("submitButtonSize") && c.submitButtonSize !== Je.submitButtonSize && g("submitButtonSize", Je.submitButtonSize));
  }, [p]), p)
    return /* @__PURE__ */ o($, {});
  const v = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", k = y && y.format !== "system" && y.format !== "google", M = `chat-input-${t || "default"}`, H = `
    ${k ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${v !== "inherit" ? `.${M} { font-family: ${v} !important; }` : ""}
  `.trim(), P = {
    ...c,
    fontFamilyCss: v
  }, W = /* @__PURE__ */ u($, { children: [
    H && /* @__PURE__ */ o("style", { children: H }),
    i(P, x, f)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Co,
      editValues: F(),
      onEditChange: g,
      onSave: S ? m : void 0,
      isSaving: d,
      savedKeys: B,
      onResetField: b,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: W
    }
  );
}, ko = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, ma = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: a("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: a("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: a("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: a("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: a("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: a("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: {
    fontWeight: "600",
    backgroundColor: a("primary"),
    color: a("primaryForeground")
  },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: a("primaryForeground")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: a("textPrimary")
  }
}, ua = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: a("background"),
  // blueWhite-like for user
  textColor: a("textPrimary"),
  // Border radius
  borderRadius: 23,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Single-line height
  singleLineHeight: 46,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Streaming cursor (pulsating dot) — defaults to textPrimary
  streamingCursorColor: a("textPrimary"),
  // Element styles with defaults
  elementStyles: ma
}, Ze = (e, t, n) => {
  const r = `elementStyles.${e}`, i = [
    {
      key: `${r}.fontFamily`,
      label: `${t} Font`,
      type: "font"
    },
    {
      key: `${r}.fontSize`,
      label: `${t} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${r}.fontWeight`,
      label: `${t} Font Weight`,
      type: "options",
      options: ot
    },
    {
      key: `${r}.color`,
      label: `${t} Color`,
      type: "color"
    }
  ];
  return n != null && n.includeBackgroundColor && i.push({
    key: `${r}.backgroundColor`,
    label: `${t} Background`,
    type: "color"
  }), i.push(
    {
      key: `${r}.lineHeight`,
      label: `${t} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${r}.marginTop`,
      label: `${t} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${r}.marginBottom`,
      label: `${t} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ), i;
}, Ue = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, Xn = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "streamingCursorColor", label: "Streaming Cursor Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: da
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "singleLineHeight",
    label: "Single Line Height (px)",
    type: "number",
    min: 0,
    max: 80,
    step: 1
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], ha = ["h1", "h2", "h3"], ya = ["p", "blockquote"], ba = ["li"], fa = ["th", "td"], xa = ["thead"], Ca = [
  ...ha.flatMap(
    (e) => Ze(e, Ue[e])
  ),
  ...ya.flatMap(
    (e) => Ze(e, Ue[e])
  ),
  ...ba.flatMap(
    (e) => Ze(e, Ue[e])
  ),
  ...xa.flatMap(
    (e) => Ze(e, Ue[e], {
      includeBackgroundColor: !0
    })
  ),
  ...fa.flatMap(
    (e) => Ze(e, Ue[e])
  )
], ka = [...Xn, ...Ca], va = (e, t, n, r) => {
  if (!t) return "";
  const i = [], l = [], c = /* @__PURE__ */ new Set();
  for (const [p, d] of Object.entries(t)) {
    if (!d) continue;
    const h = [];
    if (d.fontSize !== void 0 && h.push(`font-size: ${d.fontSize}px`), d.fontWeight !== void 0 && h.push(`font-weight: ${d.fontWeight}`), d.color && d.color !== "inherit") {
      const m = r(d.color);
      h.push(`color: ${m}`);
    }
    if (d.backgroundColor && d.backgroundColor !== "inherit" && d.backgroundColor !== "transparent") {
      const m = r(d.backgroundColor);
      h.push(`background-color: ${m}`);
    }
    if (d.lineHeight !== void 0 && h.push(`line-height: ${d.lineHeight}`), d.marginTop !== void 0 && h.push(`margin-top: ${d.marginTop}px`), d.marginBottom !== void 0 && h.push(`margin-bottom: ${d.marginBottom}px`), d.fontFamily && d.fontFamily !== "inherit") {
      const m = n[d.fontFamily];
      m && (m.format === "system" ? h.push(`font-family: ${m.url}`) : (h.push(`font-family: "${m.name}", sans-serif`), m.format !== "google" && !c.has(m.name) && (l.push(`
              @font-face {
                font-family: "${m.name}";
                src: url("${m.url}") format("${m.format}");
                font-display: swap;
              }
            `), c.add(m.name))));
    }
    h.length > 0 && i.push(`#concierge-mount .${e} .message-content ${p},
#concierge-mount .${e} .message-content .message-markdown ${p},
.${e} .message-content ${p},
.${e} .message-content .message-markdown ${p} {
  ${h.join(`;
  `)};
}`);
  }
  return [...l, ...i].join(`

`);
}, wa = (e, t, n) => {
  const r = t.split("."), i = { ...e };
  let l = i;
  for (let c = 0; c < r.length - 1; c++) {
    const p = r[c];
    l[p] = { ...l[p] }, l = l[p];
  }
  return l[r[r.length - 1]] = n, i;
}, Sa = (e) => {
  const t = {};
  for (const [n, r] of Object.entries(e))
    if (n === "elementStyles" && typeof r == "object" && r !== null) {
      for (const [i, l] of Object.entries(
        r
      ))
        if (l && typeof l == "object")
          for (const [c, p] of Object.entries(l))
            t[`elementStyles.${i}.${c}`] = p;
    } else
      t[n] = r;
  return t;
}, zs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...ua, ...e },
    Xn
    // Only use base fields for type transformations
  ), z = (P, W) => {
    if (P.includes(".")) {
      const w = wa(i, P, W), E = P.split(".")[0];
      p(E, w[E]);
    } else
      p(P, W);
  }, C = de(() => Sa(i), [i]), x = i.fontFamily, f = x && x !== "inherit" ? m[x] : null, S = f && f.format === "google" ? f.url : null, F = de(() => {
    const P = [];
    if (i.elementStyles) {
      for (const W of Object.values(i.elementStyles))
        if (W != null && W.fontFamily && W.fontFamily !== "inherit") {
          const w = m[W.fontFamily];
          (w == null ? void 0 : w.format) === "google" && w.url && !P.includes(w.url) && P.push(w.url);
        }
    }
    return P;
  }, [i.elementStyles, m]);
  Q(() => {
    S && ko(S);
    for (const P of F)
      ko(P);
  }, [S, F]);
  const g = `message-bubble-${t || "default"}`, N = de(
    () => va(
      g,
      i.elementStyles,
      m,
      b
    ),
    [g, i.elementStyles, m, b]
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const y = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", k = [`
    ${f && f.format !== "system" && f.format !== "google" ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${g} { font-family: ${y} !important; }` : ""}
  `.trim(), N].filter(Boolean).join(`

`), M = {
    ...i,
    fontFamilyCss: y
  }, H = /* @__PURE__ */ u("div", { className: g, children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(M, b)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: ka,
      editValues: C,
      onEditChange: z,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: H
    }
  );
}, Fs = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, Ba = {
  // Container
  containerBgColor: a("background"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: a("textPrimary"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: a("textPrimary"),
  statusFontSize: 12,
  statusMarginTop: 8
}, vo = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], Ts = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    resolveColor: m,
    canSave: b
  } = te(
    t,
    { ...Ba, ...e },
    vo
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const B = r(i, m);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: vo,
      editValues: i,
      onEditChange: p,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: h,
      children: B
    }
  );
}, wo = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, rt = ({ width: e }) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Ia = {
  // Preset
  preset: "inline",
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 20,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  // Title icon & behavior
  showSparkleIcon: !0,
  collapsible: !1,
  // Container
  containerGap: 16,
  containerMarginTop: 16,
  containerMarginBottom: 16,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Suggestion pills
  pillPaddingX: 12,
  pillPaddingY: 4,
  pillBorderRadius: 50,
  pillBorderColor: a("primary"),
  pillBorderWidth: 1.5,
  pillBgColor: a("background"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 16,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Pa = {
  inline: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("background"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  highlighted: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("background"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  accordion: {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("background"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  "accordion-highlighted": {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("background"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  }
}, za = [
  { label: "Inline Pills (V1)", value: "inline" },
  { label: "Highlighted (V2)", value: "highlighted" },
  { label: "Accordion (V3)", value: "accordion" },
  { label: "Accordion Highlighted (V4)", value: "accordion-highlighted" },
  { label: "Custom", value: "custom" }
], So = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: za
  },
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "showSparkleIcon", label: "Show Sparkle Icon", type: "toggle" },
  { key: "collapsible", label: "Collapsible (Accordion)", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...pe]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 2,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...pe]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Jn = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Fa = ({
  color: e = "currentColor"
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ o(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), Ta = ({
  expanded: e,
  color: t = "currentColor"
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      flexShrink: 0,
      transition: "transform 0.2s ease",
      transform: e ? "rotate(180deg)" : "rotate(0deg)"
    },
    children: /* @__PURE__ */ o("polyline", { points: "6 9 12 15 18 9" })
  }
), Ma = ({ question: e, onClick: t, state: n, resolveColor: r }) => {
  const [i, l] = O(!1);
  return /* @__PURE__ */ o(
    "button",
    {
      onClick: t,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        padding: `${n.pillPaddingY}px ${n.pillPaddingX}px`,
        borderRadius: `${n.pillBorderRadius}px`,
        border: `${n.pillBorderWidth}px solid ${r(n.pillBorderColor)}`,
        backgroundColor: r(i ? n.pillBgColorHover : n.pillBgColor),
        color: r(n.pillTextColor),
        fontSize: `${n.pillFontSize}px`,
        fontWeight: Jn[n.pillFontWeight] || 500,
        fontFamily: n.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: "32px"
      },
      children: e
    }
  );
}, Ms = ({
  widgetId: e = "conversation-starters",
  displayName: t = "Conversation Starters",
  initialState: n = {},
  questions: r,
  isLoading: i = !1,
  onQuestionClick: l
}) => {
  const {
    state: c,
    isLoading: p,
    isSaving: d,
    handleEditChange: h,
    handleSave: m,
    themeColors: b,
    themeFonts: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ...Ia, ...n },
    So
  ), [x, f] = O(!1), S = (j, L) => {
    if (j === "preset" && L !== "custom") {
      const Y = Pa[L];
      if (Y) {
        h("preset", L), Object.entries(Y).forEach(([_, J]) => {
          h(_, J);
        });
        return;
      }
    }
    h(j, L);
  }, F = c.pillFontFamily, g = F && F !== "inherit" ? B[F] : null, N = c.titleFontFamily, y = N && N !== "inherit" ? B[N] : null, I = g && g.format === "google" ? g.url : null, v = y && y.format === "google" ? y.url : null;
  if (Q(() => {
    I && wo(I);
  }, [I]), Q(() => {
    v && wo(v);
  }, [v]), p || !i && r.length === 0)
    return null;
  const k = g ? g.format === "system" ? g.url : `"${g.name}", sans-serif` : "inherit", M = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", H = g && g.format !== "system" && g.format !== "google", P = y && y.format !== "system" && y.format !== "google", W = `conversation-starters-${e || "default"}`, w = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${H ? `
      @font-face {
        font-family: "${g.name}";
        src: url("${g.url}") format("${g.format}");
        font-display: swap;
      }
    ` : ""}
    ${P ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), E = {
    ...c,
    pillFontFamilyCss: k,
    titleFontFamilyCss: M
  }, D = c.collapsible ? x : !0, X = z(c.containerBgColor), T = X && X !== "transparent" && X !== "", R = /* @__PURE__ */ u($, { children: [
    w && /* @__PURE__ */ o("style", { children: w }),
    /* @__PURE__ */ u(
      "div",
      {
        className: W,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: D ? `${c.containerGap}px` : "0px",
          marginTop: `${c.containerMarginTop}px`,
          marginBottom: `${c.containerMarginBottom}px`,
          backgroundColor: T ? X : void 0,
          padding: T || c.containerPaddingX || c.containerPaddingY ? `${c.containerPaddingY}px ${c.containerPaddingX}px` : void 0,
          borderRadius: c.containerBorderRadius > 0 ? `${c.containerBorderRadius}px` : void 0
        },
        children: [
          c.showTitle && /* @__PURE__ */ u(
            "h3",
            {
              onClick: c.collapsible ? () => f((j) => !j) : void 0,
              style: {
                fontSize: `${c.titleFontSize}px`,
                fontWeight: Jn[c.titleFontWeight] || 600,
                fontFamily: M,
                color: z(c.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: c.collapsible ? "pointer" : void 0,
                userSelect: c.collapsible ? "none" : void 0
              },
              children: [
                c.showSparkleIcon && /* @__PURE__ */ o(Fa, { color: z(c.titleColor) }),
                /* @__PURE__ */ o("span", { style: { flex: 1 }, children: c.titleText }),
                c.collapsible && /* @__PURE__ */ o(
                  Ta,
                  {
                    expanded: x,
                    color: z(c.titleColor)
                  }
                )
              ]
            }
          ),
          D && /* @__PURE__ */ o($, { children: i ? /* @__PURE__ */ u(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ o(rt, { width: 180 }),
                /* @__PURE__ */ o(rt, { width: 140 }),
                /* @__PURE__ */ o(rt, { width: 200 }),
                /* @__PURE__ */ o(rt, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: r.map((j, L) => /* @__PURE__ */ o(
                Ma,
                {
                  question: j,
                  onClick: () => l(j),
                  state: E,
                  resolveColor: z
                },
                L
              ))
            }
          ) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: So,
      editValues: c,
      onEditChange: S,
      onSave: C ? m : void 0,
      isSaving: d,
      themeColors: b,
      themeFonts: B,
      children: R
    }
  );
}, Ve = 60, Bo = 420, Io = ({
  showSettings: e,
  viewMode: t,
  editorMode: n = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${Ve}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${s.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${s.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${s.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${s.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${s.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${s.primary};
    background: ${s.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${s.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${s.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${s.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${Ve}px;
    left: 0;
    right: ${e ? Bo : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${t === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${t === "desktop" ? "100%" : "375px"};
    height: ${t === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${t === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${Ve}px;
    right: 0;
    bottom: 0;
    width: ${Bo}px;
    background: #fff;
    border-left: 1px solid ${s.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${s.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${s.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${s.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${s.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${s.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${s.gray_light};
    color: ${s.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${s.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${s.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${s.white};
    border-radius: 12px;
    border: 1px solid ${s.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${s.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${s.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${s.gray_medium};
    background: ${s.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${s.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${s.overlay_light};
    border-radius: 12px;
    border: 1px solid ${s.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${s.white};
    box-shadow: 0 2px 8px ${s.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${s.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${s.white};
    color: ${s.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${s.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${s.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${s.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${s.gray_medium};
    width: 85px;
    text-align: right;
    background: ${s.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${s.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${s.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${s.gray_light};
    color: ${s.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${s.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${s.blue};
    border: 2px dashed ${s.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${s.blue_light};
    border-color: ${s.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${s.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${s.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${s.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${s.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${s.gray_medium};
    background: ${s.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${s.overlay_light};
    border: 1px solid ${s.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${s.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${s.white};
    border-color: ${s.blue};
    color: ${s.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${s.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${s.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${n === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${Ve}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, Po = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Ea = [
  { label: "Classic", value: "magnifying-glass" },
  { label: "Alternate", value: "magnifying-glass-alt" },
  { label: "Bold", value: "magnifying-glass-bold" },
  { label: "Slim", value: "magnifying-glass-slim" },
  { label: "Dot", value: "magnifying-glass-dot" }
], kt = ({
  variant: e = "magnifying-glass",
  size: t,
  color: n,
  strokeWidth: r = 2,
  style: i
}) => {
  const l = {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: n,
    strokeWidth: r,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, ...i }
  };
  switch (e) {
    case "magnifying-glass-alt":
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }),
        /* @__PURE__ */ o("path", { d: "M21 21l-6-6" })
      ] });
    case "magnifying-glass-bold":
      return /* @__PURE__ */ u("svg", { ...l, strokeWidth: r + 0.75, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "7" }),
        /* @__PURE__ */ o("line", { x1: "16.5", y1: "16.5", x2: "21", y2: "21" })
      ] });
    case "magnifying-glass-slim":
      return /* @__PURE__ */ u("svg", { ...l, strokeWidth: Math.max(1, r - 0.5), children: [
        /* @__PURE__ */ o("circle", { cx: "10.5", cy: "10.5", r: "8.5" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "17", y2: "17" })
      ] });
    case "magnifying-glass-dot":
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }),
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "1.5", fill: n, stroke: "none" })
      ] });
    case "magnifying-glass":
    default:
      return /* @__PURE__ */ u("svg", { ...l, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
      ] });
  }
}, Aa = ({
  size: e,
  color: t
}) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, cursor: "pointer" },
    children: [
      /* @__PURE__ */ o("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      /* @__PURE__ */ o("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
    ]
  }
), Ge = {
  // Trigger icon
  triggerIconStyle: "magnifying-glass",
  triggerIconThemeIcon: "default",
  triggerIconSize: 20,
  triggerIconColor: a("textPrimary"),
  triggerIconStrokeWidth: 2,
  // Panel
  panelBgColor: a("background"),
  // Search bar
  searchBarBgColor: a("background"),
  searchBarBorderRadius: 30,
  searchBarMaxWidth: 800,
  searchBarHeight: 56,
  searchBarHeightMobile: 40,
  searchBarPlaceholder: "Search or ask concierge",
  searchBarFontSize: 14,
  searchBarFontSizeMobile: 12,
  searchBarTextColor: a("textPrimary"),
  searchBarPlaceholderColor: a("textPrimary"),
  searchBarIconSize: 24,
  searchBarIconSizeMobile: 16,
  // Ask concierge button
  askButtonBgColor: a("textPrimary"),
  askButtonTextColor: a("secondary"),
  askButtonBorderRadius: 100,
  askButtonFontSize: 14,
  askButtonFontSizeMobile: 10,
  askButtonText: "Ask concierge",
  askButtonPaddingX: 16,
  askButtonPaddingY: 4,
  // Close button
  closeIconSize: 24,
  closeIconSizeMobile: 20,
  closeIconColor: a("textPrimary"),
  // Section headers
  sectionHeaderFontSize: 16,
  sectionHeaderFontSizeMobile: 14,
  sectionHeaderFontWeight: "semibold",
  sectionHeaderColor: a("textPrimary"),
  // Body / question text
  bodyFontSize: 14,
  bodyColor: a("textPrimary"),
  bodyLineHeight: 24,
  // Products
  productImageSize: 72,
  productImageSizeMobile: 56,
  productNameFontSize: 14,
  productPriceFontSize: 14,
  productPriceFontWeight: "semibold",
  productColumns: 2,
  // Trending searches
  trendingFontSize: 14,
  trendingColor: a("textPrimary"),
  trendingLineHeight: 24,
  // Empty state
  noResultsText: "No search results found. Please try again.",
  noResultsWithSuggestionsText: "No search results found . Here's some ideas to get you started.",
  noSuggestionsText: "No suggestions found",
  noProductsText: "No products found",
  noSearchesText: "No searches found",
  // Spacing
  sectionGap: 32,
  contentPaddingX: 43,
  contentPaddingXMobile: 20,
  contentPaddingTop: 24,
  // Mobile dividers
  showMobileDividers: !0,
  dividerColor: a("background"),
  // Font
  fontFamily: "inherit"
}, Zn = [
  {
    key: "triggerIconThemeIcon",
    label: "Custom Icon",
    type: "icon",
    group: "Trigger Icon"
  },
  {
    key: "triggerIconStyle",
    label: "Built-in Style",
    type: "options",
    options: Ea,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 48,
    step: 2,
    group: "Trigger Icon"
  },
  {
    key: "triggerIconColor",
    label: "Icon Color",
    type: "color",
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconStrokeWidth",
    label: "Stroke Width",
    type: "number",
    min: 1,
    max: 4,
    step: 0.5,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  }
], Un = [
  {
    key: "searchBarBgColor",
    label: "Background",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2,
    group: "Search Bar"
  },
  {
    key: "searchBarMaxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Search Bar"
  },
  {
    key: "searchBarHeight",
    label: "Height (Desktop)",
    type: "number",
    min: 36,
    max: 72,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarHeightMobile",
    label: "Height (Mobile)",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholder",
    label: "Placeholder Text",
    type: "text",
    group: "Search Bar"
  },
  {
    key: "searchBarFontSize",
    label: "Font Size (Desktop)",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Search Bar"
  },
  {
    key: "searchBarTextColor",
    label: "Text Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholderColor",
    label: "Placeholder Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "askButtonBgColor",
    label: "Button Background",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonBorderRadius",
    label: "Button Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4,
    group: "Ask Button"
  },
  {
    key: "askButtonText",
    label: "Button Text",
    type: "text",
    group: "Ask Button"
  },
  {
    key: "closeIconSize",
    label: "Close Icon Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Close Button"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Close Button"
  }
], Nt = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderFontWeight",
    label: "Header Font Weight",
    type: "options",
    options: [...pe],
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "bodyFontSize",
    label: "Body Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Body Text"
  },
  { key: "bodyColor", label: "Body Color", type: "color", group: "Body Text" }
], Lt = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "productImageSize",
    label: "Image Size (Desktop)",
    type: "number",
    min: 48,
    max: 96,
    step: 8,
    group: "Products"
  },
  {
    key: "productImageSizeMobile",
    label: "Image Size (Mobile)",
    type: "number",
    min: 40,
    max: 72,
    step: 8,
    group: "Products"
  },
  {
    key: "productColumns",
    label: "Columns (Desktop)",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Products"
  },
  {
    key: "productNameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...pe],
    group: "Products"
  }
], Rt = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "trendingFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Trending"
  },
  { key: "trendingColor", label: "Color", type: "color", group: "Trending" }
], _n = [
  {
    key: "panelBgColor",
    label: "Panel Background",
    type: "color",
    group: "Panel"
  },
  { key: "fontFamily", label: "Font Family", type: "font", group: "Panel" },
  {
    key: "sectionGap",
    label: "Section Gap",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingX",
    label: "Padding X (Desktop)",
    type: "number",
    min: 16,
    max: 80,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingXMobile",
    label: "Padding X (Mobile)",
    type: "number",
    min: 12,
    max: 40,
    step: 4,
    group: "Spacing"
  },
  {
    key: "noResultsText",
    label: "No Results Text",
    type: "text",
    group: "Empty States"
  },
  {
    key: "noResultsWithSuggestionsText",
    label: "No Results (with suggestions)",
    type: "text",
    group: "Empty States"
  },
  {
    key: "showMobileDividers",
    label: "Show Mobile Dividers",
    type: "toggle",
    group: "Dividers"
  },
  {
    key: "dividerColor",
    label: "Divider Color",
    type: "color",
    group: "Dividers"
  }
], Ha = [
  ...Zn,
  ...Un,
  ...Nt,
  ...Lt,
  ...Rt,
  ..._n
], He = ({ width: e }) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      width: e,
      height: "18px",
      borderRadius: "3px",
      backgroundColor: "#e5e7eb",
      animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), vt = ({ imageSize: e }) => /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [
  /* @__PURE__ */ o(
    "div",
    {
      style: {
        width: e,
        height: e,
        borderRadius: "8px",
        backgroundColor: "#e5e7eb",
        flexShrink: 0,
        animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      }
    }
  ),
  /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ o(He, { width: "140px" }),
    /* @__PURE__ */ o(He, { width: "60px" })
  ] })
] }), zo = ({
  product: e,
  imageSize: t,
  nameSize: n,
  priceSize: r,
  priceWeight: i,
  textColor: l,
  nameMaxWidth: c,
  onClick: p
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: p ? "pointer" : void 0
    },
    onClick: p,
    children: [
      /* @__PURE__ */ o(
        "img",
        {
          src: e.imageUrl,
          alt: e.name,
          style: {
            width: t,
            height: t,
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: "4px"
          }
        }
      ),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            minWidth: 0,
            maxWidth: c
          },
          children: [
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: `${n}px`,
                  fontWeight: 400,
                  lineHeight: "20px",
                  color: l,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                },
                children: e.name
              }
            ),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: `${r}px`,
                  fontWeight: i,
                  lineHeight: "20px",
                  color: l
                },
                children: e.price
              }
            )
          ]
        }
      )
    ]
  }
), Es = ({
  widgetId: e = "search-panel",
  displayName: t = "Search Panel",
  initialState: n = {},
  conciergeQuestions: r,
  popularProducts: i,
  trendingSearches: l,
  isOpen: c,
  searchQuery: p,
  isLoading: d = !1,
  hasSearched: h = !1,
  onOpen: m,
  onClose: b,
  onSearchChange: B,
  onSearchSubmit: z,
  onAskConcierge: C,
  onQuestionClick: x,
  onProductClick: f,
  onTrendingClick: S,
  brandLogo: F
}) => {
  var qt;
  const {
    state: g,
    isLoading: N,
    isSaving: y,
    handleEditChange: I,
    handleSave: v,
    themeColors: k,
    themeFonts: M,
    themeIcons: H,
    resolveColor: P,
    canSave: W
  } = te(
    e,
    { ...Ge, ...n },
    Ha
  ), w = le(null), [E, D] = O(!1), X = Qt();
  Q(() => {
    const ie = () => D(window.innerWidth < 768);
    return ie(), window.addEventListener("resize", ie), () => window.removeEventListener("resize", ie);
  }, []), Q(() => {
    if (c && w.current) {
      const ie = setTimeout(() => {
        var Be;
        return (Be = w.current) == null ? void 0 : Be.focus();
      }, 100);
      return () => clearTimeout(ie);
    }
  }, [c]), Q(() => {
    if (!c) return;
    const ie = (Be) => {
      Be.key === "Escape" && b();
    };
    return document.addEventListener("keydown", ie), () => document.removeEventListener("keydown", ie);
  }, [c, b]);
  const T = ge(
    (ie) => {
      ie.key === "Enter" && z(p);
    },
    [p, z]
  );
  if (N && !c)
    return /* @__PURE__ */ o(
      "div",
      {
        onClick: m,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: /* @__PURE__ */ o(
          kt,
          {
            variant: Ge.triggerIconStyle,
            size: Ge.triggerIconSize,
            color: typeof Ge.triggerIconColor == "string" ? Ge.triggerIconColor : "#4f4b47",
            strokeWidth: Ge.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
  if (N) return null;
  const R = P(g.triggerIconColor), j = g.triggerIconThemeIcon, L = j && j !== "default" ? (qt = H[j]) == null ? void 0 : qt.url : void 0;
  if (!c) {
    const ie = /* @__PURE__ */ o(
      "div",
      {
        onClick: m,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: L ? /* @__PURE__ */ o(
          "img",
          {
            src: L,
            alt: "Search",
            style: {
              width: g.triggerIconSize,
              height: g.triggerIconSize,
              objectFit: "contain",
              cursor: "pointer",
              flexShrink: 0
            }
          }
        ) : /* @__PURE__ */ o(
          kt,
          {
            variant: g.triggerIconStyle,
            size: g.triggerIconSize,
            color: R,
            strokeWidth: g.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
    return /* @__PURE__ */ o(
      Z,
      {
        widgetId: e,
        displayName: "Search Icon",
        editFields: Zn,
        editValues: g,
        onEditChange: I,
        onSave: W ? v : void 0,
        isSaving: y,
        themeColors: k,
        themeFonts: M,
        themeIcons: H,
        wrapperStyle: { display: "inline-flex", width: "auto" },
        iconOffset: { top: -16, left: 24 },
        children: ie
      }
    );
  }
  const G = P(g.panelBgColor), Y = P(g.searchBarBgColor), _ = P(g.searchBarTextColor);
  P(g.searchBarPlaceholderColor);
  const J = P(g.askButtonBgColor), U = P(g.askButtonTextColor), re = P(g.closeIconColor), q = P(g.sectionHeaderColor), ne = P(g.bodyColor), ee = P(g.trendingColor), be = P(g.dividerColor), Ne = Po[g.sectionHeaderFontWeight] || 600, fe = Po[g.productPriceFontWeight] || 600, Pe = E ? g.searchBarHeightMobile : g.searchBarHeight, ve = E ? g.searchBarFontSizeMobile : g.searchBarFontSize, Te = E ? g.searchBarIconSizeMobile : g.searchBarIconSize, V = E ? g.closeIconSizeMobile : g.closeIconSize, me = E ? g.sectionHeaderFontSizeMobile : g.sectionHeaderFontSize, Se = E ? g.productImageSizeMobile : g.productImageSize, xe = E ? g.contentPaddingXMobile : g.contentPaddingX, ae = E ? g.askButtonFontSizeMobile : g.askButtonFontSize, ue = r.length > 0, De = i.length > 0, Ye = l.length > 0, Qe = ue || De || Ye, ut = h && !d, Fe = !h || Qe, ke = (ie) => /* @__PURE__ */ o(
    "h3",
    {
      style: {
        margin: 0,
        fontSize: `${me}px`,
        fontWeight: Ne,
        lineHeight: E ? "24px" : "32px",
        color: q
      },
      children: ie
    }
  ), Zt = () => d ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ke("Ask Concierge"),
    /* @__PURE__ */ o(He, { width: "80%" }),
    /* @__PURE__ */ o(He, { width: "70%" }),
    /* @__PURE__ */ o(He, { width: "60%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: [
    ke("Ask Concierge"),
    ue ? r.map((ie, Be) => /* @__PURE__ */ o(
      "p",
      {
        onClick: () => x(ie),
        style: {
          margin: 0,
          fontSize: `${g.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${g.bodyLineHeight}px`,
          color: ne,
          cursor: "pointer"
        },
        children: ie
      },
      Be
    )) : /* @__PURE__ */ o(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${g.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${g.bodyLineHeight}px`,
          color: ne,
          opacity: 0.7
        },
        children: g.noSuggestionsText
      }
    )
  ] }), Ut = () => {
    if (d)
      return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
        ke("Popular products"),
        /* @__PURE__ */ o(vt, { imageSize: Se }),
        /* @__PURE__ */ o(vt, { imageSize: Se }),
        /* @__PURE__ */ o(vt, { imageSize: Se })
      ] });
    const ie = E ? 1 : g.productColumns, Be = [];
    if (De) {
      const Me = Math.ceil(i.length / ie);
      for (let Ee = 0; Ee < ie; Ee++)
        Be.push(
          i.slice(Ee * Me, (Ee + 1) * Me)
        );
    }
    return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
      ke("Popular products"),
      De ? /* @__PURE__ */ o(
        "div",
        {
          style: {
            display: E ? "flex" : "grid",
            gridTemplateColumns: E ? void 0 : `repeat(${ie}, 1fr)`,
            flexDirection: E ? "column" : void 0,
            gap: E ? "16px" : "24px"
          },
          children: E ? i.map((Me, Ee) => /* @__PURE__ */ o(
            zo,
            {
              product: Me,
              imageSize: Se,
              nameSize: g.productNameFontSize,
              priceSize: g.productPriceFontSize,
              priceWeight: fe,
              textColor: ne,
              onClick: Me.onClick ?? (() => f(Me))
            },
            Ee
          )) : Be.map((Me, Ee) => /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px"
              },
              children: Me.map((yt, ar) => /* @__PURE__ */ o(
                zo,
                {
                  product: yt,
                  imageSize: Se,
                  nameSize: g.productNameFontSize,
                  priceSize: g.productPriceFontSize,
                  priceWeight: fe,
                  textColor: ne,
                  nameMaxWidth: 250,
                  onClick: yt.onClick ?? (() => f(yt))
                },
                ar
              ))
            },
            Ee
          ))
        }
      ) : /* @__PURE__ */ o(
        "p",
        {
          style: {
            margin: 0,
            fontSize: `${g.bodyFontSize}px`,
            fontWeight: 400,
            color: ne,
            opacity: 0.7
          },
          children: g.noProductsText
        }
      )
    ] });
  }, _t = () => d ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ke("Trending searches"),
    /* @__PURE__ */ o(He, { width: "75%" }),
    /* @__PURE__ */ o(He, { width: "65%" }),
    /* @__PURE__ */ o(He, { width: "80%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "8px" }, children: [
    ke("Trending searches"),
    Ye ? l.map((ie, Be) => /* @__PURE__ */ o(
      "p",
      {
        onClick: () => S(ie),
        style: {
          margin: 0,
          fontSize: `${g.trendingFontSize}px`,
          fontWeight: 400,
          lineHeight: `${g.trendingLineHeight}px`,
          color: ee,
          cursor: "pointer"
        },
        children: ie
      },
      Be
    )) : /* @__PURE__ */ o(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${g.bodyFontSize}px`,
          fontWeight: 400,
          color: ne,
          opacity: 0.7
        },
        children: g.noSearchesText
      }
    )
  ] }), Vt = () => !E || !g.showMobileDividers ? null : /* @__PURE__ */ o(
    "div",
    {
      style: {
        height: "1px",
        backgroundColor: be,
        margin: `${g.sectionGap / 2}px 0`
      }
    }
  ), ht = X ? Ve : 0, ir = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        @keyframes searchPanelPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes searchPanelSlideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes searchPanelFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      ` }),
    /* @__PURE__ */ o(
      "div",
      {
        onClick: b,
        style: {
          position: "fixed",
          top: ht,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2147483645,
          backgroundColor: E ? "transparent" : "rgba(0, 0, 0, 0.15)",
          animation: "searchPanelFadeIn 0.25s ease-out"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: ht,
          left: 0,
          right: 0,
          ...E ? { bottom: 0 } : {},
          zIndex: 2147483646,
          backgroundColor: G,
          display: "flex",
          flexDirection: "column",
          overflow: E ? "auto" : "visible",
          fontFamily: g.fontFamilyCss || "inherit",
          animation: "searchPanelSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          ...E ? {} : {
            maxHeight: `calc(100vh - ${ht}px)`,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)"
          }
        },
        children: [
          /* @__PURE__ */ o(
            Z,
            {
              widgetId: e ? `${e}__search-bar` : void 0,
              displayName: "Search Bar",
              editFields: Un,
              editValues: g,
              onEditChange: I,
              onSave: W ? v : void 0,
              isSaving: y,
              themeColors: k,
              themeFonts: M,
              wrapperStyle: { display: "flex", width: "100%" },
              children: /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: E ? "12px" : "24px",
                    padding: E ? "24px 20px 0 20px" : `36px ${xe}px 0 ${xe}px`,
                    flexShrink: 0,
                    width: "100%"
                  },
                  children: [
                    !E && F && /* @__PURE__ */ o("div", { style: { flexShrink: 0 }, children: F }),
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: Y,
                          borderRadius: `${g.searchBarBorderRadius}px`,
                          maxWidth: `${g.searchBarMaxWidth}px`,
                          margin: "0 auto",
                          height: `${Pe}px`,
                          padding: E ? "0 8px 0 12px" : "0 12px 0 16px",
                          gap: E ? "8px" : "12px"
                        },
                        children: [
                          L ? /* @__PURE__ */ o(
                            "img",
                            {
                              src: L,
                              alt: "Search",
                              style: {
                                width: Te,
                                height: Te,
                                objectFit: "contain",
                                flexShrink: 0
                              }
                            }
                          ) : /* @__PURE__ */ o(
                            kt,
                            {
                              variant: g.triggerIconStyle,
                              size: Te,
                              color: _
                            }
                          ),
                          /* @__PURE__ */ o(
                            "input",
                            {
                              ref: w,
                              type: "text",
                              value: p,
                              onChange: (ie) => B(ie.target.value),
                              onKeyDown: T,
                              placeholder: g.searchBarPlaceholder,
                              style: {
                                flex: 1,
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                fontSize: `${ve}px`,
                                fontWeight: 400,
                                lineHeight: E ? "16px" : "24px",
                                color: _,
                                fontFamily: "inherit"
                              }
                            }
                          ),
                          /* @__PURE__ */ o(
                            "button",
                            {
                              onClick: () => C(p),
                              style: {
                                flexShrink: 0,
                                backgroundColor: J,
                                color: U,
                                border: "none",
                                borderRadius: `${g.askButtonBorderRadius}px`,
                                padding: E ? "6px 8px" : `${g.askButtonPaddingY}px ${g.askButtonPaddingX}px`,
                                fontSize: `${ae}px`,
                                fontWeight: 500,
                                lineHeight: E ? "16px" : "32px",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                fontFamily: "inherit"
                              },
                              children: g.askButtonText
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ o(
                      "div",
                      {
                        onClick: b,
                        style: { flexShrink: 0, cursor: "pointer", padding: "4px" },
                        role: "button",
                        "aria-label": "Close search panel",
                        children: /* @__PURE__ */ o(Aa, { size: V, color: re })
                      }
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ u(
            "div",
            {
              style: {
                ...E ? { flex: 1 } : {},
                padding: `${g.contentPaddingTop}px ${xe}px ${xe}px`,
                overflow: "auto"
              },
              children: [
                ut && /* @__PURE__ */ o(
                  "p",
                  {
                    style: {
                      margin: `0 0 ${g.sectionGap}px`,
                      fontSize: `${g.sectionHeaderFontSize}px`,
                      fontWeight: Ne,
                      lineHeight: "32px",
                      color: q,
                      textAlign: Qe ? "center" : void 0
                    },
                    children: Qe ? g.noResultsWithSuggestionsText : g.noResultsText
                  }
                ),
                Fe && /* @__PURE__ */ o($, { children: E ? (
                  /* ---- Mobile: stacked single column ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: `${g.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Nt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: Zt()
                          }
                        ),
                        Vt(),
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Lt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: Ut()
                          }
                        ),
                        Vt(),
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Rt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: _t()
                          }
                        )
                      ]
                    }
                  )
                ) : (
                  /* ---- Desktop: 3-column layout ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "grid",
                        gridTemplateColumns: "minmax(200px, 1fr) minmax(350px, 2fr) minmax(200px, 1fr)",
                        gap: `${g.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Nt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: Zt()
                          }
                        ),
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Lt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: Ut()
                          }
                        ),
                        /* @__PURE__ */ o(
                          Z,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Rt,
                            editValues: g,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: M,
                            children: _t()
                          }
                        )
                      ]
                    }
                  )
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: _n,
      editValues: g,
      onEditChange: I,
      onSave: W ? v : void 0,
      isSaving: y,
      themeColors: k,
      themeFonts: M,
      children: ir
    }
  );
}, Na = {
  // Pill styling (matching Figma design)
  pillBgColor: a("background"),
  pillBgColorHover: a("primary"),
  pillTextColor: a("textPrimary"),
  pillTextColorHover: a("background"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: a("primary"),
  pillBorderColorHover: a("primary"),
  // Selected state styling
  pillBgColorSelected: a("primary"),
  pillTextColorSelected: a("secondary"),
  pillBorderColorSelected: a("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Fo = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillTextColorHover", label: "Pill Hover Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  { key: "pillBorderColorHover", label: "Border Hover Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: ot
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], As = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const { state: i, isLoading: l, isSaving: c, handleEditChange: p, handleSave: d, themeColors: h, resolveColor: m, canSave: b } = te(t, { ...Na, ...e }, Fo);
  if (l)
    return /* @__PURE__ */ o($, {});
  const B = r(i, m);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Fo,
      editValues: i,
      onEditChange: p,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: h,
      children: B
    }
  );
}, La = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ra = {
  // Background
  backgroundColor: a("transparent"),
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: a("background"),
  // Badge styling (cart count)
  badgeBgColor: a("primary"),
  badgeTextColor: a("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, To = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...pe],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], Hs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...Ra, ...e },
    To
  ), z = i.titleFontFamily, C = z && z !== "inherit" ? m[z] : null, x = C && C.format === "google" ? C.url : null;
  if (Q(() => {
    x && La(x);
  }, [x]), l)
    return /* @__PURE__ */ o($, {});
  const f = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", S = C && C.format !== "system" && C.format !== "google", F = `header-${t || "default"}`, g = `
    ${S ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${F} [data-title-text] { font-family: ${f} !important; }` : ""}
  `.trim(), N = {
    ...i,
    titleFontFamilyCss: f
  }, y = /* @__PURE__ */ u($, { children: [
    g && /* @__PURE__ */ o("style", { children: g }),
    r(N, b)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: To,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: y
    }
  );
}, Wa = ({ className: e }) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ o("g", { clipPath: "url(#clip0_concierge_close)", children: /* @__PURE__ */ o(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.23815 8.00015L14.7435 2.49459C15.0855 2.15283 15.0855 1.5983 14.7435 1.25654C14.4014 0.914486 13.8475 0.914486 13.5055 1.25654L8.00015 6.7621L2.49453 1.25654C2.15249 0.914486 1.59858 0.914486 1.25653 1.25654C0.914489 1.5983 0.914489 2.15283 1.25653 2.49459L6.76215 8.00015L1.25653 13.5057C0.914489 13.8475 0.914489 14.402 1.25653 14.7438C1.42755 14.9145 1.65168 15 1.87553 15C2.09938 15 2.32351 14.9145 2.49453 14.7435L8.00015 9.2379L13.5055 14.7435C13.6765 14.9145 13.9006 15 14.1245 15C14.3483 15 14.5725 14.9145 14.7435 14.7435C15.0855 14.4017 15.0855 13.8472 14.7435 13.5054L9.23815 8.00015Z",
          fill: "currentColor",
          stroke: "currentColor",
          strokeWidth: "0.5"
        }
      ) }),
      /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "clip0_concierge_close", children: /* @__PURE__ */ o("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), Da = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Mo = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 16,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: a("textPrimary"),
  maximizeButtonColor: a("textPrimary"),
  historyButtonColor: a("textPrimary")
}, Eo = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  {
    key: "maximizeButtonColor",
    label: "Maximize Button Color",
    type: "color"
  },
  {
    key: "historyButtonColor",
    label: "History Button Color",
    type: "color"
  }
], Oa = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, Ns = ({
  showMaximize: e = !0,
  isMaximized: t = !1,
  onMaximize: n,
  onMinimize: r,
  onClose: i,
  onHistoryClick: l,
  onNewConversationClick: c,
  showNewConversation: p = !0,
  newConversationIcon: d,
  title: h = "CONCIERGE",
  widgetId: m = "concierge-widget-header",
  displayName: b = "Concierge Header",
  initialState: B = {},
  // mobileBrandLogoUrl,
  // showMobileLogo = false,
  bottomContent: z
}) => {
  const {
    state: C,
    isLoading: x,
    isSaving: f,
    handleEditChange: S,
    handleSave: F,
    themeColors: g,
    themeFonts: N,
    resolveColor: y,
    canSave: I
  } = te(
    m,
    {
      ...Mo,
      titleContent: (h == null ? void 0 : h.toUpperCase()) || Mo.titleContent,
      ...B
    },
    Eo
  ), v = C.titleFontFamily, k = v && v !== "inherit" ? N[v] : null, M = k && k.format === "google" ? k.url : null;
  if (Q(() => {
    M && Da(M);
  }, [M]), x)
    return /* @__PURE__ */ o(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4",
        "data-concierge-header": !0
      }
    );
  const H = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", P = k && k.format !== "system" && k.format !== "google", W = `concierge-header-${m || "default"}`, w = (D) => {
    if (D.startsWith("#")) {
      const X = D.slice(1), T = X.length === 3 ? parseInt(X[0] + X[0], 16) : parseInt(X.slice(0, 2), 16), R = X.length === 3 ? parseInt(X[1] + X[1], 16) : parseInt(X.slice(2, 4), 16), j = X.length === 3 ? parseInt(X[2] + X[2], 16) : parseInt(X.slice(4, 6), 16);
      return `rgba(${T}, ${R}, ${j}, 0.7)`;
    }
    return D.startsWith("rgba") ? D.replace(/,\s*[\d.]+\)$/, ", 0.7)") : D.startsWith("rgb") ? D.replace("rgb", "rgba").replace(")", ", 0.7)") : D;
  }, E = /* @__PURE__ */ u(
    "div",
    {
      style: {
        borderBottom: "1px solid #F3F3F3",
        boxShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ o("style", { children: `
        ${P ? `
          @font-face {
            font-family: "${k.name}";
            src: url("${k.url}") format("${k.format}");
            font-display: swap;
          }
        ` : ""}
        ${H !== "inherit" ? `.${W} [data-title-text] { font-family: ${H} !important; }` : ""}
        .${W} .concierge-maximize-icon {
          color: ${y(C.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-maximize-icon:hover {
          color: ${w(y(C.maximizeButtonColor))};
        }
        .${W} .concierge-close-icon {
          color: ${y(C.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-close-icon:hover {
          color: ${w(y(C.closeButtonColor))};
        }
        .${W} .concierge-history-icon {
          color: ${y(C.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-history-icon:hover {
          color: ${w(y(C.historyButtonColor))};
        }
        .${W} .concierge-new-conversation-icon {
          color: ${y(C.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-new-conversation-icon:hover {
          color: ${w(y(C.historyButtonColor))};
        }
      ` }),
        /* @__PURE__ */ u(
          "div",
          {
            className: `tw:flex tw:items-center tw:justify-between tw:min-h-[44px] ${W}`,
            style: { padding: 16 },
            "data-concierge-header": !0,
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-0 tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: [
                    t && r && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: r,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Minimize to widget",
                        children: /* @__PURE__ */ o(Rr, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    !t && e && n && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: n,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Expand to full view",
                        children: /* @__PURE__ */ o(Ar, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    p && c && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: c,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Create new conversation",
                        children: /* @__PURE__ */ o("span", { className: "tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 concierge-new-conversation-icon [&>svg]:tw:block", children: d ?? /* @__PURE__ */ o(Nr, { className: "tw:w-4 tw:h-4 tw:shrink-0" }) })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ o(
                "span",
                {
                  "data-title-text": !0,
                  className: "tw:flex tw:items-center tw:justify-center",
                  style: {
                    fontSize: `${C.titleFontSize}px`,
                    fontWeight: Oa(C.titleFontWeight),
                    fontFamily: H !== "inherit" ? H : void 0,
                    color: y(C.titleColor),
                    letterSpacing: `${C.titleLetterSpacing}px`,
                    textTransform: C.titleTextTransform,
                    textAlign: "center",
                    lineHeight: 1,
                    flex: 1
                  },
                  children: C.titleContent
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1 tw:justify-end tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: /* @__PURE__ */ o(
                    "button",
                    {
                      onClick: i,
                      className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                      style: { padding: 8 },
                      "aria-label": "Close",
                      children: /* @__PURE__ */ o(Wa, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-close-icon" })
                    }
                  )
                }
              )
            ]
          }
        ),
        z
      ]
    }
  );
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: m,
      displayName: b,
      editFields: Eo,
      editValues: C,
      onEditChange: S,
      onSave: I ? F : void 0,
      isSaving: f,
      themeColors: g,
      themeFonts: N,
      children: E
    }
  );
}, Vn = `
@keyframes bc-skel-pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

/* Responsive concierge shell skeleton:
   - Desktop: left sidebar + content
   - Mobile: top header (hamburger) + content
*/
.bc-concierge-skel-shell{ position:relative; display:flex; flex-direction:row; height:100dvh; max-height:100dvh; min-height:-webkit-fill-available; overflow:hidden; background:#fff; box-sizing:border-box; }
.bc-concierge-skel-desktopSidebar{ display:flex; }
.bc-concierge-skel-mobileHeader{ display:none; }
.bc-concierge-skel-desktopContent{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-mobileContent{ display:none; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentShell{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentDesktopOnly{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentMobileOnly{ display:none; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-footerHint{ position:absolute; bottom:24px; left:0; right:0; display:flex; justify-content:center; pointer-events:none; }

@media (max-width: 767px){
  .bc-concierge-skel-shell{ flex-direction:column; }
  .bc-concierge-skel-desktopSidebar{ display:none; }
  .bc-concierge-skel-mobileHeader{ display:flex; }
  .bc-concierge-skel-desktopContent{ display:none; }
  .bc-concierge-skel-mobileContent{ display:flex; }
  .bc-concierge-skel-contentDesktopOnly{ display:none; }
  .bc-concierge-skel-contentMobileOnly{ display:flex; }
  .bc-concierge-skel-footerHint{ display:none; }
}
`, ja = "bc-skel-pulse 2.8s cubic-bezier(0.4, 0, 0.2, 1) infinite", ce = (e, t, n, r = "0s", i = "#f0f0f0") => ({
  width: e,
  height: t,
  backgroundColor: i,
  borderRadius: n,
  animation: ja,
  animationDelay: r
}), Ga = "#ffffff", $a = "#ffffff", Ya = "#f8f8f8", wt = (e, t = "0s") => /* @__PURE__ */ o("div", { style: ce(e, 40, 20, t) }), qn = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden"
    },
    children: [
      /* @__PURE__ */ o("div", { style: { flex: "1 1 0", minHeight: 0 } }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            padding: 24,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ o("div", { style: ce(40, 40, 20) }),
            /* @__PURE__ */ o("div", { style: ce(140, 18, 9, "0.05s") }),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ o("div", { style: ce(320, 24, 12, "0.1s") }),
              /* @__PURE__ */ o("div", { style: ce(260, 24, 12, "0.15s") })
            ] }),
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  ...ce("100%", 100, 16, "0.2s"),
                  maxWidth: 560,
                  backgroundColor: "#f8f8f8",
                  marginTop: 8
                }
              }
            ),
            /* @__PURE__ */ o("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginTop: 4 }, children: [180, 220, 160, 200].map((e, t) => /* @__PURE__ */ o("div", { style: ce(e, 40, 20, `${0.25 + 0.05 * t}s`) }, t)) })
          ]
        }
      ),
      /* @__PURE__ */ o("div", { style: { flex: "1 1 0", minHeight: 0 } })
    ]
  }
), Qa = () => /* @__PURE__ */ u("div", { className: "bc-concierge-skel-contentShell", children: [
  /* @__PURE__ */ o("style", { children: Vn }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-contentDesktopOnly", children: /* @__PURE__ */ o(qn, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-contentMobileOnly", children: /* @__PURE__ */ o(er, {}) })
] }), Kn = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      width: 48,
      flexShrink: 0,
      borderRight: "1px solid #e8e8ed",
      alignSelf: "stretch",
      minHeight: 0,
      boxSizing: "content-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 24,
      gap: 16
    },
    children: [
      /* @__PURE__ */ o("div", { style: ce(24, 24, 12) }),
      /* @__PURE__ */ o("div", { style: { height: 8 } }),
      /* @__PURE__ */ o("div", { style: ce(24, 24, 6, "0.1s") }),
      /* @__PURE__ */ o("div", { style: ce(24, 24, 6, "0.2s") })
    ]
  }
), Xa = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      height: 80,
      // mirrors ConciergeHomeMobileNavWidget default navHeight
      flexShrink: 0,
      boxSizing: "border-box",
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "24px 24px",
      // mirrors default navPaddingY/X
      backgroundColor: $a
    },
    children: [
      /* @__PURE__ */ o("div", { style: ce(20, 20, 6) }),
      /* @__PURE__ */ o("div", { style: { flex: 1, minWidth: 0, display: "flex", justifyContent: "center", padding: "0 8px" }, children: /* @__PURE__ */ o("div", { style: ce(79, 18, 6, "0.08s") }) }),
      /* @__PURE__ */ o("div", { style: ce(20, 20, 6, "0.14s") })
    ]
  }
), er = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flex: 1,
      minHeight: 0,
      boxSizing: "border-box",
      overflow: "hidden",
      position: "relative",
      backgroundColor: Ga
    },
    children: [
      /* @__PURE__ */ o("div", { style: { flex: 1 } }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "16px 16px",
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ o("div", { style: ce(24, 24, 12) }),
            /* @__PURE__ */ o("div", { style: { height: 14 } }),
            /* @__PURE__ */ o("div", { style: ce(52, 16, 8, "0.05s") }),
            /* @__PURE__ */ o("div", { style: { height: 10 } }),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ o("div", { style: ce("min(84vw, 360px)", 22, 11, "0.1s") }),
              /* @__PURE__ */ o("div", { style: ce("min(76vw, 300px)", 22, 11, "0.15s") })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ o("div", { style: { flex: 1 } }),
      /* @__PURE__ */ o("div", { style: { flexShrink: 0, padding: "0 8px 0 8px" }, children: /* @__PURE__ */ u("div", { style: { display: "flex", gap: 10, overflow: "hidden", padding: "0 8px" }, children: [
        wt(244, "0.22s"),
        wt(198, "0.28s"),
        wt(186, "0.34s")
      ] }) }),
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            flexShrink: 0,
            paddingTop: 16,
            paddingLeft: 8,
            paddingRight: 8,
            paddingBottom: "max(24px, env(safe-area-inset-bottom))"
          },
          children: /* @__PURE__ */ u(
            "div",
            {
              style: {
                width: "100%",
                height: 100,
                maxWidth: 900,
                padding: "14px 14px 12px 14px",
                borderRadius: 18,
                backgroundColor: Ya,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              },
              children: [
                /* @__PURE__ */ o("div", { style: ce(98, 12, 6, "0.18s") }),
                /* @__PURE__ */ u("div", { style: { display: "flex", justifyContent: "flex-end", gap: 8 }, children: [
                  /* @__PURE__ */ o("div", { style: ce(18, 18, 9, "0.22s") }),
                  /* @__PURE__ */ o("div", { style: ce(18, 18, 9, "0.26s") }),
                  /* @__PURE__ */ o("div", { style: ce(20, 20, 10, "0.3s") })
                ] })
              ]
            }
          )
        }
      )
    ]
  }
), Ls = () => /* @__PURE__ */ u("div", { className: "bc-concierge-skel-shell", children: [
  /* @__PURE__ */ o("style", { children: Vn }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-mobileHeader", children: /* @__PURE__ */ o(Xa, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-desktopSidebar", children: /* @__PURE__ */ o(Kn, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-desktopContent", children: /* @__PURE__ */ o(qn, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-mobileContent", children: /* @__PURE__ */ o(er, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-footerHint", children: /* @__PURE__ */ o("div", { style: ce(120, 20, 6, "0.4s") }) })
] }), Ja = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Za = {
  // Logo / Brand Icon
  logoIcon: "default",
  logoIconSize: 24,
  // Brand Link
  brandLinkText: "example.com",
  brandLinkPrefix: "Visit ",
  brandLinkFontSize: 14,
  brandLinkColor: a("textPrimary"),
  // Layout
  expandedWidth: 248,
  collapsedWidth: 48,
  expandedBgColor: a("background"),
  collapsedBgColor: a("secondary"),
  borderColor: a("borderColor"),
  // Navigation Icons
  sidebarIconSize: 24,
  sidebarIconColor: a("textPrimary"),
  composeIconSize: 20,
  composeIconColor: a("textPrimary"),
  closeIconColor: a("textPrimary"),
  chatsIconSize: 20,
  chatsIconColor: a("textPrimary"),
  // Labels
  openSidebarLabel: "Open sidebar",
  closeSidebarLabel: "Close sidebar",
  newChatLabel: "New chat",
  chatsLabel: "Chats",
  signOutLabel: "Sign out",
  labelFontSize: 14,
  labelFontWeight: "medium",
  labelColor: a("textPrimary"),
  // Tooltips
  tooltipBgColor: a("textPrimary"),
  tooltipTextColor: a("secondary"),
  tooltipFontSize: 12,
  tooltipBorderRadius: 8,
  // Chat History
  chatHistoryTitle: "Chat history",
  chatHistoryTitleFontSize: 14,
  chatHistoryTitleFontWeight: "medium",
  chatHistoryTitleColor: a("textPrimary"),
  chatItemFontSize: 14,
  chatItemFontWeight: "medium",
  chatItemColor: a("textPrimary"),
  chatItemActiveBgColor: a("background"),
  chatItemHoverBgColor: a("background"),
  chatItemPaddingX: 8,
  chatItemPaddingY: 4,
  chatItemBorderRadius: 5,
  chatItemLineClamp: 1,
  // Typography
  fontFamily: "inherit",
  // Avatar
  avatarSize: 32,
  avatarBgColor: a("textPrimary"),
  avatarTextColor: a("secondary"),
  avatarFontSize: 12.8,
  avatarFontWeight: "semibold"
}, it = pe.slice(0, 4), Ao = [
  // ── Logo / Brand Icon ──────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  {
    key: "logoIconSize",
    label: "Icon Size",
    type: "number",
    min: 0,
    max: 100,
    step: 1,
    group: "Logo"
  },
  // ── Brand Link ─────────────────────────────────────────────────────────
  {
    key: "brandLinkPrefix",
    label: "Prefix Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Brand Link"
  },
  {
    key: "brandLinkColor",
    label: "Color",
    type: "color",
    group: "Brand Link"
  },
  // ── Layout ─────────────────────────────────────────────────────────────
  {
    key: "expandedWidth",
    label: "Expanded Width",
    type: "number",
    min: 200,
    max: 320,
    step: 4,
    group: "Layout"
  },
  {
    key: "collapsedWidth",
    label: "Collapsed Width",
    type: "number",
    min: 36,
    max: 56,
    step: 2,
    group: "Layout"
  },
  {
    key: "expandedBgColor",
    label: "Expanded Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "collapsedBgColor",
    label: "Collapsed Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "borderColor",
    label: "Border Color",
    type: "color",
    group: "Layout"
  },
  // ── Navigation Icons ───────────────────────────────────────────────────
  {
    key: "sidebarIconSize",
    label: "Sidebar Icon Size",
    type: "number",
    min: 16,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "sidebarIconColor",
    label: "Sidebar Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "composeIconSize",
    label: "Compose Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "composeIconColor",
    label: "Compose Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "chatsIconSize",
    label: "Chats Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "chatsIconColor",
    label: "Chats Icon Color",
    type: "color",
    group: "Icons"
  },
  // ── Labels ─────────────────────────────────────────────────────────────
  {
    key: "openSidebarLabel",
    label: "Open Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "closeSidebarLabel",
    label: "Close Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "newChatLabel",
    label: "New Chat Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "chatsLabel",
    label: "Chats Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "signOutLabel",
    label: "Sign Out Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "labelFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Labels"
  },
  {
    key: "labelFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...it],
    group: "Labels"
  },
  { key: "labelColor", label: "Color", type: "color", group: "Labels" },
  // ── Tooltips ───────────────────────────────────────────────────────────
  {
    key: "tooltipBgColor",
    label: "Background",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipTextColor",
    label: "Text Color",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Tooltips"
  },
  {
    key: "tooltipBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Tooltips"
  },
  // ── Chat History ───────────────────────────────────────────────────────
  {
    key: "chatHistoryTitle",
    label: "Section Title",
    type: "text",
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...it],
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemFontSize",
    label: "Item Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemFontWeight",
    label: "Item Font Weight",
    type: "options",
    options: [...it],
    group: "Chat History"
  },
  {
    key: "chatItemColor",
    label: "Item Text Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemActiveBgColor",
    label: "Active Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemBorderRadius",
    label: "Item Border Radius",
    type: "number",
    min: 0,
    max: 12,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemLineClamp",
    label: "Item Max Lines",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Chat History"
  },
  // ── Typography ─────────────────────────────────────────────────────────
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // ── Avatar ─────────────────────────────────────────────────────────────
  {
    key: "avatarSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Avatar"
  },
  {
    key: "avatarBgColor",
    label: "Background",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarTextColor",
    label: "Text Color",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarFontSize",
    label: "Font Size",
    type: "number",
    min: 6,
    max: 14,
    step: 1,
    group: "Avatar"
  },
  {
    key: "avatarFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...it],
    group: "Avatar"
  }
], Rs = ({
  widgetId: e = "concierge-sidebar",
  displayName: t = "Concierge Sidebar",
  initialState: n = {},
  wrapperStyle: r,
  children: i
}) => {
  const {
    state: l,
    isLoading: c,
    isSaving: p,
    handleEditChange: d,
    handleSave: h,
    themeColors: m,
    themeFonts: b,
    themeIcons: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ...Za, ...n },
    Ao
  ), x = l.logoIcon && l.logoIcon !== "default" ? B[l.logoIcon] : null, f = {
    logoIconUrl: x ? x.url : null
  }, S = l.fontFamily, F = S && S !== "inherit" ? b[S] : null, g = F && F.format === "google" ? F.url : null;
  if (Q(() => {
    g && Ja(g);
  }, [g]), c)
    return /* @__PURE__ */ o(Kn, {});
  const N = F ? F.format === "system" ? F.url : `"${F.name}", sans-serif` : "inherit", I = F && F.format !== "system" && F.format !== "google" ? `@font-face {
        font-family: "${F.name}";
        src: url("${F.url}") format("${F.format}");
        font-display: swap;
      }` : "", v = {
    ...l,
    fontFamilyCss: N
  }, k = /* @__PURE__ */ u($, { children: [
    I && /* @__PURE__ */ o("style", { children: I }),
    i(v, f, z)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: Ao,
      editValues: l,
      onEditChange: d,
      onSave: C ? h : void 0,
      isSaving: p,
      themeColors: m,
      themeFonts: b,
      themeIcons: B,
      wrapperStyle: r,
      children: k
    }
  );
}, Ua = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, _a = {
  pageTitle: "Chat History",
  pageTitleFontSize: 24,
  pageTitleFontWeight: "semibold",
  pageTitleColor: a("textPrimary"),
  searchPlaceholder: "Search your chats",
  searchBgColor: a("background"),
  searchBorderColor: a("borderColor"),
  searchTextColor: a("textPrimary"),
  searchIconColor: a("textSecondary"),
  searchBorderRadius: 100,
  chatItemBgColor: a("background"),
  chatItemHoverBgColor: a("secondary"),
  chatItemSelectedBgColor: a("secondary"),
  chatItemTitleColor: a("textPrimary"),
  chatItemPreviewColor: a("textSecondary"),
  chatItemTimestampColor: a("textPrimary"),
  chatItemTitleFontSize: 14,
  chatItemPreviewFontSize: 12,
  chatItemBorderRadius: 10,
  chatItemPaddingX: 24,
  chatItemPaddingY: 16,
  groupHeaderColor: a("textSecondary"),
  groupHeaderFontSize: 14,
  groupHeaderFontWeight: "medium",
  selectionCheckboxColor: a("primary"),
  bulkActionBarBgColor: a("background"),
  bulkActionBarTextColor: a("textPrimary"),
  deleteButtonColor: a("error"),
  deleteButtonHoverColor: a("error"),
  pageBgColor: a("background"),
  newChatButtonBgColor: a("primary"),
  newChatButtonTextColor: a("buttonText"),
  newChatButtonBorderRadius: 100,
  fontFamily: "inherit"
}, Ho = pe.slice(0, 4), No = [
  // ── Page Header
  { key: "pageTitle", label: "Page Title", type: "text", group: "Header" },
  {
    key: "pageTitleFontSize",
    label: "Title Size",
    type: "number",
    min: 18,
    max: 40,
    step: 1,
    group: "Header"
  },
  {
    key: "pageTitleFontWeight",
    label: "Title Weight",
    type: "options",
    options: [...Ho],
    group: "Header"
  },
  {
    key: "pageTitleColor",
    label: "Title Color",
    type: "color",
    group: "Header"
  },
  // ── Search Bar
  {
    key: "searchPlaceholder",
    label: "Placeholder",
    type: "text",
    group: "Search"
  },
  {
    key: "searchBgColor",
    label: "Background",
    type: "color",
    group: "Search"
  },
  {
    key: "searchBorderColor",
    label: "Border Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchTextColor",
    label: "Text Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchIconColor",
    label: "Icon Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Search"
  },
  // ── Chat Items
  {
    key: "chatItemBgColor",
    label: "Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemSelectedBgColor",
    label: "Selected Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemPreviewColor",
    label: "Preview Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTimestampColor",
    label: "Timestamp Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTitleFontSize",
    label: "Title Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Chat Items"
  },
  {
    key: "chatItemPreviewFontSize",
    label: "Preview Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Chat Items"
  },
  {
    key: "chatItemBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat Items"
  },
  {
    key: "chatItemPaddingX",
    label: "Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Chat Items"
  },
  {
    key: "chatItemPaddingY",
    label: "Padding Y",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Chat Items"
  },
  // ── Group Headers
  {
    key: "groupHeaderColor",
    label: "Color",
    type: "color",
    group: "Group Headers"
  },
  {
    key: "groupHeaderFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Group Headers"
  },
  {
    key: "groupHeaderFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...Ho],
    group: "Group Headers"
  },
  // ── Selection / Bulk Actions
  {
    key: "selectionCheckboxColor",
    label: "Checkbox Color",
    type: "color",
    group: "Selection"
  },
  {
    key: "bulkActionBarBgColor",
    label: "Action Bar BG",
    type: "color",
    group: "Selection"
  },
  {
    key: "bulkActionBarTextColor",
    label: "Action Bar Text",
    type: "color",
    group: "Selection"
  },
  {
    key: "deleteButtonColor",
    label: "Delete Button",
    type: "color",
    group: "Selection"
  },
  // ── Page Background
  { key: "pageBgColor", label: "Page BG", type: "color", group: "Layout" },
  // ── New Chat Button
  {
    key: "newChatButtonBgColor",
    label: "Background",
    type: "color",
    group: "New Chat Button"
  },
  {
    key: "newChatButtonTextColor",
    label: "Text Color",
    type: "color",
    group: "New Chat Button"
  },
  {
    key: "newChatButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "New Chat Button"
  },
  // ── Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  }
], Ws = ({
  widgetId: e = "chat-history",
  displayName: t = "Chat History",
  initialState: n = {},
  wrapperStyle: r,
  children: i
}) => {
  const {
    state: l,
    isLoading: c,
    isSaving: p,
    handleEditChange: d,
    handleSave: h,
    themeColors: m,
    themeFonts: b,
    themeIcons: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ..._a, ...n },
    No
  ), x = l.fontFamily, f = x && x !== "inherit" ? b[x] : null, S = f ? null : b.body || Object.values(b)[0] || null, F = f || S, g = F && F.format === "google" ? F.url : null;
  if (Q(() => {
    g && Ua(g);
  }, [g]), c)
    return /* @__PURE__ */ o($, {});
  const N = F ? F.format === "system" ? F.url : `"${F.name}", sans-serif` : "inherit", I = F && F.format !== "system" && F.format !== "google" ? `@font-face {
        font-family: "${F.name}";
        src: url("${F.url}") format("${F.format}");
        font-display: swap;
      }` : "", v = {
    ...l,
    fontFamilyCss: N
  }, k = /* @__PURE__ */ u($, { children: [
    I && /* @__PURE__ */ o("style", { children: I }),
    i(v, z)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: No,
      editValues: l,
      onEditChange: d,
      onSave: C ? h : void 0,
      isSaving: p,
      themeColors: m,
      themeFonts: b,
      themeIcons: B,
      wrapperStyle: r,
      children: k
    }
  );
}, Va = {
  filled: {
    backgroundColor: a("primary"),
    backgroundColorHover: a("primary"),
    iconColor: a("secondary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.25,
    shadowBlur: 50,
    shadowSpread: -12,
    shadowOffsetY: 25
  },
  light: {
    backgroundColor: a("background"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.12,
    shadowBlur: 24,
    shadowSpread: -4,
    shadowOffsetY: 8
  },
  outlined: {
    backgroundColor: a("background"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 1.5,
    borderColor: a("textPrimary"),
    shadowOpacity: 0,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetY: 0
  }
}, qa = {
  "rounded-square": { borderRadius: 25 },
  circle: { borderRadius: 50 }
}, Ka = {
  // Preset selectors
  buttonShape: "circle",
  buttonStyle: "filled",
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors) — derived from "filled" style
  backgroundColor: a("primary"),
  backgroundColorHover: a("primary"),
  iconColor: a("secondary"),
  // Border — derived from "filled" style
  borderWidth: 0,
  borderColor: a("transparent"),
  // Shape — derived from "circle" shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow — derived from "filled" style
  shadowColor: a("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconStyle: "chat-ai",
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11,
  // Feature Prompt Pill
  featurePromptBgColor: a("primary"),
  featurePromptTextColor: a("secondary"),
  featurePromptBorderRadius: 12,
  featurePromptFontSize: 14,
  featurePromptFontWeight: 500
}, Lo = [
  // --- Preset selectors ---
  {
    key: "iconStyle",
    label: "Icon",
    type: "options",
    options: [
      { label: "Chat AI", value: "chat-ai" },
      { label: "Search Sparkle", value: "search-sparkle" },
      { label: "Three Sparkles", value: "three-sparkles" },
      { label: "Diamond Sparkles", value: "diamond-sparkles" },
      { label: "Search Star", value: "search-star" },
      { label: "Search Sparkle Alt", value: "search-sparkle-alt" }
    ]
  },
  {
    key: "buttonShape",
    label: "Shape",
    type: "options",
    options: [
      { label: "Circle", value: "circle" },
      { label: "Rounded Square", value: "rounded-square" }
    ]
  },
  {
    key: "buttonStyle",
    label: "Style",
    type: "options",
    options: [
      { label: "Filled", value: "filled" },
      { label: "Light", value: "light" },
      { label: "Outlined", value: "outlined" }
    ]
  },
  // --- Size & Position ---
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Size & Position"
  },
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ],
    group: "Size & Position"
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  // --- Colors ---
  { key: "backgroundColor", label: "Background Color", type: "color", group: "Colors" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color", group: "Colors" },
  { key: "iconColor", label: "Icon Color", type: "color", group: "Colors" },
  // --- Shape ---
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shape"
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 4,
    step: 0.5,
    group: "Shape"
  },
  { key: "borderColor", label: "Border Color", type: "color", group: "Shape" },
  // --- Shadow ---
  { key: "shadowColor", label: "Shadow Color", type: "color", group: "Shadow" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05,
    group: "Shadow"
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5,
    group: "Shadow"
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2,
    group: "Shadow"
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shadow"
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  },
  // Feature Prompt Pill
  {
    key: "featurePromptBgColor",
    label: "Prompt Pill Background",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptTextColor",
    label: "Prompt Pill Text Color",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptBorderRadius",
    label: "Prompt Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontSize",
    label: "Prompt Pill Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontWeight",
    label: "Prompt Pill Font Weight",
    type: "number",
    min: 300,
    max: 700,
    step: 100,
    group: "Feature Prompt"
  }
], el = (e) => {
  const { position: t, horizontalOffset: n, verticalOffset: r, size: i } = e, l = {
    position: "fixed",
    zIndex: 2147483647,
    // Max z-index to ensure it's on top
    minWidth: 0,
    minHeight: 0
  };
  return t.startsWith("bottom") ? l.bottom = r + i - 8 : l.top = r - 8, t.endsWith("left") ? l.left = n + i - 8 : l.right = n - 8, l;
}, Ds = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const [i, l] = O(!1), [c, p] = O({ x: 0, y: 0 }), [d, h] = O(null), [m, b] = O(!1), [B, z] = O(!1), C = le(null), x = Qt(), {
    state: f,
    isLoading: S,
    isSaving: F,
    handleEditChange: g,
    handleSave: N,
    themeColors: y,
    resolveColor: I,
    canSave: v,
    studioLockedKeys: k
  } = te(t, { ...Ka, ...e }, Lo), M = ge(
    (T, R) => {
      if (g(T, R), T === "buttonStyle") {
        const j = Va[R];
        j && Object.entries(j).forEach(([L, G]) => {
          g(L, G);
        });
      }
      if (T === "buttonShape") {
        const j = qa[R];
        j && g("borderRadius", j.borderRadius);
      }
    },
    [g]
  ), H = ge(() => d ? JSON.stringify(f) !== JSON.stringify(d) : !1, [f, d]);
  if (Q(() => t ? Hn((R) => {
    R !== t && i && (H() ? b(!0) : l(!1));
  }) : void 0, [t, i, H]), S)
    return /* @__PURE__ */ o($, {});
  const P = r(f, I);
  if (!x)
    return /* @__PURE__ */ o($, { children: P });
  const W = () => {
    if (C.current) {
      const T = C.current.getBoundingClientRect(), R = window.innerWidth, j = window.innerHeight, L = 620, G = 450, Y = 10, _ = j - T.bottom, J = T.top, U = R - T.left, re = T.right;
      let q;
      _ >= G + Y ? q = T.bottom + Y : J >= G + Y ? q = T.top - G - Y : _ >= J ? q = Math.max(Y, j - G - Y) : q = Math.max(Y, T.top - G - Y);
      let ne;
      U >= L ? ne = T.left : re >= L ? ne = T.right - L : ne = Math.max(Y, Math.min(R - L - Y, T.left)), ne = Math.max(Y, Math.min(ne, R - L - Y)), q = Math.max(Y, Math.min(q, j - G - Y)), p({ x: ne, y: q });
    }
    h({ ...f }), l(!0), t && An(t);
  }, w = () => {
    d && Object.keys(d).forEach((T) => {
      M(T, d[T]);
    });
  }, E = () => {
    N && v && N(), h({ ...f });
  }, D = () => {
    b(!1), l(!1);
  }, X = () => {
    E(), b(!1), l(!1);
  };
  return /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${s.white};
          border: 1px solid ${s.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${s.blue_light};
          border-color: ${s.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        onMouseEnter: () => z(!0),
        onMouseLeave: () => z(!1),
        style: { display: "contents" },
        children: [
          P,
          /* @__PURE__ */ o(
            "button",
            {
              ref: C,
              className: `floating-button-edit-icon ${B || i ? "visible" : ""}`,
              style: el(f),
              onMouseDown: (T) => {
                T.stopPropagation();
              },
              onClick: (T) => {
                T.stopPropagation(), T.preventDefault(), W();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ o(vn, { size: 16, color: s.gray_dark })
            }
          )
        ]
      }
    ),
    i && /* @__PURE__ */ o(
      Nn,
      {
        widgetId: t,
        displayName: n,
        fields: Lo,
        values: f,
        initialValues: d || void 0,
        onChange: M,
        onClose: () => l(!1),
        onReset: w,
        screenPosition: c,
        onSave: E,
        isSaving: F,
        themeColors: y,
        studioLockedKeys: k
      }
    ),
    m && /* @__PURE__ */ o(
      et,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: X,
        onCancel: D,
        isLoading: F
      }
    )
  ] });
}, tl = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: a("background"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: a("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: a("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: a("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: a("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: a("background"),
  suggestionPillBgColor: a("transparent"),
  suggestionPillBgColorHover: a("background"),
  suggestionPillTextColor: a("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Ro = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...pe]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], Os = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    resolveColor: m,
    canSave: b
  } = te(
    t,
    { ...tl, ...e },
    Ro
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const B = r(i, m);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Ro,
      editValues: i,
      onEditChange: p,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: h,
      children: B
    }
  );
}, ol = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, nl = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: a("secondary"),
  pillBorderColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: a("secondary"),
  arrowBorderColor: a("secondary"),
  arrowIconColor: a("textPrimary"),
  // Title
  titleColor: a("textPrimary"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Wo = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], js = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B,
    getEditValues: z
  } = te(
    t,
    { ...nl, ...e },
    Wo
  ), C = i.titleFontFamily, x = C && C !== "inherit" ? m[C] : null, f = x && x.format === "google" ? x.url : null;
  if (Q(() => {
    f && ol(f);
  }, [f]), l)
    return /* @__PURE__ */ o($, {});
  const S = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", F = x && x.format !== "system" && x.format !== "google", g = `trending-card-${t || "default"}`, N = `
    ${F ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${g} [data-title-text] { font-family: ${S} !important; }` : ""}
  `.trim(), y = {
    ...i,
    titleFontFamilyCss: S
  }, I = /* @__PURE__ */ u($, { children: [
    N && /* @__PURE__ */ o("style", { children: N }),
    r(y, b)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Wo,
      editValues: z(),
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: I
    }
  );
}, rl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, il = {
  // Preset
  preset: "plain",
  // Layout direction
  layout: "vertical",
  // Container
  containerGap: 8,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Icon
  showIcon: !1,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: a("borderColor"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !1,
  pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, al = {
  // --- Base: transparent bg, thin light border ---
  plain: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "plain-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Highlighted: container bg, no pill border ---
  highlighted: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "highlighted-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Container bg with thin border on pills ---
  "container-bg": {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "container-bg-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Extras: stronger border treatment ---
  bordered: {
    showIcon: !1,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-icon": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-highlighted": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  }
}, ll = [
  { label: "Plain", value: "plain" },
  { label: "Plain + Icon", value: "plain-icon" },
  { label: "Highlighted", value: "highlighted" },
  { label: "Highlighted + Icon", value: "highlighted-icon" },
  { label: "Container BG", value: "container-bg" },
  { label: "Container BG + Icon", value: "container-bg-icon" },
  { label: "Bordered", value: "bordered" },
  { label: "Bordered + Icon", value: "bordered-icon" },
  { label: "Bordered Highlighted", value: "bordered-highlighted" },
  { label: "Custom", value: "custom" }
], Do = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: ll
  },
  // Layout direction
  {
    key: "layout",
    label: "Layout",
    type: "options",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  // Icon toggle
  { key: "showIcon", label: "Show Arrow Icon", type: "toggle" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Shadow Value (CSS)", type: "text" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...pe]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" },
  // Shadow
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Pill Shadow CSS", type: "text" }
], Gs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...il, ...e },
    Do
  ), z = (M, H) => {
    if (M === "preset" && H !== "custom") {
      const W = al[H];
      if (W) {
        p("preset", H), Object.entries(W).forEach(([w, E]) => {
          p(w, E);
        });
        return;
      }
    }
    p(M, H);
  }, C = i.pillFontFamily, x = C && C !== "inherit" ? m[C] : null, f = x && x.format === "google" ? x.url : null;
  if (Q(() => {
    f && rl(f);
  }, [f]), l)
    return /* @__PURE__ */ o($, {});
  const S = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", F = x && x.format !== "system" && x.format !== "google", g = `suggestion-list-${t || "default"}`, N = `
    ${F ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${g} { font-family: ${S} !important; }` : ""}
  `.trim(), y = {
    ...i,
    pillFontFamilyCss: S
  }, I = b(i.containerBgColor), v = I && I !== "transparent" && I !== "", k = /* @__PURE__ */ u($, { children: [
    N && /* @__PURE__ */ o("style", { children: N }),
    /* @__PURE__ */ o(
      "div",
      {
        className: g,
        style: {
          backgroundColor: v ? I : void 0,
          padding: v || i.containerPaddingX || i.containerPaddingY ? `${i.containerPaddingY}px ${i.containerPaddingX}px` : void 0,
          borderRadius: i.containerBorderRadius > 0 ? `${i.containerBorderRadius}px` : void 0
        },
        children: r(y, b)
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Do,
      editValues: i,
      onEditChange: z,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: k
    }
  );
}, Oo = {
  "vertical-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: K("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: K("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "vertical-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: K("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 12,
      inputBorderColor: K("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 12,
      containerPaddingY: 12,
      containerBorderRadius: 12,
      pillBorderRadius: 100,
      pillBorderColor: K("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: K("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  },
  "horizontal-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: K("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: K("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "horizontal-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: K("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: K("#F3F3F3"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  }
}, sl = [
  { label: "Vertical + Compact Input", value: "vertical-compact" },
  { label: "Vertical + Expanded Input", value: "vertical-expanded" },
  { label: "Horizontal + Compact Input", value: "horizontal-compact" },
  { label: "Horizontal + Expanded Input", value: "horizontal-expanded" },
  { label: "Custom", value: "custom" }
], jo = [
  // --- General ---
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: sl
  },
  { key: "mainBgColor", label: "Background", type: "color" },
  // --- Suggestion Pills group ---
  {
    key: "pillLayout",
    label: "Layout",
    type: "options",
    group: "Suggestion Pills",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  {
    key: "pillShowIcon",
    label: "Show Icon",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderColor",
    label: "Border Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5,
    group: "Suggestion Pills"
  },
  {
    key: "pillBgColor",
    label: "Background",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillTextColor",
    label: "Text Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Suggestion Pills"
  },
  // --- Input Box group ---
  {
    key: "inputBorderColor",
    label: "Border Color",
    type: "color",
    group: "Input Box"
  },
  {
    key: "inputBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 0.5,
    group: "Input Box"
  },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Input Box"
  },
  {
    key: "inputMinHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10,
    group: "Input Box"
  },
  {
    key: "inputShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Input Box"
  },
  {
    key: "inputShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Input Box"
  }
], cl = {
  preset: "vertical-expanded",
  mainBgColor: a("transparent"),
  // Pill defaults (vertical-expanded) — border 1px #F3F3F3, radius 100px, shadow per mock
  pillLayout: "vertical",
  pillShowIcon: !1,
  pillBorderRadius: 100,
  pillBorderColor: K("#F3F3F3"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !0,
  pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
  pillContainerBgColor: a("transparent"),
  pillContainerBorderRadius: 12,
  // Input defaults (vertical-expanded: taller input 116px, rounded rect)
  inputBorderColor: K("#F3F3F3"),
  inputBorderWidth: 1,
  inputBorderRadius: 20,
  inputMinHeight: 116,
  inputShadowEnabled: !1,
  inputShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)"
}, $s = ({
  widgetId: e = "concierge-panel",
  displayName: t = "Concierge Panel",
  initialState: n = {},
  suggestionListWidgetId: r = "concierge-suggestion-list",
  chatInputWidgetId: i = "concierge-chat-input",
  suppressChildEdits: l = !0,
  children: c
}) => {
  const {
    state: p,
    isLoading: d,
    isSaving: h,
    handleEditChange: m,
    handleSave: b,
    themeColors: B,
    themeFonts: z,
    resolveColor: C,
    canSave: x
  } = te(
    e,
    { ...cl, ...n },
    jo
  ), { updateWidgetConfig: f, getWidgetState: S } = Ht(
    r
  ), { updateWidgetConfig: F, getWidgetState: g } = Ht(i), N = le(!1);
  Q(() => {
    if (d || p.preset === "custom" || N.current) return;
    const H = Oo[p.preset];
    if (H) {
      N.current = !0;
      const P = S() || {};
      Object.entries(H.suggestionList).forEach(([w, E]) => {
        w in P || f(w, E);
      });
      const W = g() || {};
      Object.entries(H.chatInput).forEach(([w, E]) => {
        w in W || F(w, E);
      });
    }
  }, [d, p.preset, f, F, S, g]);
  const y = {
    pillLayout: "layout",
    pillShowIcon: "showIcon",
    pillBorderRadius: "pillBorderRadius",
    pillBorderColor: "pillBorderColor",
    pillBorderWidth: "pillBorderWidth",
    pillBgColor: "pillBgColor",
    pillTextColor: "pillTextColor",
    pillShadowEnabled: "pillShadowEnabled",
    pillShadow: "pillShadow",
    pillContainerBgColor: "containerBgColor",
    pillContainerBorderRadius: "containerBorderRadius"
  }, I = {
    inputBorderColor: "borderColor",
    inputBorderWidth: "borderWidth",
    inputBorderRadius: "borderRadiusSingleLine",
    inputMinHeight: "minHeight",
    inputShadowEnabled: "shadowEnabled",
    inputShadow: "shadow"
  }, v = ge(
    (H, P) => {
      if (H === "preset" && P !== "custom") {
        const w = Oo[P];
        if (w) {
          m("preset", P), w.panel && Object.entries(w.panel).forEach(([E, D]) => {
            m(E, D);
          }), Object.entries(w.suggestionList).forEach(([E, D]) => {
            f(E, D);
          }), Object.entries(w.chatInput).forEach(([E, D]) => {
            F(E, D);
          });
          return;
        }
      }
      if (H in y) {
        m("preset", "custom"), m(H, P), f(y[H], P);
        return;
      }
      if (H in I) {
        m("preset", "custom"), m(H, P), F(I[H], P);
        return;
      }
      m(H, P);
    },
    [m, f, F]
  );
  if (d)
    return /* @__PURE__ */ o($, {});
  const k = c(p, C);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: jo,
      editValues: p,
      onEditChange: v,
      onSave: x ? b : void 0,
      isSaving: h,
      themeColors: B,
      themeFonts: z,
      containerClassName: "widget-fill-height",
      children: l ? /* @__PURE__ */ o(Oi, { children: k }) : k
    }
  );
}, Go = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, dl = {
  // Card/Pill container
  borderColor: a("borderColor"),
  borderColorSelected: a("primary"),
  backgroundColor: a("secondary"),
  backgroundColorHover: a("background"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: a("primary"),
  checkmarkIconColor: a("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: a("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: a("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: a("background"),
  dividerColorSelected: a("primary")
}, $o = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...pe]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...pe]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], Ys = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...dl, ...e },
    $o
  ), z = i.priceFontFamily, C = z && z !== "inherit" ? m[z] : null, x = i.nameFontFamily, f = x && x !== "inherit" ? m[x] : null, S = C && C.format === "google" ? C.url : null, F = f && f.format === "google" ? f.url : null;
  if (Q(() => {
    S && Go(S);
  }, [S]), Q(() => {
    F && Go(F);
  }, [F]), l)
    return /* @__PURE__ */ o($, {});
  const g = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", N = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", y = C && C.format !== "system" && C.format !== "google", I = f && f.format !== "system" && f.format !== "google", v = `variant-picker-${t || "default"}`, k = `
    ${y ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${g !== "inherit" ? `.${v} [data-price-text] { font-family: ${g} !important; }` : ""}
    ${N !== "inherit" ? `.${v} [data-name-text] { font-family: ${N} !important; }` : ""}
  `.trim(), M = {
    ...i,
    priceFontFamilyCss: g,
    nameFontFamilyCss: N
  }, H = /* @__PURE__ */ u($, { children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(M, b)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: $o,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: H
    }
  );
}, pl = {
  overlayBgColor: K("rgba(0, 0, 0, 0.45)"),
  dialogBgColor: a("secondary"),
  dialogBorderRadius: 12,
  titleColor: a("textPrimary"),
  messageColor: a("textPrimary"),
  cancelButtonBgColor: a("secondary"),
  cancelButtonBorderColor: a("borderColor"),
  cancelButtonTextColor: a("textPrimary"),
  confirmButtonBgColor: a("primary"),
  confirmButtonTextColor: a("primaryForeground")
}, Yo = [
  { key: "overlayBgColor", label: "Overlay Background", type: "color" },
  { key: "dialogBgColor", label: "Dialog Background", type: "color" },
  {
    key: "dialogBorderRadius",
    label: "Dialog Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  { key: "messageColor", label: "Message Color", type: "color" },
  {
    key: "cancelButtonBgColor",
    label: "Cancel Button Background",
    type: "color"
  },
  {
    key: "cancelButtonBorderColor",
    label: "Cancel Button Border",
    type: "color"
  },
  {
    key: "cancelButtonTextColor",
    label: "Cancel Button Text",
    type: "color"
  },
  {
    key: "confirmButtonBgColor",
    label: "Confirm Button Background",
    type: "color"
  },
  {
    key: "confirmButtonTextColor",
    label: "Confirm Button Text",
    type: "color"
  }
], Qs = ({ initialState: e = {}, widgetId: t, displayName: n, overlay: r, children: i }) => {
  const {
    state: l,
    isLoading: c,
    isSaving: p,
    handleEditChange: d,
    handleSave: h,
    themeColors: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...pl, ...e },
    Yo
  );
  if (c)
    return /* @__PURE__ */ o($, {});
  const z = r ? r(l, b) : null, C = i(l, b);
  return /* @__PURE__ */ u($, { children: [
    z,
    /* @__PURE__ */ o(
      Z,
      {
        widgetId: t,
        displayName: n,
        editFields: Yo,
        editValues: l,
        onEditChange: d,
        onSave: B ? h : void 0,
        isSaving: p,
        themeColors: m,
        triggerMode: "persistent",
        triggerPosition: "top-right",
        wrapperStyle: { width: "100%", maxWidth: "28rem" },
        children: C
      }
    )
  ] });
}, gl = {
  dialogBgColor: a("secondary"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  titleFontSize: 24,
  titleColor: a("textPrimary"),
  descriptionFontSize: 16,
  descriptionColor: a("textPrimary"),
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: K("#f5f5f5"),
  primaryButtonBgColor: a("textPrimary"),
  primaryButtonTextColor: a("secondary"),
  primaryButtonBorderRadius: 999,
  cancelTextColor: a("textPrimary")
}, Qo = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  { key: "logoContainerSize", label: "Icon Size", type: "number", min: 32, max: 96, step: 4, group: "Logo" },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  { key: "titleFontSize", label: "Font Size", type: "number", min: 16, max: 32, step: 1, group: "Title" },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Description ───────────────────────────────────────────────────────
  { key: "descriptionFontSize", label: "Font Size", type: "number", min: 12, max: 20, step: 1, group: "Description" },
  { key: "descriptionColor", label: "Color", type: "color", group: "Description" },
  // ── Button ────────────────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background", type: "color", group: "Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Button"
  },
  { key: "cancelTextColor", label: "Cancel Text Color", type: "color", group: "Button" }
], Xs = ({ initialState: e = {}, widgetId: t, displayName: n, children: r }) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeIcons: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...gl, ...e },
    Qo
  ), z = i.logoIcon && i.logoIcon !== "default" ? m[i.logoIcon] : null, C = z ? z.url : null;
  return l ? /* @__PURE__ */ o($, {}) : /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Qo,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeIcons: m,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%", maxWidth: "28rem" },
      children: r(i, b, C)
    }
  );
}, ml = {
  // Dialog container
  dialogBgColor: K("#ffffff"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  // Logo circle
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: a("primary"),
  // Title
  titleFontSize: 24,
  titleColor: a("textPrimary"),
  // Subtitle
  subtitleFontSize: 16,
  subtitleColor: a("textPrimary"),
  // Input field
  inputBorderRadius: 6,
  inputBorderColor: K("#dcdddc"),
  // Continue (primary) button
  primaryButtonBgColor: a("textPrimary"),
  primaryButtonDisabledBgColor: K("#DCDCDC"),
  primaryButtonTextColor: K("#ffffff"),
  primaryButtonBorderRadius: 999,
  // Resend (secondary/outlined) button
  secondaryButtonBorderColor: a("textPrimary"),
  secondaryButtonDisabledBorderColor: K("#DCDCDC"),
  secondaryButtonTextColor: a("textPrimary"),
  secondaryButtonBorderRadius: 999,
  // Back / cancel text
  cancelTextColor: a("textPrimary")
}, Xo = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Image", type: "icon", group: "Logo" },
  {
    key: "logoContainerSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 96,
    step: 4,
    group: "Logo"
  },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Title"
  },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Subtitle ──────────────────────────────────────────────────────────
  {
    key: "subtitleFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Subtitle"
  },
  { key: "subtitleColor", label: "Color", type: "color", group: "Subtitle" },
  // ── Input ─────────────────────────────────────────────────────────────
  { key: "inputBorderColor", label: "Border Color", type: "color", group: "Input" },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1,
    group: "Input"
  },
  // ── Continue Button ───────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background (Active)", type: "color", group: "Continue Button" },
  { key: "primaryButtonDisabledBgColor", label: "Background (Disabled)", type: "color", group: "Continue Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Continue Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Continue Button"
  },
  // ── Resend Button ─────────────────────────────────────────────────────
  { key: "secondaryButtonBorderColor", label: "Border (Active)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonDisabledBorderColor", label: "Border (Disabled)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonTextColor", label: "Text Color", type: "color", group: "Resend Button" },
  {
    key: "secondaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Resend Button"
  },
  // ── Cancel ────────────────────────────────────────────────────────────
  { key: "cancelTextColor", label: "Back Text Color", type: "color", group: "Cancel" }
], Js = ({
  widgetId: e,
  displayName: t,
  initialState: n = {},
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeIcons: m,
    resolveColor: b,
    canSave: B
  } = te(
    e,
    { ...ml, ...n },
    Xo
  ), z = i.logoIcon && i.logoIcon !== "default" ? m[i.logoIcon] : null, C = z ? z.url : null;
  return l ? /* @__PURE__ */ o($, {}) : /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: Xo,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeIcons: m,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%" },
      children: r(i, b, C)
    }
  );
}, ul = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: a("textPrimary"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: a("textPrimary"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: a("textPrimary"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: a("textPrimary"),
  thinkingTextFontSize: 14,
  thinkingBgColor: a("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: a("background"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Jo = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: pe
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], Zs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    themeIcons: b,
    resolveColor: B,
    canSave: z
  } = te(
    t,
    { ...ul, ...e },
    Jo
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const C = r(i, B);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: Jo,
      editValues: i,
      onEditChange: p,
      onSave: z ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      themeIcons: b,
      children: C
    }
  );
}, hl = {
  // Container styling
  containerBgColor: a("secondary"),
  containerBorderRadius: 16,
  containerPaddingX: 24,
  containerPaddingY: 24,
  containerBorderWidth: 1,
  containerBorderColor: a("background"),
  // Icon styling
  iconBgColor: a("primary"),
  iconColor: a("secondary"),
  iconSize: 40,
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "700",
  // Description styling
  descriptionColor: a("textPrimary"),
  descriptionFontSize: 14,
  // Button styling
  buttonBgColor: a("primary"),
  buttonTextColor: a("buttonText"),
  buttonFontSize: 14,
  buttonFontWeight: "600",
  buttonBorderRadius: 10,
  buttonPaddingX: 20,
  buttonPaddingY: 10
}, Zo = [
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24
  },
  {
    key: "containerBorderWidth",
    label: "Container Border Width",
    type: "number",
    min: 0,
    max: 4
  },
  { key: "containerBorderColor", label: "Container Border Color", type: "color" },
  { key: "iconBgColor", label: "Icon Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 24
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 10,
    max: 20
  },
  { key: "buttonBgColor", label: "Button Background", type: "color" },
  { key: "buttonTextColor", label: "Button Text Color", type: "color" },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius",
    type: "number",
    min: 0,
    max: 24
  }
], yl = ({ size: e, color: t }) => /* @__PURE__ */ u(
  "svg",
  {
    width: e * 0.5,
    height: e * 0.5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
      /* @__PURE__ */ o("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
    ]
  }
), Us = ({
  widgetId: e,
  title: t,
  description: n,
  buttonText: r,
  onSignIn: i,
  disabled: l = !1,
  initialState: c
}) => {
  const {
    state: p,
    handleEditChange: d,
    handleSave: h,
    isSaving: m,
    getEditValues: b,
    resolveColor: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x
  } = te(
    e,
    { ...hl, ...c },
    Zo
  );
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: "Prompt Login",
      editFields: Zo,
      editValues: b(),
      onEditChange: d,
      onSave: h,
      isSaving: m,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            backgroundColor: B(p.containerBgColor),
            borderRadius: `${p.containerBorderRadius}px`,
            padding: `${p.containerPaddingY}px ${p.containerPaddingX}px`,
            border: `${p.containerBorderWidth}px solid ${B(p.containerBorderColor)}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)"
          },
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  width: `${p.iconSize}px`,
                  height: `${p.iconSize}px`,
                  borderRadius: "50%",
                  backgroundColor: B(p.iconBgColor),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ o(
                  yl,
                  {
                    size: p.iconSize,
                    color: B(p.iconColor)
                  }
                )
              }
            ),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    color: B(p.titleColor),
                    fontSize: `${p.titleFontSize}px`,
                    fontWeight: p.titleFontWeight,
                    lineHeight: 1.4
                  },
                  children: t
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    color: B(p.descriptionColor),
                    fontSize: `${p.descriptionFontSize}px`,
                    lineHeight: 1.5
                  },
                  children: n
                }
              )
            ] }),
            i && /* @__PURE__ */ o(
              "button",
              {
                onClick: l ? void 0 : i,
                style: {
                  backgroundColor: B(p.buttonBgColor),
                  color: B(p.buttonTextColor),
                  fontSize: `${p.buttonFontSize}px`,
                  fontWeight: p.buttonFontWeight,
                  borderRadius: `${p.buttonBorderRadius}px`,
                  padding: `${p.buttonPaddingY}px ${p.buttonPaddingX}px`,
                  border: "none",
                  cursor: l ? "default" : "pointer",
                  transition: "opacity 0.15s ease",
                  opacity: l ? 0.5 : 1,
                  width: "100%",
                  maxWidth: "200px",
                  letterSpacing: "0.01em",
                  pointerEvents: l ? "none" : "auto",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                onMouseEnter: (f) => {
                  l || (f.currentTarget.style.opacity = "0.88");
                },
                onMouseLeave: (f) => {
                  l || (f.currentTarget.style.opacity = "1");
                },
                children: l ? "Loading ..." : r
              }
            )
          ]
        }
      )
    }
  );
}, Uo = [
  "concierge-home-greeting",
  "concierge-home-subtitle",
  "concierge-home-starters",
  "concierge-home-logo",
  "concierge-home-brand-label",
  "concierge-chat-input"
], Ie = {
  "concierge-home-greeting": {
    greetingFontWeight: "semibold"
  },
  "concierge-home-subtitle": {
    fontWeight: "semibold"
  },
  "concierge-chat-input": {
    fontSize: 16,
    mobile_fontSize: 12,
    iconSize: 24,
    submitButtonSize: 24,
    iconGap: 12
  }
}, _e = {
  preset: "expanded",
  shadowEnabled: !0,
  shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
  borderColor: a("borderColor"),
  borderColorFocus: a("borderColor"),
  borderRadiusSingleLine: 15,
  borderRadiusMultiLine: 15,
  borderWidth: 1,
  paddingX: 24,
  paddingY: 24,
  minHeight: 138,
  fontSize: 16,
  mobile_fontSize: 12,
  iconSize: 24,
  submitButtonSize: 24,
  iconGap: 12,
  mobile_minHeight: 116
}, bl = {
  // =========================================================================
  // A-Series: Minimal / brand-focused layouts
  // =========================================================================
  /** A1 - Minimal: Logo only + search bar */
  A1: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie
    }
  },
  /** A2 - Logo + Subtitle: Logo with assistant intro text */
  A2: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-hero-logo",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-subtitle": {
        fontSize: 24,
        fontWeight: "semibold",
        mobile_fontSize: 18
      },
      "concierge-home-logo": {
        marginBottom: 32,
        mobile_marginBottom: 20
      }
    }
  },
  /** A3 - Branded Logo: "CONCIERGE BY" label above logo */
  A3: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "above-hero-logo",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 48,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-brand-label": {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 16,
        mobile_fontSize: 12,
        mobile_marginBottom: 8
      }
    }
  },
  /** A4 - Subtitle + Pills: Subtitle text with pill starters, logo in footer */
  A4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A5 - Greeting + Pills: Personalized greeting with pill starters */
  A5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A6 - Inline Icon Greeting + Pills: Greeting with inline icon before text and pill starters */
  A6: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "inline",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        preset: "expanded",
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: a("borderColor"),
        borderColorFocus: a("borderColor"),
        borderRadiusSingleLine: 15,
        borderRadiusMultiLine: 15,
        borderWidth: 1,
        paddingX: 24,
        paddingY: 24,
        minHeight: 138,
        fontSize: 16,
        mobile_fontSize: 12,
        iconSize: 24,
        submitButtonSize: 24,
        iconGap: 12,
        mobile_minHeight: 116
      }
    }
  },
  /** A7 - Icon Above Greeting + Pills: Greeting with icon above text and pill starters */
  A7: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "above",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        lineHeight: 1.2,
        letterSpacing: 0.08,
        maxWidth: 830,
        marginBottom: 0
      },
      "concierge-home-starters": {
        pillPaddingX: 24,
        pillPaddingY: 12,
        pillBgColor: a("secondary"),
        pillFontWeight: "medium",
        pillShadowEnabled: !0,
        pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)"
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: a("borderColor"),
        borderColorFocus: a("borderColor"),
        borderRadiusSingleLine: 15,
        borderRadiusMultiLine: 15,
        submitButtonIconColor: a("background"),
        submitButtonSize: 24,
        iconSize: 24,
        iconGap: 12,
        fontSize: 16,
        mobile_fontSize: 12,
        paddingX: 24,
        paddingY: 24,
        minHeight: 138,
        mobile_minHeight: 116
      }
    }
  },
  // =========================================================================
  // B-Series: Greeting + conversation starters focused
  // =========================================================================
  /** B1 - Card Starters Row: Greeting with 4 cards in a horizontal row */
  B1: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-row",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "cards-grid"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": _e
    }
  },
  /** B2 - Icon Pills: Greeting with 3 icon-pill starters, logo after content */
  B2: {
    layout: {
      logoPosition: "after-content",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 56,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-chat-input": _e
    }
  },
  /** B3 - Icon Pills + Branded Footer: 3 icon-pill starters with "CONCIERGE BY" footer */
  B3: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": _e
    }
  },
  /** B4 - Card Grid: Greeting with 2x2 inline-icon card grid */
  B4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-grid",
      maxStarters: 4,
      cardLayoutDirection: "inline",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "pills-icons-list"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": _e
    }
  },
  /** B5 - Pills + Branded Footer: Greeting with pills and "EMBER BY" footer */
  B5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Ie,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": _e
    }
  }
}, fl = {
  A1: "A1 - Minimal (Logo only)",
  A2: "A2 - Logo + Subtitle",
  A3: "A3 - Branded Logo",
  A4: "A4 - Subtitle + Pills",
  A5: "A5 - Greeting + Pills",
  A6: "A6 - Inline Icon Greeting + Pills",
  A7: "A7 - Icon Above Greeting + Pills",
  B1: "B1 - Card Starters (Row)",
  B2: "B2 - Icon Pills",
  B3: "B3 - Icon Pills + Branded Footer",
  B4: "B4 - Card Starters (Grid)",
  B5: "B5 - Pills + Branded Footer",
  custom: "Custom"
}, xl = {
  layoutPreset: "A1",
  backgroundStyle: "colored",
  backgroundColor: a("background"),
  elementStyle: "default",
  logoPosition: "hero",
  brandLabelPosition: "hidden",
  showGreeting: !1,
  showGreetingIcon: !1,
  greetingIconPosition: "above",
  subtitlePosition: "hidden",
  startersMode: "hidden",
  maxStarters: 4,
  cardLayoutDirection: "stacked",
  footerGap: 8,
  footerPaddingBottom: 0,
  searchInputGap: 32,
  mobile_logoPosition: "hero",
  mobile_startersMode: "inherit"
}, Cl = Object.entries(fl).map(([e, t]) => ({
  label: t,
  value: e
})), _o = [
  // Preset
  {
    key: "layoutPreset",
    label: "Layout Preset",
    type: "options",
    options: Cl,
    group: "Preset"
  },
  // Background
  {
    key: "backgroundStyle",
    label: "Background",
    type: "options",
    options: [
      { label: "Colored", value: "colored" },
      { label: "White", value: "white" }
    ],
    group: "Background"
  },
  {
    key: "backgroundColor",
    label: "Background Color",
    type: "color",
    group: "Background",
    condition: { field: "backgroundStyle", value: "colored" }
  },
  {
    key: "elementStyle",
    label: "Element Style",
    type: "options",
    options: [
      { label: "Default", value: "default" },
      { label: "Grey Fill", value: "grey-fill" },
      { label: "Grey Fill + Stroke", value: "grey-fill-stroke" }
    ],
    group: "Background"
  },
  // Sections
  {
    key: "logoPosition",
    label: "Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "After Content", value: "after-content" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "brandLabelPosition",
    label: "Brand Label",
    type: "options",
    options: [
      { label: "Above Hero Logo", value: "above-hero-logo" },
      { label: "Above Footer Logo", value: "above-footer-logo" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "showGreeting",
    label: "Show Greeting",
    type: "toggle",
    group: "Sections"
  },
  {
    key: "showGreetingIcon",
    label: "Show Greeting Icon",
    type: "toggle",
    group: "Sections",
    condition: "showGreeting"
  },
  {
    key: "greetingIconPosition",
    label: "Icon Position",
    type: "options",
    options: [
      { label: "Above Greeting", value: "above" },
      { label: "Inline (before text)", value: "inline" }
    ],
    group: "Sections",
    condition: "showGreetingIcon"
  },
  {
    key: "subtitlePosition",
    label: "Subtitle Position",
    type: "options",
    options: [
      { label: "Under Hero Logo", value: "under-hero-logo" },
      { label: "Under Greeting", value: "under-greeting" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "startersMode",
    label: "Starters Layout",
    type: "options",
    options: [
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Sections"
  },
  {
    key: "maxStarters",
    label: "Max Starters",
    type: "number",
    min: 1,
    max: 6,
    step: 1,
    group: "Sections",
    condition: { field: "startersMode", value: "hidden", operator: "not_equals" }
  },
  {
    key: "cardLayoutDirection",
    label: "Card Layout",
    type: "options",
    options: [
      { label: "Stacked (icon above text)", value: "stacked" },
      { label: "Inline (icon beside text)", value: "inline" }
    ],
    group: "Sections",
    condition: { field: "startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "footerGap",
    label: "Footer / After-Content Gap",
    type: "number",
    min: 0,
    max: 80,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: ["footer", "after-content"], operator: "includes" }
  },
  {
    key: "footerPaddingBottom",
    label: "Footer Bottom Padding",
    type: "number",
    min: 0,
    max: 120,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: "footer" }
  },
  {
    key: "searchInputGap",
    label: "Search Input Gap",
    type: "number",
    min: 0,
    max: 64,
    step: 4,
    group: "Sections"
  },
  // Mobile overrides (responsive)
  {
    key: "mobile_logoPosition",
    label: "Mobile Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Header (top bar)", value: "header" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "Hidden", value: "hidden" },
      { label: "Inherit from Desktop", value: "inherit" }
    ],
    group: "Mobile"
  },
  {
    key: "mobile_startersMode",
    label: "Mobile Starters Layout",
    type: "options",
    options: [
      { label: "Inherit from Desktop", value: "inherit" },
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Mobile"
  }
], _s = ({
  widgetId: e = "concierge-home-layout",
  displayName: t = "Home Layout",
  initialState: n = {},
  children: r
}) => {
  const i = jt(), l = $e(), c = le(/* @__PURE__ */ new Set()), {
    state: p,
    isLoading: d,
    isSaving: h,
    handleEditChange: m,
    handleSave: b,
    resetField: B,
    savedKeys: z,
    themeColors: C,
    resolveColor: x,
    canSave: f
  } = te(e, { ...xl, ...n }, _o), S = ge(
    (y) => {
      const I = y.childWidgets ?? {};
      Uo.forEach((v) => c.current.add(v)), i.setQueryData([...Le, l.themeId], (v) => {
        var M;
        if (!v) return v;
        const k = {
          ...(M = v == null ? void 0 : v.config) == null ? void 0 : M.widgetConfig
        };
        for (const H of Uo)
          H in I ? k[H] = {
            ...I[H]
          } : delete k[H];
        return {
          ...v,
          config: {
            ...v == null ? void 0 : v.config,
            widgetConfig: k
          }
        };
      });
    },
    [i, l.themeId]
  ), F = ge(async () => {
    if (await b(), c.current.size > 0 && l.themeId && l.editThemeToken) {
      const y = i.getQueryData([...Le, l.themeId]), I = Array.from(c.current).map((v) => {
        var M, H;
        const k = (H = (M = y == null ? void 0 : y.config) == null ? void 0 : M.widgetConfig) == null ? void 0 : H[v];
        return jn({
          themeId: l.themeId,
          widgetId: v,
          widgetState: k ?? {},
          editThemeToken: l.editThemeToken
        });
      });
      try {
        await Promise.all(I), c.current.clear();
      } catch (v) {
        console.error("Failed to save child widget configs:", v);
      }
    }
  }, [b, i, l]), g = ge(
    (y, I) => {
      if (y === "layoutPreset" && I !== "custom") {
        const v = bl[I];
        v && (Object.entries(v.layout).forEach(([k, M]) => {
          m(k, M);
        }), S(v));
      }
      m(y, I);
    },
    [m, S]
  );
  if (d)
    return /* @__PURE__ */ o(Qa, {});
  const N = r(p, x);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: _o,
      editValues: p,
      onEditChange: g,
      onSave: f ? F : void 0,
      isSaving: h,
      savedKeys: z,
      onResetField: B,
      themeColors: C,
      triggerMode: "persistent",
      triggerIcon: "gear",
      triggerPosition: "bottom-right",
      triggerLabel: "Edit Home Layout",
      children: N
    }
  );
}, kl = {
  logoIcon: "default",
  logoWidth: 200,
  logoMaxHeight: 80,
  logoOpacity: 1,
  marginBottom: 0,
  mobile_logoWidth: 140,
  mobile_marginBottom: 0
}, Vo = [
  {
    key: "logoIcon",
    label: "Logo Image",
    type: "icon"
  },
  {
    key: "logoWidth",
    label: "Logo Width",
    type: "number",
    min: 60,
    max: 400,
    step: 10,
    responsive: !0
  },
  {
    key: "logoMaxHeight",
    label: "Max Height",
    type: "number",
    min: 30,
    max: 200,
    step: 10
  },
  {
    key: "logoOpacity",
    label: "Opacity",
    type: "number",
    min: 0.1,
    max: 1,
    step: 0.1
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 96,
    step: 4,
    responsive: !0
  }
], Vs = ({
  widgetId: e = "concierge-home-logo",
  displayName: t = "Brand Logo",
  initialState: n = {},
  logoUrl: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeIcons: m,
    canSave: b
  } = te(
    e,
    { ...kl, ...n },
    Vo
  ), B = i.logoIcon && i.logoIcon !== "default" ? m[i.logoIcon] : null, z = B ? B.url : r;
  if (l || !z)
    return /* @__PURE__ */ o($, {});
  const C = `logo-${e || "default"}`, x = `logo-wrap-${e || "default"}`, f = i.mobile_marginBottom ?? i.marginBottom, S = i.mobile_logoWidth ?? i.logoWidth, F = `
    .${x} {
      margin-bottom: ${i.marginBottom}px;
    }
    .${C} img {
      width: ${i.logoWidth}px;
    }
    @media (max-width: 767px) {
      .${x} {
        margin-bottom: ${f}px !important;
      }
      .${C} img {
        width: ${S}px !important;
      }
    }
  `.trim(), g = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: F }),
    /* @__PURE__ */ o(
      "div",
      {
        className: `${x} ${C}`,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        },
        children: /* @__PURE__ */ o(
          "img",
          {
            src: z,
            alt: B ? B.name : "Brand logo",
            style: {
              maxHeight: i.logoMaxHeight,
              opacity: i.logoOpacity,
              objectFit: "contain"
            }
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: Vo,
      editValues: i,
      onEditChange: p,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeIcons: m,
      children: g
    }
  );
}, vl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, wl = {
  text: "CONCIERGE BY",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  color: a("textPrimary"),
  letterSpacing: 2,
  textTransform: "uppercase",
  marginBottom: 8,
  mobile_fontSize: 14,
  mobile_marginBottom: 8
}, qo = [
  { key: "text", label: "Label Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: 0,
    max: 10,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    responsive: !0
  }
], qs = ({
  widgetId: e = "concierge-home-brand-label",
  displayName: t = "Brand Label",
  initialState: n = {}
}) => {
  const {
    state: r,
    isLoading: i,
    isSaving: l,
    handleEditChange: c,
    handleSave: p,
    themeColors: d,
    themeFonts: h,
    resolveColor: m,
    canSave: b
  } = te(
    e,
    { ...wl, ...n },
    qo
  ), B = r.fontFamily, z = B && B !== "inherit" ? h[B] : null, C = z && z.format === "google" ? z.url : null;
  if (Q(() => {
    C && vl(C);
  }, [C]), i)
    return /* @__PURE__ */ o($, {});
  const x = z ? z.format === "system" ? z.url : `"${z.name}", sans-serif` : "inherit", f = z && z.format !== "system" && z.format !== "google", S = `brand-label-${e || "default"}`, F = r.mobile_fontSize ?? r.fontSize, g = r.mobile_marginBottom ?? r.marginBottom, N = `
    ${f ? `
      @font-face {
        font-family: "${z.name}";
        src: url("${z.url}") format("${z.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${S} { font-family: ${x} !important; }` : ""}
    .${S}-container {
      margin-bottom: ${r.marginBottom}px;
    }
    .${S}-text {
      font-size: ${r.fontSize}px;
    }
    @media (max-width: 767px) {
      .${S}-container {
        margin-bottom: ${g}px !important;
      }
      .${S}-text {
        font-size: ${F}px !important;
      }
    }
  `.trim(), y = r.fontWeight === "normal" ? 400 : r.fontWeight === "medium" ? 500 : r.fontWeight === "semibold" ? 600 : 700, I = /* @__PURE__ */ u($, { children: [
    N && /* @__PURE__ */ o("style", { children: N }),
    /* @__PURE__ */ o(
      "div",
      {
        className: `${S}-container ${x !== "inherit" ? S : ""}`,
        style: {
          textAlign: "center"
        },
        children: /* @__PURE__ */ o(
          "span",
          {
            className: `${S}-text`,
            style: {
              fontWeight: y,
              color: m(r.color),
              letterSpacing: r.letterSpacing,
              textTransform: r.textTransform
            },
            children: r.text
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: qo,
      editValues: r,
      onEditChange: c,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: d,
      themeFonts: h,
      children: I
    }
  );
}, Sl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Bl = ({ size: e, color: t }) => /* @__PURE__ */ o("svg", { width: e, height: e, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o(
  "path",
  {
    d: "M48 22.8232H29.0836L46.1268 14.4962L45.1182 12.3764L28.0749 20.7034L39.8703 5.69848L38.0548 4.23074L26.2622 19.2357L30.4697 0.52336L28.2104 0L24 18.7123L19.7896 0L17.5274 0.52336L21.7378 19.2357L9.94236 4.23074L8.12968 5.69848L19.9222 20.7034L2.87896 12.3764L1.8732 14.4962L18.9164 22.8232H0V25.1768H18.9164L1.8732 33.5038L2.87896 35.6265L19.9222 27.2995L8.12968 42.3044L9.94236 43.7722L21.7378 28.7673L17.5274 47.4766L19.7896 48L24 29.2906L28.2104 48L30.4697 47.4766L26.2622 28.7673L38.0548 43.7722L39.8703 42.3044L28.0749 27.2995L45.1182 35.6265L46.1268 33.5038L29.0836 25.1768H48V22.8232Z",
    fill: t
  }
) }), Il = {
  greetingTemplate: "Hi, {name}.",
  loggedOutGreeting: "Hello",
  greetingFontSize: 24,
  greetingFontWeight: "semibold",
  greetingFontFamily: "inherit",
  greetingColor: a("textPrimary"),
  showUserName: !0,
  iconType: "brand-icon",
  emoji: "👋",
  brandIcon: "",
  iconSize: 32,
  iconColor: a("primary"),
  iconRotationAnimation: !0,
  iconRotationDuration: 8,
  iconMarginBottom: 8,
  greetingMarginBottom: 16,
  mobile_greetingMarginBottom: 8,
  mobile_greetingFontSize: 18,
  mobile_iconSize: 28
}, Ko = [
  // Greeting text
  {
    key: "greetingTemplate",
    label: "Greeting Text",
    type: "text",
    group: "Greeting Text"
  },
  {
    key: "showUserName",
    label: "Show User Name",
    type: "toggle",
    group: "Greeting Text"
  },
  {
    key: "greetingFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Greeting Text",
    responsive: !0
  },
  {
    key: "greetingFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Greeting Text"
  },
  {
    key: "greetingFontFamily",
    label: "Font Family",
    type: "font",
    group: "Greeting Text"
  },
  {
    key: "greetingColor",
    label: "Color",
    type: "color",
    group: "Greeting Text"
  },
  {
    key: "greetingMarginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Greeting Text",
    responsive: !0
  },
  // Icon
  {
    key: "iconType",
    label: "Icon Type",
    type: "options",
    options: [
      { label: "Brand Icon", value: "brand-icon" },
      { label: "Emoji", value: "emoji" }
    ],
    group: "Greeting Icon"
  },
  {
    key: "emoji",
    label: "Emoji",
    type: "text",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "emoji" }
  },
  {
    key: "brandIcon",
    label: "Icon",
    type: "icon",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Greeting Icon",
    responsive: !0
  },
  {
    key: "iconColor",
    label: "Icon Color",
    type: "color",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconRotationAnimation",
    label: "Rotation Animation",
    type: "toggle",
    group: "Greeting Icon"
  },
  {
    key: "iconRotationDuration",
    label: "Rotation Speed (seconds)",
    type: "number",
    min: 1,
    max: 30,
    step: 1,
    group: "Greeting Icon",
    condition: "iconRotationAnimation"
  },
  {
    key: "iconMarginBottom",
    label: "Icon Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 4,
    group: "Greeting Icon"
  }
], Ks = ({
  widgetId: e = "concierge-home-greeting",
  displayName: t = "Greeting",
  initialState: n = {},
  userName: r,
  showIcon: i = !1,
  iconPosition: l = "above"
}) => {
  const {
    state: c,
    isLoading: p,
    isSaving: d,
    handleEditChange: h,
    handleSave: m,
    resetField: b,
    savedKeys: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    resolveColor: f,
    canSave: S
  } = te(e, { ...Il, ...n }, Ko), F = c.greetingFontFamily, g = F && F !== "inherit" ? C[F] : C["studio-brand-font"] ?? Object.values(C)[0] ?? null, N = g && g.format === "google" ? g.url : null;
  if (Q(() => {
    N && Sl(N);
  }, [N]), p)
    return /* @__PURE__ */ o($, {});
  const y = g ? g.format === "system" ? g.url : `"${g.name}", sans-serif` : "inherit", I = g && g.format !== "system" && g.format !== "google", v = `greeting-${e || "default"}`, k = c.mobile_greetingFontSize ?? c.greetingFontSize, M = c.mobile_iconSize ?? c.iconSize, H = c.mobile_greetingMarginBottom ?? c.greetingMarginBottom, P = `
    ${I ? `
      @font-face {
        font-family: "${g.name}";
        src: url("${g.url}") format("${g.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${v} { font-family: ${y} !important; }` : ""}
    .${v}-wrap {
      margin-bottom: ${c.greetingMarginBottom}px;
    }
    @media (max-width: 767px) {
      .${v}-wrap {
        margin-bottom: ${H}px !important;
      }
      .${v}-text {
        font-size: ${k}px !important;
      }
      .${v}-icon {
        width: ${M}px !important;
        height: ${M}px !important;
      }
      .${v}-icon svg {
        width: ${M}px !important;
        height: ${M}px !important;
      }
    }
  `.trim();
  let W;
  c.showUserName && r ? W = c.greetingTemplate.replace("{name}", r) : W = c.loggedOutGreeting || "Hello";
  const w = c.greetingFontWeight === "normal" ? 400 : c.greetingFontWeight === "medium" ? 500 : c.greetingFontWeight === "semibold" ? 600 : 700, E = f(c.iconColor), D = `greeting-icon-spin-${e || "default"}`, X = c.iconRotationAnimation ? `@keyframes ${D} { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }` : "", T = c.iconRotationAnimation ? {
    animation: `${D} ${c.iconRotationDuration}s linear infinite`
  } : {}, R = () => {
    if (!i) return null;
    let G = null;
    return c.iconType === "emoji" ? G = /* @__PURE__ */ o("span", { style: { fontSize: c.iconSize }, children: c.emoji }) : c.brandIcon && x[c.brandIcon] ? G = /* @__PURE__ */ o(
      "div",
      {
        style: {
          width: c.iconSize,
          height: c.iconSize,
          backgroundColor: E,
          WebkitMaskImage: `url(${x[c.brandIcon].url})`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskImage: `url(${x[c.brandIcon].url})`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          maskPosition: "center"
        }
      }
    ) : G = /* @__PURE__ */ o(Bl, { size: c.iconSize, color: E }), /* @__PURE__ */ o(
      "div",
      {
        className: `${v}-icon`,
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...T
        },
        children: G
      }
    );
  }, j = l === "inline", L = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: P }),
    X && /* @__PURE__ */ o("style", { children: X }),
    /* @__PURE__ */ u(
      "div",
      {
        className: `${v}-wrap${y !== "inherit" ? ` ${v}` : ""}`,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center"
        },
        children: [
          i && !j && /* @__PURE__ */ o("div", { style: { marginBottom: c.iconMarginBottom }, children: R() }),
          /* @__PURE__ */ u(
            "span",
            {
              className: `${v}-text`,
              style: {
                display: "inline-flex",
                alignItems: "center",
                gap: j && i ? 8 : 0,
                fontSize: c.greetingFontSize,
                fontWeight: w,
                color: f(c.greetingColor),
                lineHeight: 1.2
              },
              children: [
                i && j && R(),
                W
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: Ko,
      editValues: c,
      onEditChange: h,
      onSave: S ? m : void 0,
      isSaving: d,
      savedKeys: B,
      onResetField: b,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: L
    }
  );
}, Pl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, zl = {
  textTemplate: "I'm {concierge_name}, your shopping assistant for {brand}.",
  fontSize: 24,
  fontWeight: "semibold",
  fontFamily: "inherit",
  color: a("textPrimary"),
  lineHeight: 1.2,
  letterSpacing: 0.08,
  maxWidth: 830,
  marginTop: 0,
  marginBottom: 0,
  mobile_fontSize: 24
}, en = [
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 32,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: -1,
    max: 2,
    step: 0.01
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 200,
    max: 900,
    step: 10
  },
  {
    key: "marginTop",
    label: "Spacing Above",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  }
], ec = ({
  widgetId: e = "concierge-home-subtitle",
  displayName: t = "Subtitle",
  initialState: n = {},
  brandName: r = "",
  conciergeName: i = "Concierge"
}) => {
  const {
    state: l,
    isLoading: c,
    isSaving: p,
    handleEditChange: d,
    handleSave: h,
    resetField: m,
    savedKeys: b,
    themeColors: B,
    themeFonts: z,
    resolveColor: C,
    canSave: x
  } = te(e, { ...zl, ...n }, en), f = l.fontFamily, S = f && f !== "inherit" ? z[f] : z["studio-brand-font"] ?? Object.values(z)[0] ?? null, F = S && S.format === "google" ? S.url : null;
  if (Q(() => {
    F && Pl(F);
  }, [F]), c)
    return /* @__PURE__ */ o($, {});
  const g = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", N = S && S.format !== "system" && S.format !== "google", y = `subtitle-${e || "default"}`, I = l.mobile_fontSize ?? l.fontSize, v = `
    ${N ? `
      @font-face {
        font-family: "${S.name}";
        src: url("${S.url}") format("${S.format}");
        font-display: swap;
      }
    ` : ""}
    ${g !== "inherit" ? `.${y} { font-family: ${g} !important; }` : ""}
    @media (max-width: 767px) {
      .${y}-text {
        font-size: ${I}px !important;
      }
    }
  `.trim(), H = !r || r.toLowerCase() === "brandclub" ? `I'm ${i}, your Brandclub shopping assistant.` : l.textTemplate.replace("{concierge_name}", i).replace("{brand}", r), P = l.fontWeight === "normal" ? 400 : l.fontWeight === "medium" ? 500 : l.fontWeight === "semibold" ? 600 : 700, W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: v }),
    /* @__PURE__ */ o(
      "div",
      {
        className: g !== "inherit" ? y : void 0,
        style: {
          textAlign: "center",
          marginTop: l.marginTop,
          marginBottom: l.marginBottom,
          width: "100%"
        },
        children: /* @__PURE__ */ o(
          "p",
          {
            className: `${y}-text`,
            style: {
              fontSize: l.fontSize,
              fontWeight: P,
              color: C(l.color),
              lineHeight: l.lineHeight,
              letterSpacing: l.letterSpacing ? `${l.letterSpacing}px` : void 0,
              maxWidth: l.maxWidth,
              margin: "0 auto"
            },
            children: H
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: en,
      editValues: l,
      onEditChange: d,
      onSave: x ? h : void 0,
      isSaving: p,
      savedKeys: b,
      onResetField: m,
      themeColors: B,
      themeFonts: z,
      children: W
    }
  );
}, Fl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIxKSI+CjxwYXRoIGQ9Ik0xOC4wMDE3IDAuMDAwNjI1NjFDMjcuOTQyMyAwLjAwMDYyNTYxIDM2LjAwMjkgOC4wNTg5NSAzNi4wMDI5IDE4LjAwMTdDMzYuMDAyOSAyNy45NDQ1IDI3Ljk0NDUgMzYuMDAyOSAxOC4wMDE3IDM2LjAwMjlDOC4wNTg5NSAzNi4wMDI5IDAuMDAwNjI1NjEgMjcuOTQyMyAwLjAwMDYyNTYxIDE4LjAwMTdIMTguMDAxN1YwLjAwMDYyNTYxWiIgZmlsbD0iI0Q2OTM4QSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXIxIj4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", Tl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIyKSI+CjxwYXRoIGQ9Ik0wIDM2QzAgMjYuMDU5MiA4LjA1OTIgMTggMTggMThDMjcuOTQwOCAxOCAzNiAyNi4wNTkyIDM2IDM2SDBaIiBmaWxsPSIjOEFCMkJGIi8+CjxwYXRoIGQ9Ik0zNiAwQzM2IDkuOTQwOCAyNy45NDA4IDE4IDE4IDE4QzguMDU5MiAxOCAwIDkuOTQwOCAwIDBIMzZaIiBmaWxsPSIjOEFCMkJGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfc3RhcnRlcjIiPgo8cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+", Ml = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIzKSI+CjxwYXRoIGQ9Ik0wIDBMMTggMThWMEgwWiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMzYgMFYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPHBhdGggZD0iTTM2IDM2TDE4IDE4VjM2SDM2WiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMCAzNlYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF9zdGFydGVyMyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=", El = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXI0KSI+CjxwYXRoIGQ9Ik0zMi41NjU4IDYuODg0NjdMMjYuNTYwOSAxNS4wODA2TDM2IDE4LjAwOUwyNi41NTg3IDIwLjkyODRMMzIuNTU2OCAyOS4xMzExTDIzLjI4NTkgMjUuNjU4NEwyMy41NTI5IDM2TDE3Ljk5NDQgMjcuNDYyMkwxMi40MjkyIDM1Ljk5NTVMMTIuNzA3MyAyNS42NTM5TDMuNDMxOTkgMjkuMTE3Nkw5LjQzOTA5IDIwLjkxOTRMMCAxNy45OTFMOS40NDEzNCAxNS4wNzE2TDMuNDQzMjEgNi44NzExN0wxMi43MTQxIDEwLjM0MzlMMTIuNDQ0OSAwTDE4LjAwMzQgOC41Mzc4TDIzLjU3MDggMC4wMDQ0OTgzMUwyMy4yOTI3IDEwLjM0ODRMMzIuNTY1OCA2Ljg4NDY3WiIgZmlsbD0iIzlBNzI2MSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXI0Ij4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", Al = [
  Fl,
  Tl,
  Ml,
  El
], Hl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Nl = {
  // Pill styling
  pillPaddingX: 24,
  pillPaddingY: 12,
  pillBorderRadius: 28,
  pillBorderWidth: 1,
  pillBorderColor: a("borderColor"),
  pillBgColor: a("background"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillShadowEnabled: !0,
  pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
  pillGap: 8,
  fontFamily: "inherit",
  // Card styling
  cardWidth: 183,
  cardHeight: 124,
  cardPadding: 16,
  cardBorderRadius: 12,
  cardBorderWidth: 0,
  cardBorderColor: a("borderColor"),
  cardBgColor: a("background"),
  cardBgColorHover: a("background"),
  cardTextColor: a("textPrimary"),
  cardFontSize: 14,
  cardGap: 12,
  cardIconSize: 32,
  // Default icons (will be replaced by bundled SVGs)
  starterIcon1: "",
  starterIcon2: "",
  starterIcon3: "",
  starterIcon4: "",
  // Container
  containerMaxWidth: 768,
  containerMarginTop: 16,
  // Mobile overrides
  mobile_pillFontSize: 12,
  mobile_pillPaddingX: 16,
  mobile_pillPaddingY: 12,
  mobile_cardGap: 8
}, tn = [
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 28,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderColor",
    label: "Pill Border Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColor",
    label: "Pill Background",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColorHover",
    label: "Pill Bg (Hover)",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillTextColor",
    label: "Pill Text Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Pill Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  // Card styling
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 120,
    max: 240,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardHeight",
    label: "Card Height",
    type: "number",
    min: 80,
    max: 180,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColorHover",
    label: "Card Bg (Hover)",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardTextColor",
    label: "Card Text Color",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardFontSize",
    label: "Card Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 4,
    group: "Card Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardIconSize",
    label: "Card Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  // Icons
  {
    key: "starterIcon1",
    label: "Starter 1 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon2",
    label: "Starter 2 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon3",
    label: "Starter 3 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon4",
    label: "Starter 4 Icon",
    type: "icon",
    group: "Icons"
  },
  // Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // Container
  {
    key: "containerMaxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 900,
    step: 50,
    group: "Container"
  },
  {
    key: "containerMarginTop",
    label: "Margin Top",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Container"
  }
], tc = ({
  widgetId: e = "concierge-home-starters",
  displayName: t = "Conversation Starters",
  initialState: n = {},
  mode: r,
  elementStyle: i = "default",
  cardLayoutDirection: l = "stacked",
  maxStarters: c = 4,
  queries: p,
  onSearch: d
}) => {
  const {
    state: h,
    isLoading: m,
    isSaving: b,
    handleEditChange: B,
    handleSave: z,
    resetField: C,
    savedKeys: x,
    themeColors: f,
    themeFonts: S,
    themeIcons: F,
    resolveColor: g,
    canSave: N
  } = te(
    e,
    { ...Nl, ...n, _startersMode: r },
    tn
  ), y = { ...h, _startersMode: r }, I = y.fontFamily, v = I && I !== "inherit" ? S[I] : null, k = v && v.format === "google" ? v.url : null;
  if (Q(() => {
    k && Hl(k);
  }, [k]), m || r === "hidden" || p.length === 0)
    return /* @__PURE__ */ o($, {});
  const M = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", H = v && v.format !== "system" && v.format !== "google", P = `starters-font-${e || "default"}`, W = `
    ${H ? `
      @font-face {
        font-family: "${v.name}";
        src: url("${v.url}") format("${v.format}");
        font-display: swap;
      }
    ` : ""}
    ${M !== "inherit" ? `.${P} { font-family: ${M} !important; }` : ""}
  `.trim(), w = p.slice(0, c), E = [
    y.starterIcon1,
    y.starterIcon2,
    y.starterIcon3,
    y.starterIcon4
  ], D = (J) => {
    const U = E[J];
    return U && F[U] ? F[U].url : Al[J] || null;
  }, X = () => {
    if (i === "grey-fill" || i === "grey-fill-stroke")
      return "#f6f8fa";
  }, T = () => {
    if (i === "grey-fill-stroke")
      return "1px solid #e5e7eb";
    if (i === "grey-fill")
      return "none";
  }, R = (J) => J === "normal" ? 400 : J === "medium" ? 500 : J === "semibold" ? 600 : 700, j = (J, U) => {
    const re = r === "pills-icons", q = D(U), ne = X(), ee = T();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => d(J),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: `${y.pillPaddingY}px ${y.pillPaddingX}px`,
          borderRadius: y.pillBorderRadius,
          border: ee ?? `${y.pillBorderWidth}px solid ${g(y.pillBorderColor)}`,
          backgroundColor: ne ?? g(y.pillBgColor),
          color: g(y.pillTextColor),
          fontSize: y.pillFontSize,
          fontWeight: R(y.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          whiteSpace: "nowrap",
          boxShadow: y.pillShadowEnabled ? y.pillShadow : "none"
        },
        onMouseEnter: (be) => {
          be.currentTarget.style.backgroundColor = g(y.pillBgColorHover) || ne || g(y.pillBgColor);
        },
        onMouseLeave: (be) => {
          be.currentTarget.style.backgroundColor = ne ?? g(y.pillBgColor);
        },
        children: [
          re && q && /* @__PURE__ */ o(
            "img",
            {
              src: q,
              alt: "",
              style: {
                width: 24,
                height: 24,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          J
        ]
      },
      U
    );
  }, L = (J, U) => {
    const re = D(U), q = X(), ne = T(), ee = l === "inline";
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => d(J),
        style: {
          display: "flex",
          flexDirection: ee ? "row" : "column",
          alignItems: ee ? "center" : void 0,
          gap: ee ? "16px" : "12px",
          padding: y.cardPadding,
          borderRadius: y.cardBorderRadius,
          border: ne ?? (y.cardBorderWidth > 0 ? `${y.cardBorderWidth}px solid ${g(y.cardBorderColor)}` : "none"),
          backgroundColor: q ?? g(y.cardBgColor),
          color: g(y.cardTextColor),
          fontSize: y.cardFontSize,
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          width: r === "cards-grid" ? "100%" : y.cardWidth,
          minHeight: ee ? void 0 : y.cardHeight,
          flexShrink: 0
        },
        onMouseEnter: (be) => {
          be.currentTarget.style.backgroundColor = g(y.cardBgColorHover) || q || g(y.cardBgColor);
        },
        onMouseLeave: (be) => {
          be.currentTarget.style.backgroundColor = q ?? g(y.cardBgColor);
        },
        children: [
          re && /* @__PURE__ */ o(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: y.cardIconSize,
                height: y.cardIconSize,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ o("span", { style: { lineHeight: 1.4 }, children: J })
        ]
      },
      U
    );
  }, G = (J, U) => {
    const re = D(U), q = X(), ne = T();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => d(J),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: `${y.pillPaddingY}px ${y.pillPaddingX}px`,
          borderRadius: y.pillBorderRadius > 20 ? 10 : y.pillBorderRadius,
          border: ne ?? `${y.pillBorderWidth}px solid ${g(y.pillBorderColor)}`,
          backgroundColor: q ?? g(y.pillBgColor),
          color: g(y.pillTextColor),
          fontSize: y.pillFontSize,
          fontWeight: R(y.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        },
        onMouseEnter: (ee) => {
          ee.currentTarget.style.backgroundColor = g(y.pillBgColorHover) || q || g(y.pillBgColor);
        },
        onMouseLeave: (ee) => {
          ee.currentTarget.style.backgroundColor = q ?? g(y.pillBgColor);
        },
        children: [
          re && /* @__PURE__ */ o(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: 16,
                height: 16,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          J
        ]
      },
      U
    );
  }, Y = () => {
    if (r === "pills" || r === "pills-icons") {
      const J = y.pillShadowEnabled ? 16 : 0;
      return /* @__PURE__ */ o(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            gap: y.pillGap,
            justifyContent: "center",
            maxWidth: y.containerMaxWidth,
            margin: `0 auto -${J}px`,
            padding: `0 0 ${J}px`
          },
          className: "concierge-home-starters-pills",
          children: w.map((U, re) => j(U, re))
        }
      );
    }
    return r === "pills-icons-list" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: y.pillGap,
          maxWidth: y.containerMaxWidth,
          margin: "0 auto",
          width: "100%"
        },
        className: "concierge-home-starters-pills-list",
        children: w.map((J, U) => G(J, U))
      }
    ) : r === "cards-row" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "flex",
          gap: y.cardGap,
          justifyContent: "center",
          maxWidth: y.containerMaxWidth,
          margin: "0 auto",
          flexWrap: "wrap"
        },
        className: "concierge-home-starters-cards-row",
        children: w.map((J, U) => L(J, U))
      }
    ) : r === "cards-grid" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: y.cardGap,
          maxWidth: y.containerMaxWidth,
          margin: "0 auto"
        },
        className: "concierge-home-starters-cards-grid",
        children: w.map((J, U) => L(J, U))
      }
    ) : null;
  }, _ = /* @__PURE__ */ u(
    "div",
    {
      className: M !== "inherit" ? P : void 0,
      style: { marginTop: y.containerMarginTop, width: "100%" },
      children: [
        /* @__PURE__ */ o("style", { children: `
        ${W || ""}
        /* Responsive: pills become horizontally scrollable on mobile */
        @media (max-width: 767px) {
          .concierge-home-starters-pills {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 4px;
            padding-left: 16px !important;
            padding-right: 16px !important;
          }
          .concierge-home-starters-pills::-webkit-scrollbar {
            display: none;
          }
          .concierge-home-starters-pill {
            padding: ${y.mobile_pillPaddingY ?? y.pillPaddingY}px ${y.mobile_pillPaddingX ?? y.pillPaddingX}px !important;
          }
          /* Vertical pill list on mobile */
          .concierge-home-starters-pills-list {
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          /* Cards row becomes 2-column grid on mobile */
          .concierge-home-starters-cards-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: ${y.mobile_cardGap}px !important;
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          .concierge-home-starters-cards-row > button {
            width: 100% !important;
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-row > button img {
            width: 16px !important;
            height: 16px !important;
          }
          /* Cards grid stays 2-column on mobile with compact sizing */
          .concierge-home-starters-cards-grid {
            gap: ${y.mobile_cardGap}px !important;
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          .concierge-home-starters-cards-grid > button {
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-grid > button img {
            width: 16px !important;
            height: 16px !important;
          }
        }
      ` }),
        Y()
      ]
    }
  );
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: tn,
      editValues: y,
      onEditChange: B,
      onSave: N ? z : void 0,
      isSaving: b,
      savedKeys: x,
      onResetField: C,
      themeColors: f,
      themeFonts: S,
      themeIcons: F,
      children: _
    }
  );
}, Ll = {
  // Hamburger icon
  hamburgerIcon: "default",
  hamburgerIconSize: 32,
  hamburgerIconColor: a("textPrimary"),
  // Close icon
  closeIcon: "default",
  closeIconSize: 32,
  closeIconColor: a("textPrimary"),
  // Logo visibility
  showLogo: !0,
  // Layout
  navHeight: 80,
  navPaddingX: 24,
  navPaddingY: 24,
  navBgColor: a("transparent")
}, on = [
  // Hamburger icon
  {
    key: "hamburgerIcon",
    label: "Menu Icon",
    type: "icon",
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconColor",
    label: "Color",
    type: "color",
    group: "Menu Icon"
  },
  // Close icon
  {
    key: "closeIcon",
    label: "Close Icon",
    type: "icon",
    group: "Close Icon"
  },
  {
    key: "closeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Close Icon"
  },
  {
    key: "closeIconColor",
    label: "Color",
    type: "color",
    group: "Close Icon"
  },
  // Logo visibility
  {
    key: "showLogo",
    label: "Show Logo",
    type: "toggle",
    group: "Logo"
  },
  // Layout
  {
    key: "navHeight",
    label: "Height",
    type: "number",
    min: 40,
    max: 120,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navBgColor",
    label: "Background",
    type: "color",
    group: "Layout"
  }
], oc = ({
  widgetId: e = "concierge-home-mobile-nav",
  displayName: t = "Mobile Nav Header",
  initialState: n = {},
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeIcons: m,
    resolveColor: b,
    canSave: B
  } = te(
    e,
    { ...Ll, ...n },
    on
  ), z = i.hamburgerIcon && i.hamburgerIcon !== "default" ? m[i.hamburgerIcon] : null, C = i.closeIcon && i.closeIcon !== "default" ? m[i.closeIcon] : null, x = {
    hamburgerIconUrl: z ? z.url : null,
    closeIconUrl: C ? C.url : null
  };
  if (l)
    return /* @__PURE__ */ o($, {});
  const f = r(i, x, b);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: on,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeIcons: m,
      children: f
    }
  );
}, tr = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  // Brandclub primary color
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Rl = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], nn = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Rl,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], Wt = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, or = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, Wl = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ o("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Dl = ({ survey: e, state: t, onClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: n,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: n ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (r) => {
      n && (r.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (r) => {
      r.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: t.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ o(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ o(
            "span",
            {
              style: {
                fontSize: t.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: t.surveyBadgeBgColor,
                color: t.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ o("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Wt(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ u("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: Wt(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            or(e.rewardAmount)
          ]
        }
      )
    ]
  }
), nc = ({
  widgetId: e,
  displayName: t = "Surveys",
  surveys: n,
  isLoading: r = !1,
  error: i,
  onSurveyClick: l,
  headerText: c,
  showHeader: p = !0,
  emptyMessage: d = "No surveys available right now",
  className: h,
  children: m
}) => {
  const {
    state: b,
    handleEditChange: B,
    handleSave: z,
    isSaving: C,
    themeColors: x,
    themeFonts: f,
    canSave: S
  } = te(
    e,
    tr,
    nn
  );
  if (m)
    return /* @__PURE__ */ o($, { children: m(b, n) });
  if (r)
    return /* @__PURE__ */ o(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: b.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (i)
    return /* @__PURE__ */ o(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (n.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ o(Wl, { size: b.emptyIconSize, color: b.emptyTextColor }),
          /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: b.emptyTextColor, marginTop: 12 }, children: d })
        ]
      }
    );
  const F = n.reduce((y, I) => y + I.rewardAmount, 0), g = c || `${n.length} Survey${n.length !== 1 ? "s" : ""} (${or(F)} potential)`, N = /* @__PURE__ */ u(
    "div",
    {
      className: h,
      style: {
        maxWidth: b.maxWidth,
        padding: `${b.paddingY}px ${b.paddingX}px`,
        backgroundColor: b.backgroundColor,
        borderRadius: b.borderRadius
      },
      children: [
        p && /* @__PURE__ */ o(
          "h3",
          {
            style: {
              fontSize: b.headerFontSize,
              fontWeight: Wt(b.headerFontWeight),
              color: b.headerColor,
              marginBottom: b.headerMarginBottom,
              margin: 0,
              marginBlockEnd: b.headerMarginBottom
            },
            children: g
          }
        ),
        /* @__PURE__ */ o("div", { style: { display: "flex", flexDirection: "column", gap: b.cardGap }, children: n.map((y) => /* @__PURE__ */ o(
          Dl,
          {
            survey: y,
            state: b,
            onClick: l ? () => l(y) : void 0
          },
          y.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: e,
      displayName: t,
      editFields: nn,
      editValues: b,
      onEditChange: B,
      onSave: S ? z : void 0,
      isSaving: C,
      themeColors: x,
      themeFonts: f,
      children: N
    }
  );
}, Ol = "#181d56", rn = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, jl = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", Gl = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, $l = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, Yl = ({
  size: e = 40,
  color: t = "#9ca3af"
}) => /* @__PURE__ */ u(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 12H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 16H13",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), rc = ({
  survey: e,
  state: t,
  onClick: n,
  className: r,
  width: i = 280
}) => {
  const [l, c] = O(!1);
  ({ ...tr, ...t });
  const p = () => {
    n ? n() : window.location.href = `/survey/${e.campaignId}`;
  }, d = e.brandLogoUrl || (e.brandId ? $l(e.brandId) : void 0), h = !!d;
  return /* @__PURE__ */ u(
    "div",
    {
      className: r,
      onClick: p,
      onMouseEnter: () => c(!0),
      onMouseLeave: () => c(!1),
      style: {
        width: typeof i == "number" ? `${i}px` : i,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: l ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: h ? /* @__PURE__ */ o(
              "img",
              {
                src: d,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ o(Yl, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: Ol,
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: rn.bg,
                          color: rn.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ o(
                            "img",
                            {
                              src: jl,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ o("span", { children: Gl(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ o(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ql = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Dt = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, nr = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, Xl = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, Jl = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ o("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Zl = ({ type: e, state: t }) => {
  const r = ((i) => {
    switch (i) {
      case "survey":
        return { bg: t.surveyBadgeBgColor, text: t.surveyBadgeTextColor };
      case "content":
        return { bg: t.contentBadgeBgColor, text: t.contentBadgeTextColor };
      case "membership":
        return { bg: t.membershipBadgeBgColor, text: t.membershipBadgeTextColor };
      case "review":
        return { bg: t.reviewBadgeBgColor, text: t.reviewBadgeTextColor };
      case "referral":
        return { bg: t.referralBadgeBgColor, text: t.referralBadgeTextColor };
      case "affiliate":
        return { bg: t.affiliateBadgeBgColor, text: t.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ o(
    "span",
    {
      style: {
        fontSize: t.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${t.typeBadgePaddingY}px ${t.typeBadgePaddingX}px`,
        borderRadius: t.typeBadgeBorderRadius,
        backgroundColor: r.bg,
        color: r.text,
        whiteSpace: "nowrap"
      },
      children: Xl[e] || e
    }
  );
}, Ul = ({ opportunity: e, state: t, onClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: n,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: n ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (r) => {
      n && (r.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (r) => {
      r.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ o(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ o(Zl, { type: e.type, state: t }),
          /* @__PURE__ */ o("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Dt(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: Dt(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            nr(e.rewardAmount)
          ]
        }
      )
    ]
  }
), ic = ({
  widgetId: e,
  opportunities: t,
  isLoading: n = !1,
  error: r,
  onOpportunityClick: i,
  headerText: l,
  showHeader: c = !0,
  emptyMessage: p = "No reward opportunities available",
  className: d,
  children: h
}) => {
  const { state: m } = te(
    e,
    Ql,
    []
    // No edit fields for now
  );
  if (h)
    return /* @__PURE__ */ o($, { children: h(m, t) });
  if (n)
    return /* @__PURE__ */ o(
      "div",
      {
        className: d,
        style: {
          maxWidth: m.maxWidth,
          padding: `${m.paddingY}px ${m.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: m.emptyTextFontSize, color: m.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (r)
    return /* @__PURE__ */ o(
      "div",
      {
        className: d,
        style: {
          maxWidth: m.maxWidth,
          padding: `${m.paddingY}px ${m.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: m.emptyTextFontSize, color: "#ef4444" }, children: r })
      }
    );
  if (t.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: d,
        style: {
          maxWidth: m.maxWidth,
          padding: `${m.paddingY}px ${m.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ o(Jl, { size: m.emptyIconSize, color: m.emptyTextColor }),
          /* @__PURE__ */ o("div", { style: { fontSize: m.emptyTextFontSize, color: m.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const b = t.reduce((z, C) => z + C.rewardAmount, 0), B = l || `${t.length} Reward Opportunity${t.length !== 1 ? "s" : ""} (${nr(b)} potential)`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: d,
      style: {
        maxWidth: m.maxWidth,
        padding: `${m.paddingY}px ${m.paddingX}px`,
        backgroundColor: m.backgroundColor,
        borderRadius: m.borderRadius
      },
      children: [
        c && /* @__PURE__ */ o(
          "h3",
          {
            style: {
              fontSize: m.headerFontSize,
              fontWeight: Dt(m.headerFontWeight),
              color: m.headerColor,
              marginBottom: m.headerMarginBottom,
              margin: 0,
              marginBlockEnd: m.headerMarginBottom
            },
            children: B
          }
        ),
        /* @__PURE__ */ o("div", { style: { display: "flex", flexDirection: "column", gap: m.cardGap }, children: t.map((z) => /* @__PURE__ */ o(
          Ul,
          {
            opportunity: z,
            state: m,
            onClick: i ? () => i(z) : void 0
          },
          z.id || z.campaignId || `${z.type}-${z.title}`
        )) })
      ]
    }
  );
}, _l = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Vl = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, an = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: pe
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], ac = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  excludeEditFields: r
}) => {
  const i = r ? an.filter((v) => !r.includes(v.key)) : an, {
    state: l,
    isLoading: c,
    isSaving: p,
    handleEditChange: d,
    handleSave: h,
    themeColors: m,
    themeFonts: b,
    resolveColor: B,
    canSave: z
  } = te(
    t,
    { ...Vl, ...e },
    i
  ), C = l.fontFamily, x = C && C !== "inherit" ? b[C] : null, f = x && x.format === "google" ? x.url : null;
  if (Q(() => {
    f && _l(f);
  }, [f]), c)
    return /* @__PURE__ */ o($, {});
  const S = (v) => {
    const k = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, M = parseInt(v, 10);
    return isNaN(M) ? k[v] || 500 : M;
  }, F = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", g = `textbox-${t || "default"}`, y = `
    ${x && x.format !== "system" && x.format !== "google" ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${F !== "inherit" ? `.${g} { font-family: ${F} !important; }` : ""}
  `.trim(), I = /* @__PURE__ */ u($, { children: [
    y && /* @__PURE__ */ o("style", { children: y }),
    /* @__PURE__ */ o(
      "span",
      {
        className: `textbox-content ${g}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...F === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${l.fontSize}px`,
          fontWeight: S(l.fontWeight),
          color: B(l.color),
          textAlign: l.textAlign,
          lineHeight: l.lineHeight,
          letterSpacing: `${l.letterSpacing}px`,
          textTransform: l.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: l.content
      }
    )
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: i,
      editValues: l,
      onEditChange: d,
      onSave: z ? h : void 0,
      isSaving: p,
      themeColors: m,
      themeFonts: b,
      children: I
    }
  );
}, ln = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, ql = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: K("rgba(236, 121, 46, 0.3)"),
  instantTextColor: K("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: K("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: K("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: K("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: K("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: K("rgba(162, 34, 114, 0.3)"),
  contentTextColor: K("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: a("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, sn = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...pe]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], lc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    themeFonts: m,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...ql, ...e },
    sn
  ), z = i.pillFontFamily, C = z && z !== "inherit" ? m[z] : null, x = i.subfixFontFamily, f = x && x !== "inherit" ? m[x] : null, S = C && C.format === "google" ? C.url : null, F = f && f.format === "google" ? f.url : null;
  if (Q(() => {
    S && ln(S);
  }, [S]), Q(() => {
    F && ln(F);
  }, [F]), l)
    return /* @__PURE__ */ o($, {});
  const g = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", N = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", y = C && C.format !== "system" && C.format !== "google", I = f && f.format !== "system" && f.format !== "google", v = `reward-pill-${t || "default"}`, k = `
    ${y ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${g !== "inherit" ? `.${v} [data-pill-text] { font-family: ${g} !important; }` : ""}
    ${N !== "inherit" ? `.${v} [data-subfix-text] { font-family: ${N} !important; }` : ""}
  `.trim(), M = {
    ...i,
    pillFontFamilyCss: g,
    subfixFontFamilyCss: N
  }, H = /* @__PURE__ */ u($, { children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(M, b)
  ] });
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: sn,
      editValues: i,
      onEditChange: p,
      onSave: B ? d : void 0,
      isSaving: c,
      themeColors: h,
      themeFonts: m,
      children: H
    }
  );
}, Kl = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: a("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, cn = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...pe]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], sc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: l,
    isSaving: c,
    handleEditChange: p,
    handleSave: d,
    themeColors: h,
    resolveColor: m,
    canSave: b
  } = te(
    t,
    { ...Kl, ...e },
    cn
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const B = r(i, m);
  return /* @__PURE__ */ o(
    Z,
    {
      widgetId: t,
      displayName: n,
      editFields: cn,
      editValues: i,
      onEditChange: p,
      onSave: b ? d : void 0,
      isSaving: c,
      themeColors: h,
      children: B
    }
  );
}, es = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, A = (e) => e.map((t) => ({
  weight: t,
  label: es[t] || `Weight ${t}`
})), st = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: A([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: A([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: A([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: A([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: A([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: A([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: A([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: A([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: A([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: A([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: A([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: A([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: A([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: A([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: A([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: A([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: A([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: A([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: A([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: A([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: A([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: A([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: A([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: A([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: A([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: A([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: A([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: A([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: A([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: A([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: A([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: A([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: A([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: A([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: A([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: A([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: A([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: A([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: A([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: A([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: A([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: A([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: A([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: A([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: A([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: A([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: A([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: A([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: A([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: A([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: A([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: A([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: A([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: A([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: A([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: A([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: A([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: A([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: A([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: A([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: A([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: A([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: A([400, 500, 700])
  }
], ts = (e, t = [500]) => {
  const n = e.replace(/ /g, "+"), r = t.join(";");
  return `https://fonts.googleapis.com/css2?family=${n}:wght@${r}&display=swap`;
}, os = (e) => `https://fonts.googleapis.com/css2?${e.map((n) => {
  const r = n.name.replace(/ /g, "+"), i = n.weights.join(";");
  return `family=${r}:wght@${i}`;
}).join("&")}&display=swap`, ns = (e) => {
  const t = st.find(
    (n) => n.name.toLowerCase() === e.toLowerCase()
  );
  return (t == null ? void 0 : t.variants) || [{ weight: 500, label: "Medium" }];
};
let at = null;
const rr = () => at || (at = new Promise((e) => {
  const t = st.map((i) => ({
    name: i.name,
    weights: [400, 500]
  })), n = os(t), r = document.createElement("link");
  r.href = n, r.rel = "stylesheet", r.onload = () => {
    e();
  }, r.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(r);
}), at), rs = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, dn = (e) => {
  const t = rs(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, Ae = (e, t, n) => {
  var i;
  const r = {
    type: Gn,
    payload: { updateType: t, themeId: n }
  };
  (i = e == null ? void 0 : e.current) != null && i.contentWindow ? e.current.contentWindow.postMessage(
    r,
    window.location.origin
  ) : window.postMessage(r, window.location.origin);
}, is = (e) => {
  var n;
  switch ((n = e.split(".").pop()) == null ? void 0 : n.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, as = ({
  themeId: e,
  editThemeToken: t,
  iframeRef: n,
  refreshThemeColors: r,
  refreshThemeFonts: i,
  refreshThemeIcons: l
}) => {
  const [c, p] = O(!1), [d, h] = O(null), [m, b] = O(null), [B, z] = O(!1), [C, x] = O(""), [f, S] = O("#000000ff"), [F, g] = O(
    null
  ), N = async () => {
    if (!C.trim()) {
      h("Color name is required");
      return;
    }
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    p(!0), h(null), b(null);
    try {
      await yo({
        themeId: e,
        colorKey: C.trim(),
        colorValue: dn(f),
        editThemeToken: t
      }), await r(), Ae(n, "colors", e), x(""), S("#000000ff"), z(!1), b("Color added successfully"), setTimeout(() => b(null), 2e3);
    } catch (T) {
      h(T.message || "Failed to add color");
    } finally {
      p(!1);
    }
  }, y = async (T, R) => {
    if (!(!t || !e)) {
      p(!0), h(null), b(null);
      try {
        await yo({
          themeId: e,
          colorKey: T,
          colorValue: dn(R),
          editThemeToken: t
        }), await r(), Ae(n, "colors", e), b("Color updated successfully"), setTimeout(() => b(null), 2e3);
      } catch (j) {
        h(j.message || "Failed to update color");
      } finally {
        p(!1);
      }
    }
  }, I = async (T, R) => {
    if (!(!t || !e)) {
      if (!R.trim()) {
        h("Color name is required");
        return;
      }
      if (T !== R.trim()) {
        p(!0), h(null), b(null);
        try {
          await ta({
            themeId: e,
            oldColorKey: T,
            newColorKey: R.trim(),
            editThemeToken: t
          }), await r(), Ae(n, "colors", e), b("Color renamed successfully"), setTimeout(() => b(null), 2e3);
        } catch (j) {
          h(j.message || "Failed to rename color");
        } finally {
          p(!1);
        }
      }
    }
  }, v = (T) => {
    !t || !e || g({ type: "color", key: T });
  }, k = async (T) => {
    if (!(!t || !e)) {
      p(!0), h(null), b(null);
      try {
        await ea({
          themeId: e,
          colorKey: T,
          editThemeToken: t
        }), await r(), Ae(n, "colors", e), b("Color deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete color");
      } finally {
        p(!1);
      }
    }
  }, M = async (T) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    p(!0), h(null), b(null);
    try {
      let R, j;
      switch (T.type) {
        case "system":
          R = T.value || T.name, j = "system";
          break;
        case "google":
          const G = ns(T.name).map((J) => J.weight);
          G.includes(800) || G.push(800), G.includes(900) || G.push(900), R = ts(T.name, G), j = "google";
          break;
        case "upload":
          if (!T.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: Y, objectPublicUrl: _ } = await bo({
            themeId: e,
            fileName: T.file.name,
            contentType: T.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: t
          });
          await fo({
            file: T.file,
            signedUploadUrl: Y
          }), R = _, j = is(T.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await oa({
        themeId: e,
        fontKey: T.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: T.name,
          url: R,
          format: j
        },
        editThemeToken: t
      }), await i(), Ae(n, "fonts", e), b("Font added successfully"), setTimeout(() => b(null), 2e3);
    } catch (R) {
      h(R.message || "Failed to add font");
    } finally {
      p(!1);
    }
  }, H = (T) => {
    !t || !e || g({ type: "font", key: T });
  }, P = async (T) => {
    if (!(!t || !e)) {
      p(!0), h(null), b(null);
      try {
        await na({
          themeId: e,
          fontKey: T,
          editThemeToken: t
        }), await i(), Ae(n, "fonts", e), b("Font deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete font");
      } finally {
        p(!1);
      }
    }
  }, W = async (T) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    p(!0), h(null), b(null);
    try {
      let R;
      switch (T.type) {
        case "lucide":
          if (R = T.url || "", !R)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!T.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: j, objectPublicUrl: L } = await bo({
            themeId: e,
            fileName: T.file.name,
            contentType: T.file.type || (T.file.name.endsWith(".svg") ? "image/svg+xml" : "application/octet-stream"),
            assetType: "icon",
            editThemeToken: t
          });
          await fo({
            file: T.file,
            signedUploadUrl: j
          }), R = L;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await ra({
        themeId: e,
        iconKey: T.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: T.name,
          url: R
        },
        editThemeToken: t
      }), await l(), Ae(n, "icons", e), b("Icon added successfully"), setTimeout(() => b(null), 2e3);
    } catch (R) {
      h(R.message || "Failed to add icon");
    } finally {
      p(!1);
    }
  }, w = (T) => {
    !t || !e || g({ type: "icon", key: T });
  }, E = async (T) => {
    if (!(!t || !e)) {
      p(!0), h(null), b(null);
      try {
        await ia({
          themeId: e,
          iconKey: T,
          editThemeToken: t
        }), await l(), Ae(n, "icons", e), b("Icon deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete icon");
      } finally {
        p(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: c,
    error: d,
    successMessage: m,
    // Color state
    isAddingColor: B,
    setIsAddingColor: z,
    newColorKey: C,
    setNewColorKey: x,
    newColorValue: f,
    setNewColorValue: S,
    // Color Handlers
    handleAddColor: N,
    handleUpdateColor: y,
    handleRenameColor: I,
    handleDeleteColor: v,
    // Font Handlers
    handleAddFont: M,
    handleDeleteFont: H,
    // Icon Handlers
    handleAddIcon: W,
    handleDeleteIcon: w,
    // Delete confirmation
    pendingDelete: F,
    confirmDelete: async () => {
      if (!F) return;
      const { type: T, key: R } = F;
      switch (g(null), T) {
        case "color":
          await k(R);
          break;
        case "font":
          await P(R);
          break;
        case "icon":
          await E(R);
          break;
      }
    },
    cancelDelete: () => {
      g(null);
    }
  };
}, pn = ({
  onClose: e,
  successMessage: t,
  error: n,
  children: r
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ o("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ o(
      oe,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ o(We, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-content", children: [
    t && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ o(kr, { size: 14 }),
      " ",
      t
    ] }),
    n && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ o(wr, { size: 14 }),
      " ",
      n
    ] }),
    r
  ] })
] }), gn = ({
  themeFonts: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  onDeleteFont: i,
  onOpenFontPicker: l,
  studioLockedFontKeys: c
}) => {
  const [p, d] = O(!1);
  Q(() => {
    t && !p && rr().then(() => d(!0));
  }, [t, p]);
  const h = (m) => {
    switch (m) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return m;
    }
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ o(
        dt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([m, b]) => {
        const B = (c == null ? void 0 : c.has(m)) ?? !1;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row bc-font-row", children: [
          /* @__PURE__ */ o(
            "span",
            {
              className: "bc-font-preview-name",
              style: {
                fontFamily: p ? `'${b.name}', sans-serif` : "inherit"
              },
              children: b.name
            }
          ),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-asset-format", children: B ? "Concierge Studio" : h(b.format) }),
          B ? /* @__PURE__ */ o(
            "span",
            {
              title: "Edit this font from Concierge Studio",
              style: {
                display: "inline-flex",
                alignItems: "center",
                color: s.blue,
                padding: "4px",
                cursor: "help"
              },
              children: /* @__PURE__ */ o(Gt, { size: 14 })
            }
          ) : /* @__PURE__ */ o(
            "button",
            {
              className: "bc-theme-editor-delete-btn",
              onClick: () => i(m),
              disabled: r,
              "aria-label": "Delete font",
              children: /* @__PURE__ */ o(We, { size: 16 })
            }
          )
        ] }, m);
      }),
      /* @__PURE__ */ o(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ o($t, { size: 12 }),
          onClick: l,
          disabled: r,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, mn = ({
  themeIcons: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  onDeleteIcon: i,
  onOpenIconPicker: l
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
    /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
      "Images and Icons",
      /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ o(
      dt,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
      }
    )
  ] }),
  t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([c, p]) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ o("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ o("img", { src: p.url, alt: p.name }) }),
      /* @__PURE__ */ o(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: p.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ o(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => i(c),
          disabled: r,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ o(We, { size: 16 })
        }
      )
    ] }, c)),
    /* @__PURE__ */ o(
      oe,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ o($t, { size: 12 }),
        onClick: l,
        disabled: r,
        children: "Add Image"
      }
    )
  ] }) })
] }), un = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], ls = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${s.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${s.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${s.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${s.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${s.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${s.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${s.primary};
    background: ${s.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${s.blue};
    background: ${s.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${s.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${s.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${s.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${s.primary};
  }

  .font-picker-tab.active {
    color: ${s.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${s.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${s.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${s.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${s.border_glass};
  }

  .font-picker-item:hover {
    background: ${s.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${s.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${s.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${s.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${s.bg_light};
    border-bottom: 1px solid ${s.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${s.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${s.primary};
    background: ${s.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${s.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${s.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${s.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${s.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${s.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${s.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${s.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${s.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${s.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${s.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${s.primary};
    background: ${s.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${s.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${s.border_glass};
    background: ${s.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, hn = ({
  isOpen: e,
  onClose: t,
  onSelect: n,
  isLoading: r = !1
}) => {
  const [i, l] = O("system"), [c, p] = O(""), [d, h] = O(null), [m, b] = O(null), [B, z] = O(""), C = le(null), [x, f] = O(!1);
  Q(() => {
    e && (p(""), h(null), b(null), z(""));
  }, [e]), Q(() => {
    i === "google" && !x && rr().then(() => {
      f(!0);
    });
  }, [i, x]);
  const S = de(() => {
    if (!c) return un;
    const w = c.toLowerCase();
    return un.filter(
      (E) => E.name.toLowerCase().includes(w) || E.category.toLowerCase().includes(w)
    );
  }, [c]), F = de(() => {
    if (!c) return st;
    const w = c.toLowerCase();
    return st.filter(
      (E) => E.name.toLowerCase().includes(w) || E.category.toLowerCase().includes(w)
    );
  }, [c]), g = (w) => {
    h({
      type: "system",
      name: w.name,
      value: w.value
    });
  }, N = (w) => {
    h({
      type: "google",
      name: w.name
    });
  }, y = (w) => {
    var D;
    const E = (D = w.target.files) == null ? void 0 : D[0];
    if (E) {
      b(E);
      const X = E.name.replace(/\.[^/.]+$/, "");
      z(X), h({
        type: "upload",
        name: X,
        file: E,
        format: I(E.name)
      });
    }
  }, I = (w) => {
    var D;
    switch ((D = w.split(".").pop()) == null ? void 0 : D.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, v = (w) => {
    z(w), (d == null ? void 0 : d.type) === "upload" && m && h({
      ...d,
      name: w
    });
  }, k = () => {
    d && (n(d), t());
  }, M = r || !d || d.type === "upload" && (!m || !B.trim()), H = de(() => {
    const w = {};
    return F.forEach((E) => {
      w[E.category] || (w[E.category] = []), w[E.category].push(E);
    }), w;
  }, [F]), P = de(() => {
    const w = {};
    return S.forEach((E) => {
      w[E.category] || (w[E.category] = []), w[E.category].push(E);
    }), w;
  }, [S]);
  if (!e) return null;
  const W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: ls() }),
    /* @__PURE__ */ o("div", { className: "font-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "font-picker-modal", onClick: (w) => w.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ o("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ o(We, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ o(pt, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: c,
            onChange: (w) => p(w.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "system" ? "active" : ""}`,
            onClick: () => l("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "google" ? "active" : ""}`,
            onClick: () => l("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-content", children: [
        i === "system" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(P).map(
            ([w, E]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ o("h4", { className: "font-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
              E.map((D) => /* @__PURE__ */ u(
                "div",
                {
                  className: `font-picker-item ${(d == null ? void 0 : d.type) === "system" && (d == null ? void 0 : d.name) === D.name ? "selected" : ""}`,
                  onClick: () => g(D),
                  children: [
                    /* @__PURE__ */ o(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: D.value },
                        children: D.name
                      }
                    ),
                    (d == null ? void 0 : d.type) === "system" && (d == null ? void 0 : d.name) === D.name && /* @__PURE__ */ o(Ke, { size: 16, className: "font-picker-check" })
                  ]
                },
                D.name
              ))
            ] }, w)
          )
        ] }),
        i === "google" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(H).map(
            ([w, E]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ o("h4", { className: "font-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
              E.map((D) => {
                const X = (d == null ? void 0 : d.type) === "google" && (d == null ? void 0 : d.name) === D.name;
                return /* @__PURE__ */ o("div", { children: /* @__PURE__ */ u(
                  "div",
                  {
                    className: `font-picker-item ${X ? "selected" : ""}`,
                    onClick: () => N(D),
                    children: [
                      /* @__PURE__ */ o(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: x ? `'${D.name}', sans-serif` : "inherit"
                          },
                          children: D.name
                        }
                      ),
                      X && /* @__PURE__ */ o(
                        Ke,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, D.name);
              })
            ] }, w)
          )
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ o(
            "input",
            {
              ref: C,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: y,
              style: { display: "none" }
            }
          ),
          m ? /* @__PURE__ */ u("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ o("span", { className: "font-picker-upload-filename", children: m.name }),
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var w;
                    return (w = C.current) == null ? void 0 : w.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ o("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: B,
                  onChange: (w) => v(w.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var w;
                return (w = C.current) == null ? void 0 : w.click();
              },
              children: [
                /* @__PURE__ */ o(Bn, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ o("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ o("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ o(oe, { variant: "outline", onClick: t, disabled: r, children: "Cancel" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            onClick: k,
            disabled: M,
            children: r ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Re.createPortal(W, gt());
}, yn = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], ct = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], bn = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, ss = (e) => {
  const t = e.toLowerCase().trim();
  return t ? ct.filter(
    (n) => n.name.toLowerCase().includes(t) || n.tags.some((r) => r.toLowerCase().includes(t)) || n.category.toLowerCase().includes(t)
  ) : ct;
}, fn = (e) => ct.filter((t) => t.category === e), cs = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${s.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${s.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${s.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${s.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${s.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${s.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${s.primary};
    background: ${s.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${s.blue};
    background: ${s.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${s.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${s.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${s.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${s.primary};
  }

  .icon-picker-tab.active {
    color: ${s.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${s.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${s.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${s.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${s.border_glass};
    border-radius: 20px;
    background: ${s.white};
    font-size: 12px;
    font-weight: 500;
    color: ${s.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${s.blue};
    color: ${s.blue};
  }

  .icon-picker-category-btn.active {
    background: ${s.primary};
    border-color: ${s.primary};
    color: ${s.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${s.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${s.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${s.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${s.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${s.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${s.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${s.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${s.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${s.bg_light};
    border-top: 1px solid ${s.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${s.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${s.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${s.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${s.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${s.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${s.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${s.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-image-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-image-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-image-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${s.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${s.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${s.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${s.primary};
    background: ${s.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${s.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${s.border_glass};
    background: ${s.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, xn = ({
  isOpen: e,
  onClose: t,
  onSelect: n,
  isLoading: r = !1
}) => {
  const [i, l] = O("upload"), [c, p] = O(""), [d, h] = O(null), [m, b] = O("all"), [B, z] = O(null), [C, x] = O(""), [f, S] = O(null), [F, g] = O(null), N = le(null);
  Q(() => {
    e && (l("upload"), p(""), h(null), b("all"), z(null), x(""), S(null), g(null));
  }, [e]);
  const y = de(() => {
    let w;
    return c ? w = ss(c) : m === "all" ? w = ct : w = fn(m), w;
  }, [c, m]), I = de(() => {
    if (c || m !== "all")
      return {
        [m === "all" ? "results" : m]: y
      };
    const w = {};
    return yn.forEach((E) => {
      w[E] = fn(E);
    }), w;
  }, [y, c, m]), v = (w) => {
    h({
      type: "lucide",
      name: w.name,
      url: bn(w.name)
    });
  }, k = async (w) => {
    var D;
    const E = (D = w.target.files) == null ? void 0 : D[0];
    if (E) {
      z(E);
      const X = E.name.replace(/\.[^/.]+$/, "");
      if (x(X), F && (URL.revokeObjectURL(F), g(null)), S(null), E.type === "image/svg+xml" || E.name.endsWith(".svg")) {
        const R = new FileReader();
        R.onload = (j) => {
          var L;
          S((L = j.target) == null ? void 0 : L.result);
        }, R.readAsText(E);
      } else
        g(URL.createObjectURL(E));
      h({
        type: "upload",
        name: X,
        file: E
      });
    }
  }, M = (w) => {
    x(w), (d == null ? void 0 : d.type) === "upload" && B && h({
      ...d,
      name: w
    });
  }, H = () => {
    d && (n(d), t());
  }, P = r || !d || d.type === "upload" && (!B || !C.trim());
  if (!e) return null;
  const W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: cs() }),
    /* @__PURE__ */ o("div", { className: "icon-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "icon-picker-modal", onClick: (w) => w.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ o("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ o(We, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ o(pt, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: c,
            onChange: (w) => p(w.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ o(
          "button",
          {
            className: `icon-picker-tab ${i === "lucide" ? "active" : ""}`,
            onClick: () => l("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `icon-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload Image"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-content", children: [
        i === "lucide" && /* @__PURE__ */ u($, { children: [
          /* @__PURE__ */ u("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ o(
              "button",
              {
                className: `icon-picker-category-btn ${m === "all" ? "active" : ""}`,
                onClick: () => b("all"),
                children: "All"
              }
            ),
            yn.map((w) => /* @__PURE__ */ o(
              "button",
              {
                className: `icon-picker-category-btn ${m === w ? "active" : ""}`,
                onClick: () => b(w),
                children: w.charAt(0).toUpperCase() + w.slice(1)
              },
              w
            ))
          ] }),
          /* @__PURE__ */ u("div", { className: "icon-picker-icons-container", children: [
            Object.entries(I).map(([w, E]) => /* @__PURE__ */ u(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !c && m === "all" && /* @__PURE__ */ o("h4", { className: "icon-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
                  /* @__PURE__ */ o("div", { className: "icon-picker-grid", children: E.map((D) => /* @__PURE__ */ u(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(d == null ? void 0 : d.type) === "lucide" && (d == null ? void 0 : d.name) === D.name ? "selected" : ""}`,
                      onClick: () => v(D),
                      title: D.name,
                      children: [
                        /* @__PURE__ */ o(
                          "img",
                          {
                            src: bn(D.name),
                            alt: D.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (d == null ? void 0 : d.type) === "lucide" && (d == null ? void 0 : d.name) === D.name && /* @__PURE__ */ o("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ o(Ke, { size: 12 }) })
                      ]
                    },
                    D.name
                  )) })
                ]
              },
              w
            )),
            y.length === 0 && /* @__PURE__ */ o("div", { className: "icon-picker-empty", children: /* @__PURE__ */ u("p", { children: [
              'No icons found for "',
              c,
              '"'
            ] }) })
          ] }),
          (d == null ? void 0 : d.type) === "lucide" && /* @__PURE__ */ u("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ o(
              "img",
              {
                src: d.url,
                alt: d.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ o("span", { className: "icon-picker-selected-name", children: d.name })
          ] })
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ o("p", { className: "icon-picker-description", children: "Upload your own image or icon file." }),
          /* @__PURE__ */ o(
            "input",
            {
              ref: N,
              type: "file",
              accept: ".png,.jpg,.jpeg,.gif,.webp,.svg,image/*",
              onChange: k,
              style: { display: "none" }
            }
          ),
          B ? /* @__PURE__ */ u("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-file", children: [
              f && /* @__PURE__ */ o(
                "div",
                {
                  className: "icon-picker-image-preview",
                  dangerouslySetInnerHTML: { __html: f }
                }
              ),
              F && /* @__PURE__ */ o("div", { className: "icon-picker-image-preview", children: /* @__PURE__ */ o("img", { src: F, alt: C }) }),
              /* @__PURE__ */ u("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-filename", children: B.name }),
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var w;
                      return (w = N.current) == null ? void 0 : w.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ o("label", { className: "icon-picker-upload-label", children: "Image name" }),
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: C,
                  onChange: (w) => M(w.target.value),
                  placeholder: "Enter image name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var w;
                return (w = N.current) == null ? void 0 : w.click();
              },
              children: [
                /* @__PURE__ */ o(Bn, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-text", children: "Click to upload image" }),
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-hint", children: "PNG, JPG, GIF, WEBP, SVG" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ o(oe, { variant: "outline", onClick: t, disabled: r, children: "Cancel" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            onClick: H,
            disabled: P,
            children: r ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Re.createPortal(W, gt());
}, cc = () => {
  const e = $e(), t = In(), [n, r] = O("checking"), [i, l] = O("desktop"), c = le(null), [p, d] = O(!1), { data: h } = ze(), m = (h == null ? void 0 : h.themeName) || e.themeId, { themeColors: b, refreshThemeColors: B } = Jt(), { themeFonts: z, refreshThemeFonts: C } = $n(), { themeIcons: x, refreshThemeIcons: f } = Yn(), { data: S } = ze(), F = de(() => {
    var R;
    const T = (R = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : R.colors;
    return T != null && T.length ? new Set(T) : void 0;
  }, [S]), g = de(() => {
    var R;
    const T = (R = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : R.fonts;
    return T != null && T.length ? new Set(T) : void 0;
  }, [S]), [N, y] = O(null), [I, v] = O(!1), [k, M] = O(!1), H = (T) => {
    y((R) => R === T ? null : T);
  }, P = as({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: n === "iframe" ? c : null,
    refreshThemeColors: B,
    refreshThemeFonts: C,
    refreshThemeIcons: f
  });
  Q(() => {
    t || Di();
  }, [t]), Q(() => Ei(() => {
    M(!0);
  }), []), Q(() => {
    if (t || !e.themeId) return;
    (async () => {
      const R = await Zr();
      r(R ? "iframe" : "inline");
    })();
  }, [t, e.themeId]), Q(() => {
    if (t || e.previewMode || !e.themeId || !e.editThemeToken) return;
    let T = !1;
    return Ki({
      themeId: e.themeId,
      editThemeToken: e.editThemeToken
    }).then((R) => {
      T || R || (ft(), xt(), window.location.reload());
    }), () => {
      T = !0;
    };
  }, [t, e.themeId, e.editThemeToken, e.previewMode, e.origin]);
  const W = ge(() => {
    var T;
    if (c.current)
      try {
        const R = new URL(
          ((T = c.current.contentWindow) == null ? void 0 : T.location.href) || ""
        ), j = new URL(window.location.href);
        j.pathname = R.pathname;
        const L = new URLSearchParams(R.search), G = new URLSearchParams();
        e.themeId && G.set("themeId", e.themeId), e.editMode && G.set("editMode", "true"), e.editThemeToken && G.set("editThemeToken", e.editThemeToken), L.forEach((Y, _) => {
          _ !== "frameMode" && _ !== "themeId" && _ !== "editMode" && _ !== "editThemeToken" && G.set(_, Y);
        }), j.search = G.toString(), window.history.replaceState({}, "", j.toString());
      } catch (R) {
        console.debug("Could not access iframe URL (cross-origin):", R);
      }
  }, [e]);
  if (!e.themeId || t)
    return null;
  if (e.previewMode) {
    const T = () => {
      ft(), xt();
      const R = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
      window.location.href = R;
    };
    return /* @__PURE__ */ u($, { children: [
      /* @__PURE__ */ o("style", { children: `
          body { padding-top: 60px !important; }
        ` }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: 60,
            background: "#f5f5f7",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            gap: 16,
            zIndex: 1000001,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          },
          children: [
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ o(Pr, { size: 18, color: "white" })
                }
              ),
              /* @__PURE__ */ o("span", { style: { fontWeight: 600, fontSize: 15, color: "#1a1a2e" }, children: "Theme Preview" })
            ] }),
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ o("span", { style: { fontSize: 12, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px" }, children: "Theme:" }),
              /* @__PURE__ */ o("span", { style: { fontSize: 14, fontWeight: 500, color: "#1a1a2e" }, children: m }),
              (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u(
                "span",
                {
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#22c55e",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  },
                  children: [
                    /* @__PURE__ */ o(
                      "span",
                      {
                        style: {
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#22c55e"
                        }
                      }
                    ),
                    "Live"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { style: { flex: 1 } }),
            /* @__PURE__ */ o(
              oe,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: /* @__PURE__ */ o(bt, { size: 14 }),
                onClick: T,
                children: "Exit Preview"
              }
            )
          ]
        }
      )
    ] });
  }
  if (n === "checking")
    return /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ o(Tr, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ o("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ o("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const w = () => {
    ft(), xt();
    const T = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = T;
  }, E = () => {
    d(!p);
  }, D = async (T) => {
    await P.handleAddFont(T);
  }, X = async (T) => {
    await P.handleAddIcon(T);
  };
  return n === "inline" ? /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: Io({ showSettings: p, viewMode: i, editorMode: n }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ o("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ o(eo, { size: 18 }) }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-id", children: m }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ o("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ o(Bt, { size: 14 }),
              onClick: E,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ o(bt, { size: 14 }),
              onClick: w,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      p && /* @__PURE__ */ u(
        pn,
        {
          onClose: () => d(!1),
          successMessage: P.successMessage,
          error: P.error,
          children: [
            /* @__PURE__ */ o(
              ho,
              {
                themeColors: b,
                isExpanded: N === "colors",
                onToggle: () => H("colors"),
                isLoading: P.isLoading,
                isAddingColor: P.isAddingColor,
                setIsAddingColor: P.setIsAddingColor,
                newColorKey: P.newColorKey,
                setNewColorKey: P.setNewColorKey,
                newColorValue: P.newColorValue,
                setNewColorValue: P.setNewColorValue,
                onAddColor: P.handleAddColor,
                onUpdateColor: P.handleUpdateColor,
                onRenameColor: P.handleRenameColor,
                onDeleteColor: P.handleDeleteColor,
                studioLockedColorKeys: F
              }
            ),
            /* @__PURE__ */ o(
              gn,
              {
                themeFonts: z,
                isExpanded: N === "fonts",
                onToggle: () => H("fonts"),
                isLoading: P.isLoading,
                onDeleteFont: P.handleDeleteFont,
                onOpenFontPicker: () => v(!0),
                studioLockedFontKeys: g
              }
            ),
            /* @__PURE__ */ o(
              mn,
              {
                themeIcons: x,
                isExpanded: N === "icons",
                onToggle: () => H("icons"),
                isLoading: P.isLoading,
                onDeleteIcon: P.handleDeleteIcon,
                onOpenIconPicker: () => M(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ o(
        hn,
        {
          isOpen: I,
          onClose: () => v(!1),
          onSelect: D,
          isLoading: P.isLoading
        }
      ),
      /* @__PURE__ */ o(
        xn,
        {
          isOpen: k,
          onClose: () => M(!1),
          onSelect: X,
          isLoading: P.isLoading
        }
      ),
      P.pendingDelete && /* @__PURE__ */ o(
        et,
        {
          title: `Delete ${P.pendingDelete.type}`,
          message: `Are you sure you want to delete "${P.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: P.confirmDelete,
          onCancel: P.cancelDelete,
          isLoading: P.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: Io({ showSettings: p, viewMode: i, editorMode: n }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ o("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ o(eo, { size: 18 }) }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-id", children: m }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ o("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: i === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ o(kn, { size: 16 })
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: i === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ o(Sn, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ o(Bt, { size: 14 }),
              onClick: E,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ o(bt, { size: 14 }),
              onClick: w,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ o("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ o("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ o("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ o(
        "iframe",
        {
          ref: c,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: W,
          title: "Theme Preview"
        }
      ) }) }) }),
      p && /* @__PURE__ */ u(
        pn,
        {
          onClose: () => d(!1),
          successMessage: P.successMessage,
          error: P.error,
          children: [
            /* @__PURE__ */ o(
              ho,
              {
                themeColors: b,
                isExpanded: N === "colors",
                onToggle: () => H("colors"),
                isLoading: P.isLoading,
                isAddingColor: P.isAddingColor,
                setIsAddingColor: P.setIsAddingColor,
                newColorKey: P.newColorKey,
                setNewColorKey: P.setNewColorKey,
                newColorValue: P.newColorValue,
                setNewColorValue: P.setNewColorValue,
                onAddColor: P.handleAddColor,
                onUpdateColor: P.handleUpdateColor,
                onRenameColor: P.handleRenameColor,
                onDeleteColor: P.handleDeleteColor
              }
            ),
            /* @__PURE__ */ o(
              gn,
              {
                themeFonts: z,
                isExpanded: N === "fonts",
                onToggle: () => H("fonts"),
                isLoading: P.isLoading,
                onDeleteFont: P.handleDeleteFont,
                onOpenFontPicker: () => v(!0)
              }
            ),
            /* @__PURE__ */ o(
              mn,
              {
                themeIcons: x,
                isExpanded: N === "icons",
                onToggle: () => H("icons"),
                isLoading: P.isLoading,
                onDeleteIcon: P.handleDeleteIcon,
                onOpenIconPicker: () => M(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ o(
        hn,
        {
          isOpen: I,
          onClose: () => v(!1),
          onSelect: D,
          isLoading: P.isLoading
        }
      ),
      /* @__PURE__ */ o(
        xn,
        {
          isOpen: k,
          onClose: () => M(!1),
          onSelect: X,
          isLoading: P.isLoading
        }
      ),
      P.pendingDelete && /* @__PURE__ */ o(
        et,
        {
          title: `Delete ${P.pendingDelete.type}`,
          message: `Are you sure you want to delete "${P.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: P.confirmDelete,
          onCancel: P.cancelDelete,
          isLoading: P.isLoading
        }
      )
    ] })
  ] });
};
export {
  oe as Button,
  Zs as ChainOfThoughtWidget,
  Ws as ChatHistoryWidget,
  Ps as ChatInput,
  Qa as ConciergeContentSkeleton,
  Ls as ConciergeFullPageSkeleton,
  Ns as ConciergeHeaderWidget,
  qs as ConciergeHomeBrandLabelWidget,
  Ks as ConciergeHomeGreetingWidget,
  _s as ConciergeHomeLayoutWidget,
  Vs as ConciergeHomeLogoWidget,
  oc as ConciergeHomeMobileNavWidget,
  tc as ConciergeHomeStartersWidget,
  ec as ConciergeHomeSubtitleWidget,
  $s as ConciergePanelWidget,
  Kn as ConciergeSidebarSkeleton,
  Rs as ConciergeSidebarWidget,
  Qs as ConfirmActionDialogWidget,
  Ms as ConversationStartersWidget,
  Fs as ELEMENT_GROUPS,
  Nn as EditPanel,
  Ds as FloatingButtonWidget,
  As as FollowUpQueriesWidget,
  Hs as HeaderWidget,
  bl as LAYOUT_PRESETS,
  Js as LoginDialogWidget,
  zs as MessageBubbleWidget,
  Is as PANEL_CHAT_INPUT_PRESETS,
  fl as PRESET_LABELS,
  Us as PromptLoginWidget,
  sc as RetailerIconWidget,
  ic as RewardOpportunitiesWidget,
  lc as RewardPillWidget,
  Es as SearchPanelWidget,
  Xs as ShareConversationDialogWidget,
  Gs as SuggestionListWidget,
  rc as SurveyCard,
  nc as SurveysWidget,
  ac as TextBox,
  cc as ThemeManager,
  js as TrendingCardWidget,
  Ts as TypingIndicatorWidget,
  Ys as VariantPickerWidget,
  Le as WIDGET_THEME_QUERY_KEY,
  Os as WelcomeScreenWidget,
  Oi as WidgetEditSuppressProvider,
  vs as WidgetEditUnsuppressProvider,
  Z as WidgetWrapper,
  bs as calculateRewardPercent,
  ft as clearThemeParams,
  xt as clearUrlParams,
  s as colors,
  K as customColor,
  hl as defaultPromptLoginState,
  hs as formatDate,
  us as formatMoney,
  ys as formatRelativeTime,
  xs as getFontWeightValue,
  Wi as getThemeParams,
  Ii as isColorValue,
  Ri as saveThemeParams,
  fs as slugify,
  Di as syncUrlToStorage,
  a as themeColor,
  Cs as truncateText,
  ks as updateUrlParams,
  jn as updateWidgetConfig,
  Qt as useEditMode,
  Bs as useResolveColor,
  Ss as useStudioAgentName,
  ws as useStudioAvailability,
  Jt as useThemeColors,
  $n as useThemeFonts,
  Yn as useThemeIcons,
  la as useWidgetConfig,
  Ht as useWidgetEdit,
  ji as useWidgetEditSuppressed,
  te as useWidgetEditable,
  ze as useWidgetTheme,
  $e as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
